<template>
    <div id="content-area" style="display: flex;flex-direction: row-reverse;">
        <div class="button-flex">
            <div class="button-area1">
                <div class="button-box1" @click="handleDown()">打印</div>
            </div>
            <div class="button-area2">
                <div class="button-box2" @click="returnBack()">返回</div>
            </div>
        </div>
        <div class="demo-area">
            <div id="demo" :style="{ 'height': Dheight }">
                <div class="page-module" v-loading="loading" element-loading-text="加速生成中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="page-area">
                        <div class="top-area">
                            <div class="top-left-area">
                                <span class="top-left-area-title">中国基金公司量化数据报告 </span><span
                                    class="line-area">|</span><span class="top-left-area-date">
                                    {{ companyReportData.quarterStr }}</span>
                            </div>
                            <div class="top-right-area">
                                <div class="top-right-area-img"></div>
                            </div>
                        </div>

                        <div class="title-head-area">
                            <div class="title-head-left">
                                <div class="title-head-company-name">
                                    {{ companyData.companyNameCN }}
                                </div>
                                <div class="title-head-date">
                                    <span>成⽴时间：</span><span>{{ companyReportData.companyDate }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="content-main1-area">
                            <div class="content-main1-left">
                                <div class="content-left-box-area">
                                    <div class="content-left-top-area">
                                        <span class="teamImgClass" v-html="TDGLlogo" />
                                        <span class="desc-text1">管理团队</span>
                                    </div>
                                    <div class="content-left-bottom-area1">
                                        <div
                                            style="display: flex;flex: 1;justify-content: space-between;align-items: center;">
                                            <span style="font-weight: 600;font-size: 13px;color: black;">旗下基金经理统计</span>
                                            <span style="font-weight: 600;font-size: 13px;color: black;">排名</span>
                                        </div>
                                        <div
                                            style="display: flex;flex: 1;align-items: center;justify-content: space-between;">
                                            <span style="display: flex;flex: 1;font-weight: 545;font-size: 14px;"><span
                                                    style="display: flex;width: 140px;">人数</span></span>
                                            <span
                                                style="display: flex;flex: 1;font-weight: 400;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.managerCount
                                                        == "" ? "--" : companyData.managerCount }}</span>
                                            <span
                                                style="display: flex;flex: 1;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.managerCountRank
                                                        == "" ? "--" : companyData.managerCountRank }}<span
                                                    style="font-weight: 200;font-size: 15px;color: rgb(161 161 161);">{{
                                                        companyData.managerCountRank
                                                            == "" ? "" : "/" }}{{ companyData.managerCountRank == "" ?
                                                        "" : companyReportData.managerCountRankSize }}</span></span>
                                        </div>
                                        <div
                                            style="display: flex;flex: 1;align-items: center;justify-content: space-between;">
                                            <span style="display: flex;flex: 1;font-weight: 545;font-size: 14px;"><span
                                                    style="display: flex;width: 140px;">平均投管经验（年）</span></span>
                                            <span
                                                style="display: flex;flex: 1;font-weight: 400;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.managerCareerTime
                                                        == "" ?
                                                        "--" : parseFloat(companyData.managerCareerTime).toFixed(2) }}</span>
                                            <span
                                                style="display: flex;flex: 1;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.managerCareerTimeRank
                                                        == "" ? "--" : companyData.managerCareerTimeRank }}<span
                                                    style="font-weight: 200;font-size: 15px;color: rgb(161 161 161);">{{
                                                        companyData.managerCareerTimeRank
                                                            == "" ? "" : "/" }}{{ companyData.managerCareerTimeRank == "" ?
                                                        "" : companyReportData.managerCareerTimeRankSize }}</span></span>
                                        </div>
                                        <div
                                            style="display: flex;flex: 1;align-items: center;justify-content: space-between;">
                                            <span style="display: flex;flex: 1;font-weight: 545;font-size: 14px;"><span
                                                    style="display: flex;width: 140px;">平均在职时长（年）</span></span>
                                            <span
                                                style="display: flex;flex: 1;font-weight: 400;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.managerStayTime
                                                        == "" ? "--"
                                                        : parseFloat(companyData.managerStayTime).toFixed(2) }}</span>
                                            <span
                                                style="display: flex;flex: 1;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.managerStayTimeRank
                                                        == "" ? "--" : companyData.managerStayTimeRank }}<span
                                                    style="font-weight: 200;font-size: 15px;color: rgb(161 161 161);">{{
                                                        companyData.managerStayTimeRank
                                                            == "" ? "" : "/" }}{{ companyData.managerStayTimeRank == "" ?
                                                        "" : companyReportData.managerStayTimeRankSize }}</span></span>
                                        </div>
                                        <div
                                            style="display: flex;flex: 1;align-items: center;justify-content: space-between;">
                                            <span style="display: flex;flex: 1;font-weight: 545;font-size: 14px;"><span
                                                    style="display: flex;width: 140px;">最近三年留职率</span></span>
                                            <span
                                                style="display: flex;flex: 1;font-weight: 400;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.retention_3Y
                                                        == "" ?
                                                        "--" : parseFloat(companyData.retention_3Y).toFixed(2) + '%' }}</span>
                                            <span
                                                style="display: flex;flex: 1;font-size: 14px;color: black;justify-content: flex-end;">{{
                                                    companyData.retentionRank_3Y
                                                        == "" ? "--" : companyData.retentionRank_3Y }}<span
                                                    style="font-weight: 200;font-size: 15px;color: rgb(161 161 161);">{{
                                                        companyData.retentionRank_3Y
                                                            == "" ? "" : "/" }}{{ companyData.retentionRank_3Y == "" ?
                                                        "" : companyReportData.retentionRank3YSize }}</span></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="content-left-box-area">
                                    <div class="content-left-top-area">
                                        <span class="levelImgClass" v-html="MSlogo" />
                                        <span class="desc-text">综合评级</span>
                                    </div>
                                    <div class="content-left-bottom-area2">
                                        <div class="left-bottom-area1"
                                            v-if="starNumBlack == '1' || starNumBlack == '2' || starNumBlack == '3' || starNumBlack == '4' || starNumBlack == '5'">
                                            <span class="bottom-text" style="color: black;font-size: 13px;">
                                                排名
                                            </span>
                                        </div>
                                        <div v-else>
                                            <div class="null-node-area"
                                                style="margin-bottom: 0px;margin-top: 10px;align-self: end;">
                                                暂无信息
                                            </div>
                                        </div>
                                        <div class="left-bottom-area1" v-else></div>

                                        <div class="left-bottom-area2"
                                            v-if="starNumBlack == '1' || starNumBlack == '2' || starNumBlack == '3' || starNumBlack == '4' || starNumBlack == '5'">
                                            <span
                                                style="font-size: 13px;font-weight: 550;flex: 1;color: black;">加权星级</span>
                                            <div class="star-area">
                                                <div style="display: flex;" v-if="starNumBlack == '1'">
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                </div>
                                                <div style="display: flex;" v-if="starNumBlack == '2'">
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                </div>
                                                <div style="display: flex;" v-if="starNumBlack == '3'">
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                </div>
                                                <div style="display: flex;" v-if="starNumBlack == '4'">
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                </div>
                                                <div style="display: flex;" v-if="starNumBlack == '5'">
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                    <span class="companyStarClass" v-html="companyStar"></span>
                                                </div>

                                                <div style="display:flex;" v-show="showStarQuarter1">
                                                    <span class="companyStarMarkClass" v-html="companyStarMark"></span>
                                                </div>
                                                <div style="display:flex;" v-show="showStarQuarter2">
                                                    <span class="companyStarClass2" v-html="companyStar2"></span>
                                                </div>
                                                <div style="display:flex;" v-show="showStarQuarter4">
                                                    <span class="companyStarClass4" v-html="companyStar4"></span>
                                                </div>


                                                <div style="display:flex;" v-if="showNumWhite == '5'">
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                </div>
                                                <div style="display:flex;" v-if="showNumWhite == '4'">
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                </div>
                                                <div style="display:flex;" v-if="showNumWhite == '3'">
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                </div>
                                                <div style="display:flex;" v-if="showNumWhite == '2'">
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                </div>
                                                <div style="display:flex;" v-if="showNumWhite == '1'">
                                                    <span class="companyStarWhiteClass"
                                                        v-html="companyStarWhite"></span>
                                                </div>
                                            </div>
                                            <span style="font-size: 14px;flex: 1;color: black;">{{
                                                companyData.aumweightedStar
                                                    == "" ? "--" : companyData.aumweightedStar }}</span>
                                            <span style="font-size: 14px;color: black;">{{
                                                companyReportData.aumWeightStarRank
                                                    == "" ? "--" : companyReportData.aumWeightStarRank }}<span
                                                    style="font-weight: 200;font-size: 14px;color: rgb(161 161 161);">{{
                                                        companyReportData.aumWeightStarRank
                                                            == "" ? "" : "/" }}{{ companyReportData.aumWeightStarRank == "" ?
                                                        "" : companyReportData.aumWeightStarRankAll }}</span></span>
                                        </div>
                                        <div v-else class="left-bottom-area2"></div>

                                        <div style="display: flex;height: 120px;">
                                            <div class="left-bottom-area33"
                                                v-if="companyData.star5Per != '' || companyData.star4Per != '' || companyData.star3Per != '' || companyData.star2Per != '' || companyData.star1Per != ''">
                                                <div class="left-bottom-area33-box">
                                                    <div class="left-bottom-area33-box1"><span
                                                            style="margin-bottom: 3px;font-size: 10px;">规模占比</span>
                                                    </div>
                                                    <div class="left-bottom-area33-box2"><span
                                                            style="margin-top: 3px;font-size: 10px;">数量(只)</span></div>
                                                </div>
                                            </div>
                                            <div v-else class="left-bottom-area33"></div>

                                            <div class="left-bottom-area3"
                                                v-if="companyData.star5Per != '' || companyData.star4Per != '' || companyData.star3Per != '' || companyData.star2Per != '' || companyData.star1Per != ''">
                                                <div class="bottom-box1">
                                                    <div class="box-top">
                                                        <div class="black-box-area">
                                                            <div :style="{ 'height': height5 }"
                                                                :class="[companyData.star5Per == '' ? 'black-null' : 'black-box5']">
                                                            </div>
                                                            <span>{{ companyData.star5Per == "" ?
                                                                "--" : companyData.star5Per }}%</span>
                                                        </div>
                                                    </div>
                                                    <div class="box-bottom5">
                                                        <div class="star5"></div>
                                                    </div>
                                                    <div class="box-bottom-num">
                                                        {{ companyData.star5Count == "" ? "--" : companyData.star5Count
                                                        }}
                                                    </div>
                                                </div>
                                                <div class="bottom-space"></div>
                                                <div class="bottom-box1">
                                                    <div class="box-top">
                                                        <div class="black-box-area">
                                                            <div :style="{ 'height': height4 }"
                                                                :class="[companyData.star4Per == '' ? 'black-null' : 'black-box4']">
                                                            </div>
                                                            <span>{{ companyData.star4Per == "" ?
                                                                "--" : companyData.star4Per }}%</span>
                                                        </div>
                                                    </div>
                                                    <div class="box-bottom4">
                                                        <div class="star4"></div>
                                                    </div>
                                                    <div class="box-bottom-num">
                                                        {{ companyData.star4Count == "" ? "--" : companyData.star4Count
                                                        }}
                                                    </div>
                                                </div>
                                                <div class="bottom-space"></div>
                                                <div class="bottom-box1">
                                                    <div class="box-top">
                                                        <div class="black-box-area">
                                                            <div :style="{ 'height': height3 }"
                                                                :class="[companyData.star3Per == '' ? 'black-null' : 'black-box3']">
                                                            </div>
                                                            <span>{{ companyData.star3Per == "" ?
                                                                "--" : companyData.star3Per }}%</span>
                                                        </div>
                                                    </div>
                                                    <div class="box-bottom3">
                                                        <div class="star3"></div>
                                                    </div>
                                                    <div class="box-bottom-num">
                                                        {{ companyData.star3Count == "" ? "--" : companyData.star3Count
                                                        }}
                                                    </div>
                                                </div>
                                                <div class="bottom-space"></div>
                                                <div class="bottom-box1">
                                                    <div class="box-top">
                                                        <div class="black-box-area">
                                                            <div :style="{ 'height': height2 }"
                                                                :class="[companyData.star2Per == '' ? 'black-null' : 'black-box2']">
                                                            </div>
                                                            <span>{{ companyData.star2Per == "" ?
                                                                "--" : companyData.star2Per }}%</span>
                                                        </div>
                                                    </div>
                                                    <div class="box-bottom2">
                                                        <div class="star2"></div>
                                                    </div>
                                                    <div class="box-bottom-num">
                                                        {{ companyData.star2Count == "" ? "--" : companyData.star2Count
                                                        }}
                                                    </div>
                                                </div>
                                                <div class="bottom-space"></div>
                                                <div class="bottom-box1">
                                                    <div class="box-top">
                                                        <div class="black-box-area">
                                                            <div :style="{ 'height': height1 }"
                                                                :class="[companyData.star1Per == '' ? 'black-null' : 'black-box1']">
                                                            </div>
                                                            <span>{{ companyData.star1Per == "" ?
                                                                "--" : companyData.star1Per }}%</span>
                                                        </div>
                                                    </div>
                                                    <div class="box-bottom1">
                                                        <div class="star1"></div>
                                                    </div>
                                                    <div class="box-bottom-num">
                                                        {{ companyData.star1Count == "" ? "--" : companyData.star1Count
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="left-bottom-area3">
                                                <!-- <div class="null-node-area" style="margin-bottom: 0px;align-self: end;">
                                                        暂无信息
                                    </div>   -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content-main1-right">
                                <div class="content-desc-text">
                                    &#12288;&#12288;{{ companyReportData.shortName }}成立于{{
                                        companyReportData.companyEstablishDate }}年，
                                    <span v-show="cityShow">注册地位于{{ companyReportData.province }}{{
                                        companyReportData.city }}{{ gdShow || ywShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="gdShow">主要股东为{{ contentInfoData }} 。</span>
                                    <span v-show="ywShow">该公司<span v-show="tsShow">同时</span>拥有{{ attributeData
                                    }}等业务资格。</span><br />
                                    &#12288;&#12288;截止{{ companyReportData.latestDate }}，
                                    <span v-show="gmShow">公司管理公募基金（不含货币基金）规模为人民币{{ companyData.fundSize > 1 ?
                                        Math.abs(parseFloat(companyData.fundSize).toFixed(0)) : '不足1' }}亿元{{ zj3ytbShow
                                            ||
                                            cpxShow || zj3yrShow || zj3yShow || zj1ytbShow || zj1yrShow || zj1yShow ||
                                            gmrShow
                                        == true ? '，':'。'}}</span>
                                    <span v-show="gmrShow">在{{ companyReportData.fundSizeRankSize }}家公司中位列第{{
                                        companyData.fundSizeRank }}。</span>
                                    <span v-show="zj1yShow">最近一年资金{{ fundSize1YText }}{{
                                        Math.abs(parseFloat(companyData.fundSizeFlow_1Y).toFixed(0)) }}亿元{{ zj3ytbShow
                                            || cpxShow || zj3yrShow || zj3yShow || zj1ytbShow || zj1yrShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="zj1yrShow">排名{{ companyData.fundSizeFlowRank_1Y }}/{{
                                        companyReportData.fundSizeFlowRank1YSize }}{{ zj3ytbShow || cpxShow || zj3yrShow
                                            || zj3yShow || zj1ytbShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="zj1ytbShow">同比{{ raiseOrDown1Y }}{{
                                        Math.abs(companyData.fundSizeFlowPer_1Y) }}%{{ zj3ytbShow || cpxShow ||
                                            zj3yrShow || zj3yShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="zj3yShow">最近三年资金{{ fundSize3YText }}{{
                                        Math.abs(parseFloat(companyData.fundSizeFlow_3Y).toFixed(0)) }}亿元{{ zj3ytbShow
                                            || cpxShow || zj3yrShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="zj3yrShow">排名{{ companyData.fundSizeFlowRank_3Y }}/{{
                                        companyReportData.fundSizeFlowRank3YSize }}{{ zj3ytbShow || cpxShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="zj3ytbShow">同比{{ raiseOrDown3Y }}{{
                                        Math.abs(companyData.fundSizeFlowPer_3Y) }}%。</span><br />
                                    <span v-show="cpxShow">&#12288;&#12288;公司产品线覆盖{{ companyReportData.productionData
                                    }}类型。</span>
                                    截止{{ companyReportData.latestDate }}，
                                    <span v-show="zhpjShow">旗下基金规模加权后的晨星综合星级为{{ companyData.aumweightedStar }}{{
                                        zhpjbjShow || zhpjrShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="zhpjrShow">排名{{ companyReportData.aumWeightStarRank }}/{{
                                        companyReportData.aumWeightStarRankAll }}{{ zhpjbjShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="zhpjbjShow">较上一期{{ companyReportData.compareStarStr }} 。</span>

                                    <span v-show="zdcpShow">整体来看旗下主动管理产品业绩排名在{{ typeSum1 }}个综合类{{ companyData.sizeType
                                        == 1
                                        ? '大型' : (companyData.sizeType == 2 ?
                                            '中型' : '小型') }}公司中排名第{{ companyData.companyScoreRawRank }}{{ gscpShow || flShow ||
                                            pgcpShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="pgcpShow">偏股型主动管理业绩评分在{{ typeSum2 }}个偏股类{{ companyData.eqallocsizeType
                                        ==
                                        1 ? '大型' : (companyData.eqallocsizeType == 2 ?
                                            '中型' : '小型') }}公司中排名第{{ companyData.eqalloccompanyScoreRawRank }}{{ gscpShow ||
                                            flShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="gscpShow">固收型主动管理业绩在{{ typeSum3 }}个固收类{{ companyData.fxincsizeType ==
                                        1 ?
                                        '大型' : (companyData.fxincsizeType == 2 ?
                                            '中型' : '小型') }}公司中排名第{{ companyData.fxinccompanyScoreRawRank }} 。</span>
                                    <span v-show="flShow">旗下基金整体运营费率较同业{{ terscoreText }} 。</span><br />
                                    &#12288;&#12288;截止{{ companyReportData.yearStr }}，
                                    <span v-show="jlrsShow">公司在职基金经理为{{ companyData.managerCount }}人{{ wdxShow ||
                                        jsnlzlShow || jjpmShow || glnxShow
                                        == true ? '，' : '。' }}</span>
                                    <span v-show="glnxShow">平均投资管理期限为{{
                                        parseFloat(companyData.managerCareerTime).toFixed(2) }}年{{ wdxShow || jsnlzlShow
                                            || jjpmShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="jjpmShow">排名{{ companyData.managerCareerTimeRank }}/{{
                                        companyReportData.managerCareerTimeRankSize }}{{ wdxShow || jsnlzlShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="jsnlzlShow">近三年留职率为{{ parseFloat(companyData.retention_3Y).toFixed(2)
                                    }}%{{ wdxShow
                                            == true ? '，' : '。' }}</span>
                                    <span v-show="wdxShow">任职稳定性{{ comfortableText }}行业中位数。</span>
                                </div>
                            </div>
                        </div>

                        <div class="content-main2-area">
                            <div class="content-main2-right">
                                <div class="box-right1">
                                    <div class="content-left-top-area1">
                                        <span class="yjpfImgClass" v-html="YJPFlogo" />
                                        <span class="desc-text6">业绩评分</span>
                                    </div>
                                    <div class="content-big-box1">
                                        <div class="content-bottom-area">
                                            <div class="top-box-area1">
                                                <!-- <span style="display: flex; flex: 1.1;"></span> -->
                                                <span
                                                    style="display: flex; justify-content: flex-end;flex: 1.7;margin-left:40px;">
                                                    <span
                                                        style="display: flex;font-size: 13px;color: black;">参评基金数量</span>
                                                </span>
                                                <span
                                                    style="display: flex; flex: 1.5;justify-content: center;margin-left: 18px;">
                                                    <span
                                                        style="display: flex;font-size: 13px;color: black;">规模分类</span>
                                                </span>
                                                <span style="display: flex; flex: 1.1;justify-content: center;">
                                                    <span style="display: flex;font-size: 13px;color: black;">排名</span>
                                                </span>
                                                <div style="display: flex;flex: 5.1;">
                                                    <span style="display: flex; flex: 1;">
                                                        <span
                                                            style="display: flex;font-size: 13px;color: black;">总分值</span>
                                                    </span>

                                                    <span style="display: flex; flex: 1;justify-content:flex-end;">
                                                        <span
                                                            style="display: flex;width:12px;height:12px;margin-top:3px;margin-right:6px;border-radius: 50%;background-color: #1F55A5;"></span>
                                                        <span
                                                            style="display: flex;font-size: 13px;color: black;">得分</span>
                                                    </span>
                                                    <span style="display: flex; flex: 1.5;justify-content:flex-end;">
                                                        <span
                                                            style="display: flex;width:2px;height:14px;margin-top:2px;margin-right:6px;background-color: #060000;"></span>
                                                        <span
                                                            style="display: flex;font-size: 13px;color: black;">中位数</span>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="top-box-area1"
                                                style="align-items: flex-start;justify-content: left;font-weight: normal;"
                                                v-if="companyData.classCount == '' && companyData.eqallocclassCount == '' && companyData.fxincclassCount == ''">
                                                <div class="null-node-area"
                                                    style="margin-bottom: 0px;margin-top: 10px;align-self: flex-start;">
                                                    暂无信息
                                                </div>
                                            </div>

                                            <div class="top-box-area2" v-if="companyData.classCount != ''">
                                                <div style="flex: 0.5;text-align: left;">综合</div>
                                                <div style="flex: 0.5;text-align: center;color: black;">
                                                    {{ companyData.classCount == "" ? "--" : companyData.classCount }}
                                                </div>
                                                <div style="flex: 0.5;text-align: center;color: black;">
                                                    {{ companyData.sizeType == 1 ? '大型' : (companyData.sizeType == 2 ?
                                                        '中型' : '小型') }}</div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-if="companyData.sizeType == 1">{{ companyData.companyScoreRawRank
                                                        == "" ? "--" : companyData.companyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.companyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.companyScoreRawRank == "" ?
                                                            "" : companyData.allBigSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-else-if="companyData.sizeType == 2">
                                                    {{ companyData.companyScoreRawRank == "" ?
                                                        "--" : companyData.companyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.companyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.companyScoreRawRank == "" ?
                                                            "" : companyData.allMiddleSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-else-if="companyData.sizeType == 3">
                                                    {{ companyData.companyScoreRawRank == "" ?
                                                        "--" : companyData.companyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.companyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.companyScoreRawRank == "" ?
                                                            "" : companyData.allSmallSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;" v-else>
                                                    {{ companyData.companyScoreRawRank == "" ?
                                                        "--" : companyData.companyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.companyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.companyScoreRawRank == "" ?
                                                            "" : companyData.allSmallSum }}</span></div>
                                                <div class="top-process-area">
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>

                                                    <div class="top-size-area">
                                                        <div class="top-size-box1">
                                                            <div :style="{ 'margin-left': num1 }">
                                                                {{ companyData.companyScoreRaw == "" ?
                                                                    "--" : companyData.companyScoreRaw }}</div>
                                                        </div>
                                                        <div class="top-size-box2"
                                                            :style="{ 'margin-left': progressNum1, 'width': progressWidth1 }">
                                                            <div class="middle-num-box" :style="{ 'left': middleNum1 }">
                                                            </div>
                                                            <div class="score-num-box" :style="{ 'left': scoreNum1 }">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="top-box-area2" v-else></div>
                                            <div class="top-box-area2" v-if="companyData.eqallocclassCount != ''">
                                                <div style="flex: 0.5;text-align: left;">偏股</div>
                                                <div style="flex: 0.5;text-align: center;color: black;">
                                                    {{ companyData.eqallocclassCount == "" ?
                                                        "--" : companyData.eqallocclassCount }}</div>
                                                <div style="flex: 0.5;text-align: center;color: black;">
                                                    {{ companyData.eqallocsizeType == 1 ?
                                                        '大型' : (companyData.eqallocsizeType == 2 ? '中型' : '小型') }}</div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-if="companyData.eqallocsizeType == 1">
                                                    {{ companyData.eqalloccompanyScoreRawRank == "" ?
                                                        "--" : companyData.eqalloccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.eqalloccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.eqalloccompanyScoreRawRank == ""
                                                            ?
                                                            "" : companyData.eqallocbigSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-else-if="companyData.eqallocsizeType == 2">
                                                    {{ companyData.eqalloccompanyScoreRawRank == "" ?
                                                        "--" : companyData.eqalloccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.eqalloccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.eqalloccompanyScoreRawRank == ""
                                                            ?
                                                            "" : companyData.eqallocmiddleSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-else-if="companyData.eqallocsizeType == 3">
                                                    {{ companyData.eqalloccompanyScoreRawRank == "" ?
                                                        "--" : companyData.eqalloccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.eqalloccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.eqalloccompanyScoreRawRank == ""
                                                            ?
                                                            "" : companyData.eqallocsmallSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;" v-else>
                                                    {{ companyData.eqalloccompanyScoreRawRank == "" ?
                                                        "--" : companyData.eqalloccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.eqalloccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.eqalloccompanyScoreRawRank == ""
                                                            ?
                                                            "" : companyData.eqallocsmallSum }}</span></div>
                                                <div class="top-process-area">
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>

                                                    <div class="top-size-area">
                                                        <div class="top-size-box1">
                                                            <div :style="{ 'margin-left': num2 }">
                                                                {{ companyData.eqalloccompanyScoreRaw == "" ?
                                                                    "--" : companyData.eqalloccompanyScoreRaw }}</div>
                                                        </div>
                                                        <div class="top-size-box2"
                                                            :style="{ 'margin-left': progressNum2, 'width': progressWidth2 }">
                                                            <div class="middle-num-box" :style="{ 'left': middleNum2 }">
                                                            </div>
                                                            <div class="score-num-box" :style="{ 'left': scoreNum2 }">
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="top-box-area2" v-else></div>
                                            <div class="top-box-area2" v-if="companyData.fxincclassCount != ''">
                                                <div style="flex: 0.5;text-align: left;">固收</div>
                                                <div style="flex: 0.5;text-align: center;color: black;">
                                                    {{ companyData.fxincclassCount == "" ?
                                                        "--" : companyData.fxincclassCount }}</div>
                                                <div style="flex: 0.5;text-align: center;color: black;">
                                                    {{ companyData.fxincsizeType == 1 ? '大型' :
                                                        (companyData.fxincsizeType
                                                            == 2 ? '中型' : '小型') }}</div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-if="companyData.fxincsizeType == 1">
                                                    {{ companyData.fxinccompanyScoreRawRank == "" ?
                                                        "--" : companyData.fxinccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.fxinccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.fxinccompanyScoreRawRank == "" ?
                                                            "" : companyData.fxincbigSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-else-if="companyData.fxincsizeType == 2">
                                                    {{ companyData.fxinccompanyScoreRawRank == "" ?
                                                        "--" : companyData.fxinccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.fxinccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.fxinccompanyScoreRawRank == "" ?
                                                            "" : companyData.fxincmiddleSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;"
                                                    v-else-if="companyData.fxincsizeType == 3">
                                                    {{ companyData.fxinccompanyScoreRawRank == "" ?
                                                        "--" : companyData.fxinccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.fxinccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.fxinccompanyScoreRawRank == "" ?
                                                            "" : companyData.fxincsmallSum }}</span></div>
                                                <div style="flex: 0.5;text-align: center;color: black;" v-else>
                                                    {{ companyData.fxinccompanyScoreRawRank == "" ?
                                                        "--" : companyData.fxinccompanyScoreRawRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.fxinccompanyScoreRawRank
                                                                == "" ? "" : "/" }}{{ companyData.fxinccompanyScoreRawRank == "" ?
                                                            "" : companyData.fxincsmallSum }}</span></div>
                                                <div class="top-process-area">
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>
                                                    <div class="every-box"></div>

                                                    <div class="top-size-area">
                                                        <div class="top-size-box1">
                                                            <div :style="{ 'margin-left': num3 }">
                                                                {{ companyData.fxinccompanyScoreRaw == "" ?
                                                                    "--" : companyData.fxinccompanyScoreRaw }}</div>
                                                        </div>
                                                        <div class="top-size-box2"
                                                            :style="{ 'margin-left': progressNum3, 'width': progressWidth3 }">
                                                            <div class="middle-num-box" :style="{ 'left': middleNum3 }">
                                                            </div>
                                                            <div class="score-num-box" :style="{ 'left': scoreNum3 }">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="top-box-area2" v-else></div>
                                            <div class="num-mark-area"
                                                v-if="companyData.classCount != '' || companyData.eqallocclassCount != '' || companyData.fxincclassCount != ''">
                                                <div class="num-area">
                                                    <div class="num-box1">0</div>
                                                    <div class="num-box2">20</div>
                                                    <div class="num-box3">40</div>
                                                    <div class="num-box4">60</div>
                                                    <div class="num-box5">80</div>
                                                    <div class="num-box6">100</div>
                                                </div>
                                            </div>
                                            <div class="num-mark-area" v-else></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="box-right2" :style="{ 'height': flexRatioHeight }">
                                    <div class="xc-area">
                                        <div class="xc-box">
                                            <div class="xc-top-box">
                                                <div class="top-right">
                                                    <div class="top-title"
                                                        style="display: flex;flex: 6;font-size: 13px;font-weight: 550;justify-content: flex-end;color: black;">
                                                        幸存率<span
                                                            style="color: rgb(161 161 161);font-weight: 200;">/同类平均</span>
                                                    </div>
                                                    <div class="top-three"
                                                        style="display: flex;flex: 2;font-size: 13px;justify-content: flex-end;font-weight: 550;color: black;">
                                                        排名</div>
                                                    <div class="top-five"
                                                        style="display: flex;flex: 5;font-size: 13px;justify-content: flex-end;font-weight: 550;color: black;">
                                                        成功率<span
                                                            style="color: rgb(161 161 161);font-weight: 200;">/同类平均</span>
                                                    </div>
                                                    <div class="top-ten"
                                                        style="display: flex;flex: 2;font-size: 13px;justify-content: flex-end;font-weight: 550;color: black;">
                                                        排名</div>
                                                </div>
                                            </div>
                                            <div class="xc-bottom-box"
                                                v-if="(survivalRatio[0] != '0' || successRatio[0] != '0') || (survivalRatio[1] != '0' || successRatio[1] != '0') || (survivalRatio[2] != '0' || successRatio[2] != '0')">
                                                <div class="bottom-row"
                                                    v-show="survivalRatio[0] != '0' || successRatio[0] != '0'">
                                                    <div class="top-left">
                                                        <div class="top-title"
                                                            style="display:flex;flex:3;font-size: 13px;color: black;">三年
                                                        </div>
                                                    </div>
                                                    <div class="top-right">
                                                        <div class="top-three"
                                                            style="display:flex;flex:1.6;color: black;justify-content: flex-end;">
                                                            <span
                                                                style="color:#960000;font-size: 15px;font-feature-settings: normal;"
                                                                v-if="survivalRatio[0] > survivalAvg[0]">{{
                                                                    parseFloat(survivalRatio[0]).toFixed(2) }}%&nbsp;</span>
                                                            <span
                                                                style="color:#518428;font-size: 15px;font-feature-settings: normal;"
                                                                v-else>{{ parseFloat(survivalRatio[0]).toFixed(2)
                                                                }}%&nbsp;</span>
                                                            <span
                                                                style="color: rgb(161 161 161);font-size: 13px;font-feature-settings: normal;">/&nbsp;{{
                                                                    parseFloat(survivalAvg[0]).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="top-five"
                                                            style="display:flex;flex:1;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span>{{ survivalRank[0] == null ?
                                                                '-'
                                                                : survivalRank[0].substring(0, survivalRank[0].lastIndexOf("/")) }}</span>
                                                            <span style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                survivalRank[0]
                                                                    == null ?
                                                                    '-'
                                                                    :survivalRank[0].substring(survivalRank[0].lastIndexOf("/"))}}</span>
                                                        </div>

                                                        <div class="top-ten"
                                                            style="display:flex;flex:2;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span
                                                                style="color:#960000;font-size: 15px;font-feature-settings: normal;"
                                                                v-if="successRatio[0] > successAvg[0]">{{
                                                                    parseFloat(successRatio[0]).toFixed(2) }}%&nbsp;</span>
                                                            <span
                                                                style="color:#518428;font-size: 15px;font-feature-settings: normal;"
                                                                v-else>{{ parseFloat(successRatio[0]).toFixed(2)
                                                                }}%&nbsp;</span>
                                                            <span
                                                                style="color: rgb(161 161 161);font-size: 13px;font-feature-settings: normal;">/&nbsp;{{
                                                                    parseFloat(successAvg[0]).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="top-ten"
                                                            style="display:flex;flex:1;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span>{{ successRank[0] == null ?
                                                                '-'
                                                                :
                                                                successRank[0].substring(0,successRank[0].lastIndexOf("/"))}}</span>
                                                            <span style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                successRank[0]
                                                                    == null ?
                                                                    '-'
                                                                    :successRank[0].substring(successRank[0].lastIndexOf("/"))}}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="bottom-row"
                                                    v-show="survivalRatio[1] != '0' || successRatio[1] != '0'">
                                                    <div class="top-left">
                                                        <div class="top-title"
                                                            style="display:flex;flex:3;font-size: 13px;color: black;">五年
                                                        </div>
                                                    </div>
                                                    <div class="top-right">
                                                        <div class="top-three"
                                                            style="display:flex;flex:1.6;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span
                                                                style="color:#960000;font-size: 15px;font-feature-settings: normal;"
                                                                v-if="survivalRatio[1] > survivalAvg[1]">{{
                                                                    parseFloat(survivalRatio[1]).toFixed(2) }}%&nbsp;</span>
                                                            <span
                                                                style="color:#518428;font-size: 15px;font-feature-settings: normal;"
                                                                v-else>{{ parseFloat(survivalRatio[1]).toFixed(2)
                                                                }}%&nbsp;</span>
                                                            <span
                                                                style="color: rgb(161 161 161);font-size: 13px;font-feature-settings: normal;">/&nbsp;{{
                                                                    parseFloat(survivalAvg[1]).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="top-five"
                                                            style="display:flex;flex:1;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span>{{ survivalRank[1] == null ?
                                                                '--'
                                                                : survivalRank[1].substring(0, survivalRank[1].lastIndexOf("/")) }}</span>
                                                            <span style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                survivalRank[1]
                                                                    == null ?
                                                                    '-'
                                                                    :survivalRank[1].substring(survivalRank[1].lastIndexOf("/"))}}</span>
                                                        </div>

                                                        <div class="top-ten"
                                                            style="display:flex;flex:2;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span
                                                                style="color:#960000;font-size: 15px;font-feature-settings: normal;"
                                                                v-if="successRatio[1] > successAvg[1]">{{
                                                                    parseFloat(successRatio[1]).toFixed(2) }}%&nbsp;</span>
                                                            <span
                                                                style="color:#518428;font-size: 15px;font-feature-settings: normal;"
                                                                v-else>{{ parseFloat(successRatio[1]).toFixed(2)
                                                                }}%&nbsp;</span>
                                                            <span
                                                                style="color: rgb(161 161 161);font-size: 13px;font-feature-settings: normal;">/&nbsp;{{
                                                                    parseFloat(successAvg[1]).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="top-ten"
                                                            style="display:flex;flex:1;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span>{{ successRank[1] == null ?
                                                                '--'
                                                                :
                                                                successRank[1].substring(0,successRank[1].lastIndexOf("/"))}}</span>
                                                            <span style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                successRank[1]
                                                                    == null ?
                                                                    '-'
                                                                    :successRank[1].substring(successRank[1].lastIndexOf("/"))}}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="bottom-row"
                                                    v-show="survivalRatio[2] != '0' || successRatio[2] != '0'">
                                                    <div class="top-left">
                                                        <div class="top-title"
                                                            style="display:flex;flex:3;font-size: 13px;color: black;">十年
                                                        </div>
                                                    </div>
                                                    <div class="top-right">
                                                        <div class="top-three"
                                                            style="display:flex;flex:1.6;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span
                                                                style="color:#960000;font-size: 15px;font-feature-settings: normal;"
                                                                v-if="survivalRatio[2] > survivalAvg[2]">{{
                                                                    parseFloat(survivalRatio[2]).toFixed(2) }}%&nbsp;</span>
                                                            <span
                                                                style="color:#518428;font-size: 15px;font-feature-settings: normal;"
                                                                v-else>{{ parseFloat(survivalRatio[2]).toFixed(2)
                                                                }}%&nbsp;</span>
                                                            <span
                                                                style="color: rgb(161 161 161);font-size: 13px;font-feature-settings: normal;">/&nbsp;{{
                                                                    parseFloat(survivalAvg[2]).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="top-five"
                                                            style="display:flex;flex:1;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span>{{ survivalRank[2] == null ?
                                                                '--'
                                                                : survivalRank[2].substring(0, survivalRank[2].lastIndexOf("/")) }}</span>
                                                            <span style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                survivalRank[2]
                                                                    == null ?
                                                                    '--'
                                                                    :survivalRank[2].substring(survivalRank[2].lastIndexOf("/"))}}</span>
                                                        </div>
                                                        <div class="top-ten"
                                                            style="display:flex;flex:2;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span
                                                                style="color:#960000;font-size: 15px;font-feature-settings: normal;"
                                                                v-if="successRatio[2] > successAvg[2]">{{
                                                                    parseFloat(successRatio[2]).toFixed(2) }}%&nbsp;</span>
                                                            <span
                                                                style="color:#518428;font-size: 15px;font-feature-settings: normal;"
                                                                v-else>{{ parseFloat(successRatio[2]).toFixed(2)
                                                                }}%&nbsp;</span>
                                                            <span
                                                                style="color: rgb(161 161 161);font-size: 13px;font-feature-settings: normal;">/&nbsp;{{
                                                                    parseFloat(successAvg[2]).toFixed(2) }}%</span>
                                                        </div>
                                                        <div class="top-ten"
                                                            style="display:flex;flex:1;font-size: 14px;color: black;justify-content: flex-end;">
                                                            <span>{{ successRank[2] == null ?
                                                                '--'
                                                                :
                                                                successRank[2].substring(0,successRank[2].lastIndexOf("/"))}}</span>
                                                            <span style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                successRank[2]
                                                                    == null ?
                                                                    '--'
                                                                    :successRank[2].substring(successRank[2].lastIndexOf("/"))}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="xc-bottom-box" v-else>
                                                <div class="null-node-area"
                                                    style="margin-bottom: 0px;align-self: flex-start;">
                                                    暂无信息
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box-right6">
                                    <div class="content-left-top-area1">
                                        <span class="gmImgClass" v-html="GMlogo" />
                                        <span class="desc-text3">规模</span>
                                    </div>
                                    <div class="gm-area2">
                                        <div class="gm-box">
                                            <div class="gm-left-title">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;color: black;">非货币基金</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">数值</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">排名</span>
                                            </div>
                                            <div class="gm-row">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;">管理规模&nbsp;(亿元)</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSize
                                                            == "" ? "--" : (companyData.fundSize > 1 ?
                                                                parseFloat(companyData.fundSize).toFixed(0) : '&lt;1') }}</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSizeRank
                                                            == "" ? "--" : companyData.fundSizeRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">/{{
                                                            companyReportData.fundSizeRankSize
                                                                == "" ? "--" : companyReportData.fundSizeRankSize }}</span></span>
                                            </div>
                                            <div class="gm-row">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;">基金数量</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        companyIndexInfo.nonMoneyMarketFundCount
                                                            == "" ? "--" : companyIndexInfo.nonMoneyMarketFundCount }}</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        nonMoneyMarketFundCountRank
                                                            == "" ?
                                                            '--' :
                                                            nonMoneyMarketFundCountRank.substring(0,nonMoneyMarketFundCountRank.lastIndexOf("/"))}}<span
                                                        style="color: rgb(161 161 161);font-weight: 200;">{{
                                                            nonMoneyMarketFundCountRank
                                                                == "" ?
                                                                '-' :
                                                                nonMoneyMarketFundCountRank.substring(nonMoneyMarketFundCountRank.lastIndexOf("/"))}}</span></span>
                                            </div>
                                            <div class="gm-row">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;">份额数量</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        companyData.fundCount }}</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        companyData.fundCountRank
                                                            == "" ? "--" : companyData.fundCountRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">/{{
                                                            companyReportData.fundCountRankSize
                                                                == "" ? "--" : companyReportData.fundCountRankSize }}</span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="content-main3-left-area">
                                <div class="content-main3-left-box">
                                    <div class="box-left1"
                                        :style="{ 'height': cpxFlexHeight, 'border-bottom': cpxBorderBottom }">
                                        <div class="box-left1-top-area" :style="{ 'border-bottom': cpxBorderBottom }">
                                            <div class="content-left-top-area2">
                                                <span class="cpxImgClass" v-html="CPXlogo" />
                                                <span class="desc-text7">产品线</span>
                                            </div>
                                            <div style="display:flex;width:100%;height:220px;">
                                                <div class="cpx-left-area">
                                                    <div
                                                        style="width:180px;height:100%;display: flex;display: -webkit-flex;align-items: center;">
                                                        <v-chart :option="orgOptions" autoresize
                                                            style="width:100%;height: 180px;left: -15px;"></v-chart>
                                                    </div>
                                                </div>
                                                <div class="cpx-right-area">
                                                    <div class="cpx-data-row">
                                                        <div class="cpx-row" style="display: flex;">
                                                            <span style="display: flex;flex: 1;"> </span>
                                                            <span
                                                                style="display: flex;flex: 1;font-size: 13px;font-weight: 550;justify-content: flex-end;color: black;">规模(亿元)</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-size: 13px;font-weight: 550;justify-content: flex-end;color: black;">排名</span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row">
                                                        <div class="circle-div">
                                                            <div class="process-circle-big1">
                                                                <div class="process-circle-small"></div>
                                                            </div>
                                                        </div>
                                                        <div class="cpx-row"
                                                            style="display: flex;border-bottom: 1px solid #CBCBCB;">
                                                            <span style="display: flex;flex: 1;">股票</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;margin-right: 14px;color: black;">{{
                                                                    parseFloat(companyData.equity)
                                                                        == 'NaN' ? "--" : (companyData.equity > 1 ?
                                                                            parseFloat(companyData.equity) : '&lt;1') }}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;color: black;"><span>{{
                                                                    companyData.equityrank
                                                                        == "" ? "--" : companyData.equityrank }}</span><span
                                                                    style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                        companyData.equityrank
                                                                            == "" ? "" : "/" }}{{ companyData.equityrank == "" ?
                                                                        "" : companyReportData.equityRankSize
                                                                    }}</span></span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row">
                                                        <div class="circle-div">
                                                            <div class="process-circle-big2">
                                                                <div class="process-circle-small"></div>
                                                            </div>
                                                        </div>
                                                        <div class="cpx-row"
                                                            style="display: flex;border-bottom: 1px solid #CBCBCB;">
                                                            <span style="display: flex;flex: 1;">混合</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;margin-right: 14px;color: black;">{{
                                                                    parseFloat(companyData.alloc)
                                                                        == 'NaN' ? "--" : (companyData.alloc > 1 ?
                                                                            parseFloat(companyData.alloc) : '&lt;1') }}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;color: black;"><span>{{
                                                                    companyData.allocrank
                                                                        == "" ? "--" : companyData.allocrank }}</span><span
                                                                    style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                        companyData.allocrank
                                                                            == "" ? "" : "/" }}{{ companyData.allocrank == "" ?
                                                                        "" : companyReportData.allocRankSize
                                                                    }}</span></span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row">
                                                        <div class="circle-div">
                                                            <div class="process-circle-big3">
                                                                <div class="process-circle-small"></div>
                                                            </div>
                                                        </div>
                                                        <div class="cpx-row"
                                                            style="display: flex;border-bottom: 1px solid #CBCBCB;">
                                                            <span style="display: flex;flex: 1;">固收</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;margin-right: 14px;color: black;">{{
                                                                    parseFloat(companyData.fxinc)
                                                                        == 'NaN' ? "--" : (companyData.fxinc > 1 ?
                                                                            parseFloat(companyData.fxinc) : '&lt;1') }}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;color: black;"><span>{{
                                                                    companyData.fxincrank
                                                                        == "" ? "--" : companyData.fxincrank }}</span><span
                                                                    style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                        companyData.fxincrank
                                                                            == "" ? "" : "/" }}{{ companyData.fxincrank == "" ?
                                                                        "" : companyReportData.fxincRankSize
                                                                    }}</span></span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row">
                                                        <div class="circle-div">
                                                            <div class="process-circle-big4">
                                                                <div class="process-circle-small"></div>
                                                            </div>
                                                        </div>
                                                        <div class="cpx-row"
                                                            style="display: flex;border-bottom: 1px solid #CBCBCB;">
                                                            <span style="display: flex;flex: 1;">货币</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;margin-right: 14px;color: black;">{{
                                                                    parseFloat(companyData.mnmkt)
                                                                        == 'NaN' ? "--" : (companyData.mnmkt > 1 ?
                                                                            parseFloat(companyData.mnmkt) : '&lt;1') }}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;color: black;"><span>{{
                                                                    companyData.mnmktrank
                                                                        == "" ? "--" : companyData.mnmktrank }}</span><span
                                                                    style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                        companyData.mnmktrank
                                                                            == "" ? "" : "/" }}{{ companyData.mnmktrank == "" ?
                                                                        "" : companyReportData.mnmktRankSize
                                                                    }}</span></span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row">
                                                        <div class="circle-div">
                                                            <div class="process-circle-big5">
                                                                <div class="process-circle-small"></div>
                                                            </div>
                                                        </div>
                                                        <div class="cpx-row" style="display: flex;">
                                                            <span style="display: flex;flex: 1;">其他</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;margin-right: 14px;color: black;">{{
                                                                    parseFloat(companyData.other)
                                                                        == 'NaN' ? "--" : (companyData.other > 1 ?
                                                                            parseFloat(companyData.other) : '&lt;1') }}</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 200;justify-content: flex-end;color: black;">--</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="box-left1-bottom-area"
                                            v-show="companyIndexInfo.passivityFundSizeRatio != ''">
                                            <div style="display:flex;width:100%;height:158px;">
                                                <div class="cpx-left-area2">
                                                    <div style="width:180px;height:100%">
                                                        <v-chart :option="orgOptions2" autoresize
                                                            style="width:100%;height: 180px;left: -15px;"></v-chart>
                                                    </div>
                                                </div>
                                                <div class="cpx-right-area2">
                                                    <div class="cpx-data-row2">
                                                        <div class="cpx-row" style="display: flex;">
                                                            <span style="display: flex;flex: 1;"> </span>
                                                            <span
                                                                style="display: flex;flex: 1;font-size: 13px;font-weight: 550;justify-content: flex-end;color: black;">规模(亿元)</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-size: 13px;font-weight: 550;justify-content: flex-end;color: black;">排名</span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row2">
                                                        <!-- <div class="circle-div">
                                                <div class="process-circle-big1">
                                                    <div class="process-circle-small"></div>
                                                </div>
                                            </div> -->
                                                        <div class="cpx-row" style="display: flex;">
                                                            <span style="display: flex;flex: 1;">指数型</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;color: black;">{{
                                                                    companyIndexInfo.indexFundSize
                                                                        == "" ?
                                                                        "--"
                                                                        : parseFloat(companyIndexInfo.indexFundSize).toFixed(1)}}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;color: black;">
                                                                <span>{{ indexFundSizeRank == "" ?
                                                                    '--'
                                                                    : indexFundSizeRank.substring(0, indexFundSizeRank.lastIndexOf("/")) }}</span>
                                                                <span
                                                                    style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                        indexFundSizeRank
                                                                            == "" ?
                                                                            ''
                                                                            : indexFundSizeRank.substring(indexFundSizeRank.lastIndexOf("/"))}}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row2">
                                                        <!-- <div class="circle-div">
                                                <div class="process-circle-big2">
                                                    <div class="process-circle-small"></div>
                                                </div>
                                            </div> -->
                                                        <div class="cpx-row" style="display: flex;">
                                                            <span
                                                                style="display: flex;flex: 1;color: rgb(161, 161, 161);">&nbsp;&nbsp;-权益指数</span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;color: black;">{{
                                                                    companyIndexInfo.equityIndexFundSize
                                                                        == "" ?
                                                                        "--"
                                                                        : parseFloat(companyIndexInfo.equityIndexFundSize).toFixed(1)}}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;color: black;">
                                                                <span>{{ equityIndexFundSizeRank == "" ?
                                                                    "--"
                                                                    : equityIndexFundSizeRank.substring(0, equityIndexFundSizeRank.lastIndexOf("/")) }}</span>
                                                                <span
                                                                    style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                        equityIndexFundSizeRank
                                                                            == "" ?
                                                                            ''
                                                                            : equityIndexFundSizeRank.substring(equityIndexFundSizeRank.lastIndexOf("/"))}}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="cpx-data-row2">
                                                        <!-- <div class="circle-div">
                                                <div class="process-circle-big3">
                                                    <div class="process-circle-small"></div>
                                                </div>
                                            </div> -->
                                                        <div class="cpx-row" style="display: flex;">
                                                            <span style="display: flex;flex: 1;"><span
                                                                    style="display: flex;">指数增强型</span></span>
                                                            <span
                                                                style="display: flex;flex: 1;font-weight: 400;justify-content: flex-end;color: black;">{{
                                                                    companyIndexInfo.enhanceIndexFundSize
                                                                        == "" ?
                                                                        "--"
                                                                        : parseFloat(companyIndexInfo.enhanceIndexFundSize).toFixed(1)}}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;color: black;">
                                                                <span>{{ enhanceIndexFundSizeRank == "" ?
                                                                    "--"
                                                                    : enhanceIndexFundSizeRank.substring(0, enhanceIndexFundSizeRank.lastIndexOf("/")) }}</span>
                                                                <span
                                                                    style="color: rgb(161 161 161);font-weight: 200;">{{
                                                                        enhanceIndexFundSizeRank
                                                                            == "" ?
                                                                            ''
                                                                            : enhanceIndexFundSizeRank.substring(enhanceIndexFundSizeRank.lastIndexOf("/"))}}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="cpx-left-bottom-area">
                                                <div class="circle-div6">
                                                    <div class="process-circle-big33">
                                                        <div class="process-circle-small6"></div>
                                                    </div>
                                                </div>
                                                <span style="margin-right: 14px;font-size: 14px;">主动型 <span
                                                        style="color: black;">{{ companyIndexInfo.activeFundSizeRatio ==
                                                            "" ? "--"
                                                            :
                                                            parseFloat(companyIndexInfo.activeFundSizeRatio).toFixed(2)}}%</span></span>
                                                <div class="circle-div6">
                                                    <div class="process-circle-big22">
                                                        <div class="process-circle-small6"></div>
                                                    </div>
                                                </div>
                                                <span style="font-size: 14px;">指数及指数增强 <span style="color: black;">{{
                                                    companyIndexInfo.passivityFundSizeRatio
                                                        ==
                                                        "" ? "--" :
                                                        parseFloat(companyIndexInfo.passivityFundSizeRatio).toFixed(2)}}%</span></span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="box-left6">
                                        <!-- <div class="box-right3"> -->
                                        <div class="content-left-top-area2">
                                            <span class="flImgClass" v-html="FLlogo" />
                                            <span class="desc-text5">费率</span>
                                        </div>
                                        <div class="content-area">
                                            <div class="fl-content-area1">
                                                <div class="fl-content-title">

                                                </div>
                                                <div class="fl-content-data">运营费率</div>
                                            </div>
                                            <div class="fl-content-area2">
                                                <div class="fl-content-title" style="font-size: 13px;font-weight: 550;">
                                                    综合得分</div>
                                                <div class="fl-content-data" style="color: black;">
                                                    {{ companyData.terscore == "" ? "--" : companyData.terscore }}</div>
                                            </div>
                                            <div class="fl-content-area2">
                                                <div class="fl-content-title" style="font-size: 13px;font-weight: 550;">
                                                    排名</div>
                                                <div class="fl-content-data" style="color: black;">
                                                    {{ companyData.terscoreRank == "" ?
                                                        "--" : companyData.terscoreRank }}<span
                                                        style="font-weight: 200;color: rgb(161 161 161);">{{
                                                            companyData.terscoreRank
                                                                == "" ? "" : "/" }}{{ companyData.terscoreRank == "" ?
                                                            "" : companyReportData.terscoreRankSize }}</span></div>
                                            </div>
                                        </div>
                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="content-main3-area">
                            <div class="bottom1-area">
                                <span style="font-weight:600;">数据来源：</span><span>Morningstar（晨星）；数据截⾄{{
                                    companyReportData.latestDate }}，如⽆特殊说明以⼈⺠币计算。</span>
                            </div>
                            <div class="bottom2-area">
                                <span
                                    style="font-weight:600;">免责声明：</span><span>晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况
                                    下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深
                                    圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。</span>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="page-module" ref="productReportPageRef" v-loading="loading" element-loading-text="加速生成中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="page-area">
                        <div class="top-area">
                            <div class="top-left-area">
                                <span class="top-left-area-title">中国基金公司量化数据报告 </span><span
                                    class="line-area">|</span><span class="top-left-area-date">
                                    {{ companyReportData.quarterStr }}</span>
                            </div>
                            <div class="top-right-area">
                                <div class="top-right-area-img"></div>
                            </div>
                        </div>

                        <div class="content-main6-area">
                            <div class="content-main6-right">
                                <div class="box-right7">
                                    <div class="content-left-top-area3">
                                        <span class="zjlImgClass" v-html="ZJLlogo" />
                                        <span class="desc-text4">资金流</span>
                                    </div>
                                    <div class="zjl-area">
                                        <div class="zjl-left-area">
                                            <div class="gm-row" style="padding: 6px 0px;">
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;font-weight: 550;font-size: 14px;color: rgb(30, 30, 30);">排名</span>
                                            </div>
                                            <div class="gm-row">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;">最近⼀年净流⼊(亿元)</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        parseFloat(companyData.fundSizeFlow_1Y).toFixed(0)
                                                            == 'NaN' ?
                                                            "--" : parseFloat(companyData.fundSizeFlow_1Y).toFixed(0) }}</span>
                                                <span
                                                    style="display: flex;flex: 1.5;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSizeFlowRank_1Y
                                                            == "" ? "--" : companyData.fundSizeFlowRank_1Y }}<span
                                                        style="font-weight: 200;color: rgb(161, 161, 161);">{{
                                                            companyData.fundSizeFlowRank_1Y
                                                                == "" ? "" : "/" }}{{ companyData.fundSizeFlowRank_1Y == "" ?
                                                            "" : companyReportData.fundSizeFlowRank1YSize }}</span></span>
                                            </div>
                                            <div class="gm-row">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;">最近⼀年增⻓率</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSizeFlowPer_1Y
                                                            == "" ?
                                                            "--" : companyData.fundSizeFlowPer_1Y }}{{
                                                        companyData.fundSizeFlowPer_1Y
                                                            == "" ? "" : "%" }}</span>
                                                <span
                                                    style="display: flex;flex: 1.5;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSizeFlowPerRank_1Y
                                                            == "" ? "--" : companyData.fundSizeFlowPerRank_1Y }}<span
                                                        style="font-weight: 200;color: rgb(161, 161, 161);">{{
                                                            companyData.fundSizeFlowPerRank_1Y
                                                                == "" ? "" : "/" }}{{ companyData.fundSizeFlowPerRank_1Y == "" ?
                                                            "" : companyReportData.fundSizeFlowPerRank1YSize
                                                        }}</span></span>
                                            </div>
                                            <div class="gm-row">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;">最近三年净流⼊(亿元)</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        parseFloat(companyData.fundSizeFlow_3Y).toFixed(0)
                                                            == 'NaN' ?
                                                            "--" : parseFloat(companyData.fundSizeFlow_3Y).toFixed(0) }}</span>
                                                <span
                                                    style="display: flex;flex: 1.5;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSizeFlowRank_3Y
                                                            == "" ? "--" : companyData.fundSizeFlowRank_3Y }}<span
                                                        style="font-weight: 200;color: rgb(161, 161, 161);">{{
                                                            companyData.fundSizeFlowRank_3Y
                                                                == "" ? "" : "/" }}{{ companyData.fundSizeFlowRank_3Y == "" ?
                                                            "" : companyReportData.fundSizeFlowRank3YSize }}</span></span>
                                            </div>
                                            <div class="gm-row">
                                                <span
                                                    style="display: flex;flex: 3;justify-content: flex-start;">最近三年增⻓率</span>
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSizeFlowPer_3Y
                                                            == "" ?
                                                            "--" : companyData.fundSizeFlowPer_3Y }}{{
                                                        companyData.fundSizeFlowPer_3Y
                                                            == "" ? "" : "%" }}</span>
                                                <span
                                                    style="display: flex;flex: 1.5;justify-content: flex-end;color: black;">{{
                                                        companyData.fundSizeFlowPerRank_3Y
                                                            == "" ? "--" : companyData.fundSizeFlowPerRank_3Y }}<span
                                                        style="font-weight: 200;color: rgb(161, 161, 161);">{{
                                                            companyData.fundSizeFlowPerRank_3Y
                                                                == "" ? "" : "/" }}{{ companyData.fundSizeFlowPerRank_3Y == "" ?
                                                            "" : companyReportData.fundSizeFlowPerRank3YSize
                                                        }}</span></span>
                                            </div>
                                        </div>
                                        <div class="zjl-right-area">
                                            <div class="zjl-right-box">
                                                <div class="zjl-content-box">
                                                    <div class="gm-row"
                                                        style="font-size: 14px;color: #1E1E1E;padding: 6px 0px;font-weight: 550;">
                                                        <span
                                                            style="display: flex;flex: 5;justify-content: flex-start;">资金流入前三</span>
                                                        <span
                                                            style="display: flex;flex: 1;justify-content: flex-end;font-size: 13px;">基金代码</span>
                                                        <span
                                                            style="display: flex;flex: 2.5;justify-content: flex-end;font-size: 13px;">季度资金流变化(亿元)</span>
                                                        <span
                                                            style="display: flex;flex: 2;justify-content: flex-end;font-size: 13px;">最新规模(亿元)</span>
                                                    </div>
                                                    <div v-if="fundInflow.length > 0">
                                                        <div class="gm-row" v-for="item in fundInflow" :key="item">
                                                            <span
                                                                style="display: flex;flex: 5;justify-content: flex-start;text-align: left;">{{
                                                                    item.fundName }}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;">{{
                                                                    item.symbol }}</span>
                                                            <span
                                                                style="display: flex;flex: 2.5;justify-content: flex-end;color: black;">{{
                                                                    item.flow
                                                                        == "" ? "--" : parseFloat(item.flow).toFixed(2) }}</span>
                                                            <span
                                                                style="display: flex;flex: 2;justify-content: flex-end;color: black;">{{
                                                                    item.fundSize
                                                                        == "" ?
                                                                        "--" : parseFloat(item.fundSize).toFixed(2) }}</span>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="null-node-area">
                                                            暂无信息
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="zjl-content-box">
                                                    <div class="gm-row"
                                                        style="font-size: 14px;color: #1E1E1E;padding: 6px 0px;font-weight: 550;">
                                                        <span
                                                            style="display: flex;flex: 5;justify-content: flex-start;">资金流出前三</span>
                                                        <span
                                                            style="display: flex;flex: 1;justify-content: flex-end;font-size: 13px;">基金代码</span>
                                                        <span
                                                            style="display: flex;flex: 2.5;justify-content: flex-end;font-size: 13px;">季度资金流变化(亿元)</span>
                                                        <span
                                                            style="display: flex;flex: 2;justify-content: flex-end;font-size: 13px;">最新规模(亿元)</span>
                                                    </div>
                                                    <div v-if="fundOutflow.length > 0">
                                                        <div class="gm-row" v-for="item in fundOutflow" :key="item">
                                                            <span
                                                                style="display: flex;flex: 5;justify-content: flex-start;text-align: left;">{{
                                                                    item.fundName }}</span>
                                                            <span
                                                                style="display: flex;flex: 1;justify-content: flex-end;">{{
                                                                    item.symbol }}</span>
                                                            <span
                                                                style="display: flex;flex: 2.5;justify-content: flex-end;color: black;">{{
                                                                    item.flow
                                                                        == "" ? "--" : parseFloat(item.flow).toFixed(2) }}</span>
                                                            <span
                                                                style="display: flex;flex: 2;justify-content: flex-end;color: black;">{{
                                                                    item.fundSize
                                                                        == "" ?
                                                                        "--" : parseFloat(item.fundSize).toFixed(2) }}</span>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="null-node-area">
                                                            暂无信息
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="box-right9">
                                    <div class="content-left-top-area9">
                                        <span class="zjlImgClass" v-html="ZJLlogo" />
                                        <span class="desc-text4">产品动态</span>
                                    </div>
                                    <div ref="page1FundStartRef" class="fund-start-marker"></div>
                                    <div class="cpct-area" v-show="page1NewFundShow" ref="page1NewFundRef">
                                        <div class="fixed-header">
                                            <div
                                            style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 22px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;margin-top: 10px;">
                                            新发基金(近一年)
                                            </div>
                                            <div class="gm-row" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                                <span style="display: flex;flex: 1;justify-content: flex-start;">基金代码</span>
                                                <span style="display: flex;flex: 4;justify-content: flex-start;"><span
                                                        style="display: flex;margin-left: 10px;justify-content: flex-start;">基金名称</span></span>
                                                <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                        style="display: flex;justify-content: flex-start;margin-left: 10px;">首发基金经理</span></span>
                                                <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                        style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                                <span style="display: flex;flex: 2;justify-content: center;"><span
                                                        style="display: flex;margin-left: 8px;">成立日期</span></span>
                                                <span
                                                    style="display: flex;flex: 1.5;justify-content: flex-end;">首发规模(亿元)</span>
                                            </div>
                                        </div>    
                                        <div v-if="newFund.length != 0" style="margin-bottom: 10px;">
                                            <div class="gm-row fund-content-row" v-for="item in page1NewFundList" :key="item">
                                                <span
                                                    style="display: flex;flex: 1;justify-content: flex-start;text-align: left;">{{
                                                        item.symbol }}</span>
                                                <span style="display: flex;flex: 4;justify-content: flex-start;"><span
                                                        style="display: flex;margin-left: 10px;justify-content: flex-start;text-align: left;">{{
                                                            item.fundName }}</span></span>
                                                <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                        style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                            item.managerName == "" ? "--" : item.managerName
                                                        }}</span></span>
                                                <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                        style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                            item.categoryName }}</span></span>
                                                <span style="display: flex;flex: 2;justify-content: center;">{{
                                                    item.inceptionDate.substr(0, 10) }}</span>
                                                <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{
                                                    item.fundSize
                                                        == "" ? "--" : parseFloat(item.fundSize).toFixed(2) }}</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="null-node-area">
                                                暂无信息
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cpct-area2" ref="page1ObsoleteFundRef"
                                    :style="{'border-top': borderTop }"
                                    v-show="page1ObsoleteFundShow">
                                    <div class="fixed-header">
                                        <div
                                        style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 28px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;margin-top: 10px;">
                                        基金清盘(近一年)
                                        </div>
                                        <div class="gm-row" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                            <span style="display: flex;flex: 1;justify-content: flex-start;">基金代码</span>
                                            <span style="display: flex;flex: 4;justify-content: flex-start;"><span
                                                    style="display: flex;margin-left: 10px;justify-content: flex-start;">基金名称</span></span>
                                            <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 10px;">基金经理</span></span>
                                            <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                            <span style="display: flex;flex: 2;justify-content: center;"><span
                                                    style="display: flex;margin-left: 8px;">成立日期</span></span>
                                            <span style="display: flex;flex: 1.5;justify-content: flex-end;">清盘日期</span>
                                        </div>
                                    </div>
                                    <div v-if="page1ObsoleteFundList.length !== 0" style="margin-bottom: 10px;">
                                        <div class="gm-row fund-content-row" v-for="item in page1ObsoleteFundList" :key="item">
                                            <span
                                                style="display: flex;flex: 1;justify-content: flex-start;text-align: left;">{{
                                                    item.symbol }}</span>
                                            <span style="display: flex;flex: 4;justify-content: flex-start;"><span
                                                    style="display: flex;margin-left: 10px;justify-content: flex-start;text-align: left;">{{
                                                        item.fundName }}</span></span>
                                            <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                        item.managerName == "" ? "--" : item.managerName }}</span></span>
                                            <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                        item.categoryName }}</span></span>
                                            <span style="display: flex;flex: 2;justify-content: center;">{{
                                                item.inceptionDate.substr(0, 10) }}</span>
                                            <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{
                                                item.obsoleteDate.substr(0, 10) }}</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="null-node-area">
                                            暂无信息
                                        </div>
                                    </div>
                                </div>
                                <div class="cpct-area66" v-show="page1MiniFundShow"  ref="page1MiniFundRef">
                                    <div class="fixed-header">
                                        <div
                                            style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 22px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;margin-top: 10px;">
                                            迷你基金(规模不足一亿)</div>
                                        <div class="gm-row3" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                            <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                                    style="display: flex;width: 83px;justify-content: flex-start;">基金代码</span></span>
                                            <span style="display: flex;flex: 7;justify-content: flex-start;">基金名称</span>
                                            <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 5px;">基金经理</span></span>
                                            <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                            <span
                                                style="display: flex;flex: 2.5;justify-content: flex-start;">最新规模(亿元)</span>
                                            <span style="display: flex;flex: 1.5;justify-content: flex-end;">是否指数</span>
                                            <span style="display: flex;flex: 2;justify-content: flex-end;">是否发起式</span>
                                        </div>
                                    </div>
                                    <div v-if="page1MiniFundList.length != 0" style="margin-bottom: 10px;">
                                        <div class="gm-row3 fund-content-row" v-for="item in page1MiniFundList" :key="item">
                                            <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                                    style="display: flex;width: 83px;justify-content: flex-start;text-align: left;">{{
                                                        item.symbol }}</span></span>
                                            <span
                                                style="display: flex;flex: 7;justify-content: flex-start;text-align: left;">{{
                                                    item.fundName }}</span>
                                            <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 5px;text-align: left;">{{
                                                        item.managerName == "" ? "--" : item.managerName }}</span></span>
                                            <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                                    style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                        item.categoryName }}</span></span>
                                            <span style="display: flex;flex: 2.5;justify-content: flex-end;"><span
                                                    style="margin-right: 19px;">{{ item.fundSize ==
                                                        "" ? "--" : parseFloat(item.fundSize).toFixed(2) }}</span></span>
                                            <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{
                                                item.index
                                                    == true ? '是' : '否' }}</span>
                                            <span style="display: flex;flex: 2;justify-content: flex-end;">{{ item.init
                                                == true ? '是' : '否' }}</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="null-node-area">
                                            暂无信息
                                        </div>
                                    </div>
                                </div>

                                <div class="cpct-area3" v-show="page1FundCountShow">
                                    <div class="cpct-box3">
                                        <div class="gm-row2" style="width: 200px;">
                                            <span
                                                style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">基金数量</span>
                                            <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                                companyIndexInfo.miniFundCount }}</span>
                                        </div>
                                        <div class="gm-row2" style="width: 200px;">
                                            <span
                                                style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">数量占比</span>
                                            <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                                companyIndexInfo.miniFundCountRatio
                                                    ==
                                                    "" ? "--" :
                                                    parseFloat(companyIndexInfo.miniFundCountRatio).toFixed(2)}}{{
                                                    companyIndexInfo.miniFundCountRatio
                                                        == "" ? "" : "%" }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="content-main3-area">
                            <div class="bottom1-area">
                                <span style="font-weight:600;">数据来源：</span><span>Morningstar（晨星）；数据截⾄{{
                                    companyReportData.latestDate }}，如⽆特殊说明以⼈⺠币计算。</span>
                            </div>
                            <div class="bottom2-area">
                                <span
                                    style="font-weight:600;">免责声明：</span><span>晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况
                                    下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深
                                    圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。</span>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 按最终排版宽度渲染全部数据，仅用于取得换行后的真实行高。 -->
                <div ref="fundMeasureRef" class="fund-measure-container" aria-hidden="true">
                    <!-- 三个栏目必须在同一个、与正式页面同宽的容器中完整排版。 -->
                    <div ref="fundMeasureNewSectionRef" data-fund-section="newFund"
                        class="fund-dynamic-section" :class="{ 'fund-dynamic-section--has-data': newFund.length }">
                        <div ref="fundMeasureNewHeaderRef" class="fixed-header">
                            <div class="fund-section-title">新发基金(近一年)</div>
                            <div class="gm-row fund-standard-row fund-table-header">
                                <span>基金代码</span><span>基金名称</span><span>首发基金经理</span>
                                <span>晨星分类</span><span>成立日期</span><span>首发规模(亿元)</span>
                            </div>
                        </div>
                        <div class="gm-row fund-standard-row" data-fund-type="newFund" :data-fund-index="index"
                            v-for="(item, index) in newFund" :key="'measure-new-' + index">
                            <span>{{ item.symbol }}</span><span>{{ item.fundName }}</span><span>{{ item.managerName == '' ? '--' : item.managerName }}</span>
                            <span>{{ item.categoryName }}</span><span>{{ formatFundDate(item.inceptionDate) }}</span><span>{{ item.fundSize == '' ? '--' : parseFloat(item.fundSize).toFixed(2) }}</span>
                        </div>
                        <div v-if="!newFund.length" class="null-node-area">暂无信息</div>
                    </div>

                    <div ref="fundMeasureObsoleteSectionRef" data-fund-section="obsoleteFund"
                        class="fund-dynamic-section fund-dynamic-section--bordered"
                        :class="{ 'fund-dynamic-section--has-data': obsoleteFund.length }">
                        <div ref="fundMeasureObsoleteHeaderRef" class="fixed-header">
                            <div class="fund-section-title">基金清盘(近一年)</div>
                            <div class="gm-row fund-standard-row fund-table-header">
                                <span>基金代码</span><span>基金名称</span><span>基金经理</span>
                                <span>晨星分类</span><span>成立日期</span><span>清盘日期</span>
                            </div>
                        </div>
                        <div class="gm-row fund-standard-row" data-fund-type="obsoleteFund" :data-fund-index="index"
                            v-for="(item, index) in obsoleteFund" :key="'measure-obsolete-' + index">
                            <span>{{ item.symbol }}</span><span>{{ item.fundName }}</span><span>{{ item.managerName == '' ? '--' : item.managerName }}</span>
                            <span>{{ item.categoryName }}</span><span>{{ formatFundDate(item.inceptionDate) }}</span><span>{{ formatFundDate(item.obsoleteDate) }}</span>
                        </div>
                        <div v-if="!obsoleteFund.length" class="null-node-area">暂无信息</div>
                    </div>

                    <div ref="fundMeasureMiniSectionRef" data-fund-section="miniFund"
                        class="fund-dynamic-section fund-dynamic-section--bordered"
                        :class="{ 'fund-dynamic-section--has-data': miniFund.length }">
                        <div ref="fundMeasureMiniHeaderRef" class="fixed-header">
                            <div class="fund-section-title">迷你基金(规模不足一亿)</div>
                            <div class="gm-row3 fund-mini-row fund-table-header">
                                <span>基金代码</span><span>基金名称</span><span>基金经理</span><span>晨星分类</span>
                                <span>最新规模(亿元)</span><span>是否指数</span><span>是否发起式</span>
                            </div>
                        </div>
                        <div class="gm-row3 fund-mini-row" data-fund-type="miniFund" :data-fund-index="index"
                            v-for="(item, index) in miniFund" :key="'measure-mini-' + index">
                            <span>{{ item.symbol }}</span><span>{{ item.fundName }}</span><span>{{ item.managerName == '' ? '--' : item.managerName }}</span>
                            <span>{{ item.categoryName }}</span><span>{{ item.fundSize == '' ? '--' : parseFloat(item.fundSize).toFixed(2) }}</span>
                            <span>{{ item.index ? '是' : '否' }}</span><span>{{ item.init ? '是' : '否' }}</span>
                        </div>
                        <div v-if="!miniFund.length" class="null-node-area">暂无信息</div>
                    </div>

                    <div ref="fundMeasureEmptyRef" class="null-node-area">暂无信息</div>
                    <div ref="fundMeasureSummaryRef" class="cpct-area3"></div>
                </div>

                <!-- 产品动态的续页由测量结果生成，不再限制为固定的 2～4 页。 -->
                <div class="page-module" v-for="(fundPage, fundPageIndex) in fundPages.slice(1)" :key="'fund-page-' + fundPageIndex">
                    <div class="page-area">
                        <div class="top-area">
                            <div class="top-left-area"><span class="top-left-area-title">中国基金公司量化数据报告 </span><span class="line-area">|</span><span class="top-left-area-date">{{ companyReportData.quarterStr }}</span></div>
                            <div class="top-right-area"><div class="top-right-area-img"></div></div>
                        </div>
                        <div class="page-limit-area">
                            <div v-for="(section, sectionIndex) in fundPage.sections" :key="section.type + '-' + sectionIndex"
                                class="fund-dynamic-section" :class="{ 'fund-dynamic-section--bordered': section.type !== 'newFund', 'fund-dynamic-section--has-data': section.items.length }">
                                <div class="fixed-header">
                                    <div class="fund-section-title">{{ fundSectionTitle(section.type) }}</div>
                                    <div v-if="section.type !== 'miniFund'" class="gm-row fund-standard-row fund-table-header">
                                        <span>基金代码</span><span>基金名称</span><span>{{ section.type === 'newFund' ? '首发基金经理' : '基金经理' }}</span>
                                        <span>晨星分类</span><span>成立日期</span><span>{{ section.type === 'newFund' ? '首发规模(亿元)' : '清盘日期' }}</span>
                                    </div>
                                    <div v-else class="gm-row3 fund-mini-row fund-table-header">
                                        <span>基金代码</span><span>基金名称</span><span>基金经理</span><span>晨星分类</span><span>最新规模(亿元)</span><span>是否指数</span><span>是否发起式</span>
                                    </div>
                                </div>
                                <template v-if="section.items.length">
                                    <!-- 不在同一元素上混用 v-if/v-else 和 v-for。Vue 2 中 v-for 优先级更高，
                                         会让条件分支复用错误，清盘基金跨页时可能重复渲染整段数据。 -->
                                    <template v-if="section.type === 'newFund'">
                                        <div class="gm-row fund-standard-row" v-for="(item, itemIndex) in section.items"
                                            :key="section.startIndex + itemIndex">
                                            <span>{{ item.symbol }}</span><span>{{ item.fundName }}</span><span>{{ item.managerName == '' ? '--' : item.managerName }}</span><span>{{ item.categoryName }}</span>
                                            <span>{{ formatFundDate(item.inceptionDate) }}</span><span>{{ item.fundSize == '' ? '--' : parseFloat(item.fundSize).toFixed(2) }}</span>
                                        </div>
                                    </template>
                                    <template v-else-if="section.type === 'obsoleteFund'">
                                        <div class="gm-row fund-standard-row" v-for="(item, itemIndex) in section.items"
                                            :key="section.startIndex + itemIndex">
                                            <span>{{ item.symbol }}</span><span>{{ item.fundName }}</span><span>{{ item.managerName == '' ? '--' : item.managerName }}</span><span>{{ item.categoryName }}</span>
                                            <span>{{ formatFundDate(item.inceptionDate) }}</span><span>{{ formatFundDate(item.obsoleteDate) }}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="gm-row3 fund-mini-row" v-for="(item, itemIndex) in section.items"
                                            :key="section.startIndex + itemIndex">
                                            <span>{{ item.symbol }}</span><span>{{ item.fundName }}</span><span>{{ item.managerName == '' ? '--' : item.managerName }}</span><span>{{ item.categoryName }}</span>
                                            <span>{{ item.fundSize == '' ? '--' : parseFloat(item.fundSize).toFixed(2) }}</span><span>{{ item.index ? '是' : '否' }}</span><span>{{ item.init ? '是' : '否' }}</span>
                                        </div>
                                    </template>
                                </template>
                                <div v-else class="null-node-area">暂无信息</div>
                            </div>
                            <div class="cpct-area3" v-if="fundPage.showSummary">
                                <div class="cpct-box3">
                                    <div class="gm-row2" style="width: 200px;"><span style="flex: 2;font-weight: 550;">基金数量</span><span style="flex: 1;text-align: right;">{{ companyIndexInfo.miniFundCount }}</span></div>
                                    <div class="gm-row2" style="width: 200px;"><span style="flex: 2;font-weight: 550;">数量占比</span><span style="flex: 1;text-align: right;">{{ formatFundRatio(companyIndexInfo.miniFundCountRatio) }}</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="content-main3-area">
                            <div class="bottom1-area"><span style="font-weight:600;">数据来源：</span><span>Morningstar（晨星）；数据截⾄{{ companyReportData.latestDate }}，如⽆特殊说明以⼈⺠币计算。</span></div>
                            <div class="bottom2-area"><span style="font-weight:600;">免责声明：</span><span>晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。</span></div>
                        </div>
                    </div>
                </div>

                <!-- 旧版固定续页保留为兼容模板，但新分页逻辑不会再显示它们。 -->
                <div class="page-module" v-loading="loading" v-show="page2Show" element-loading-text="加速生成中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="page-area">
                        <div class="top-area">
                            <div class="top-left-area">
                                <span class="top-left-area-title">中国基金公司量化数据报告 </span><span
                                    class="line-area">|</span><span class="top-left-area-date">
                                    {{ companyReportData.quarterStr }}</span>
                            </div>
                            <div class="top-right-area">
                                <div class="top-right-area-img"></div>
                            </div>
                        </div>

                        <div class="page-limit-area">

                            <div v-if="page2NewFundList.length != 0" v-show="page2NewFundShow" style="margin-bottom: 10px;"
                                ref="page2NewFundRef">
                                <div class="fixed-header">
                                    <div
                                        style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 22px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;margin-top: 10px;">
                                        新发基金(近一年)</div>
                                    <div class="gm-row" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                        <span style="display: flex;flex: 1;justify-content: flex-start;"
                                            v-show="newFund.length != 0">基金代码</span>
                                        <span style="display: flex;flex: 4;justify-content: flex-start;"
                                            v-show="newFund.length != 0"><span
                                                style="display: flex;margin-left: 10px;justify-content: flex-start;">基金名称</span></span>
                                        <span style="display: flex;flex: 2;justify-content: flex-start;"
                                            v-show="newFund.length != 0"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;">首发基金经理</span></span>
                                        <span style="display: flex;flex: 2;justify-content: flex-start;"
                                            v-show="newFund.length != 0"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                        <span style="display: flex;flex: 2;justify-content: center;"
                                            v-show="newFund.length != 0"><span
                                                style="display: flex;margin-left: 8px;">成立日期</span></span>
                                        <span style="display: flex;flex: 1.5;justify-content: flex-end;"
                                            v-show="newFund.length != 0">首发规模(亿元)</span>
                                    </div>
                                </div>
                                <div class="gm-row" v-for="item in page2NewFundList" :key="item">
                                    <span style="display: flex;flex: 1;justify-content: flex-start;text-align: left;">{{
                                        item.symbol }}</span>
                                    <span style="display: flex;flex: 4;justify-content: flex-start;"><span
                                            style="display: flex;margin-left: 10px;justify-content: flex-start;text-align: left;">{{
                                                item.fundName }}</span></span>
                                    <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                item.managerName == "" ? "--" : item.managerName }}</span></span>
                                    <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                item.categoryName }}</span></span>
                                    <span style="display: flex;flex: 2;justify-content: center;">{{
                                        item.inceptionDate.substr(0, 10) }}</span>
                                    <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{ item.fundSize ==
                                        "" ? "--" : parseFloat(item.fundSize).toFixed(2) }}</span>
                                </div>
                            </div>

                            <div class="cpct-area2" style="border-top: 1.5px solid #b1b0b0;" ref="page2ObsoleteFundRef"
                                v-show="page2ObsoleteFundShow">
                                <div class="fixed-header">
                                    <div
                                        style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 28px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;margin-top: 10px;">
                                        基金清盘(近一年)</div>
                                    <div class="gm-row" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                        <span style="display: flex;flex: 1;justify-content: flex-start;">基金代码</span>
                                        <span style="display: flex;flex: 4;justify-content: flex-start;"
                                            v-show="obsoleteFund.length != 0"><span
                                                style="display: flex;margin-left: 10px;justify-content: flex-start;">基金名称</span></span>
                                        <span style="display: flex;flex: 2;justify-content: flex-start;"
                                            v-show="obsoleteFund.length != 0"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;">基金经理</span></span>
                                        <span style="display: flex;flex: 2;justify-content: flex-start;"
                                            v-show="obsoleteFund.length != 0"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                        <span style="display: flex;flex: 2;justify-content: center;"
                                            v-show="obsoleteFund.length != 0"><span
                                                style="display: flex;margin-left: 8px;">成立日期</span></span>
                                        <span style="display: flex;flex: 1.5;justify-content: flex-end;"
                                            v-show="obsoleteFund.length != 0">清盘日期</span>
                                    </div>
                                </div>
                                <div v-if="page2ObsoleteFundList.length != 0" style="margin-bottom: 10px;">
                                    <div class="gm-row" v-for="item in page2ObsoleteFundList" :key="item">
                                        <span
                                            style="display: flex;flex: 1;justify-content: flex-start;text-align: left;">{{
                                                item.symbol }}</span>
                                        <span style="display: flex;flex: 4;justify-content: flex-start;"><span
                                                style="display: flex;margin-left: 10px;justify-content: flex-start;text-align: left;">{{
                                                    item.fundName }}</span></span>
                                        <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                    item.managerName == "" ? "--" : item.managerName }}</span></span>
                                        <span style="display: flex;flex: 2;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                    item.categoryName }}</span></span>
                                        <span style="display: flex;flex: 2;justify-content: center;">{{
                                            item.inceptionDate.substr(0, 10) }}</span>
                                        <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{
                                            item.obsoleteDate.substr(0, 10) }}</span>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="null-node-area">
                                        暂无信息
                                    </div>
                                </div>
                            </div>
                            <div class="cpct-area6" v-show="page2MiniFundShow" ref="page2MiniFundRef">
                                <div class="fixed-header">
                                    <div
                                        style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 22px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;margin-top: 10px;">
                                        迷你基金(规模不足一亿)</div>
                                    <div class="gm-row" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                        <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                                style="display: flex;width: 83px;justify-content: flex-start;">基金代码</span></span>
                                        <span style="display: flex;flex: 7;justify-content: flex-start;">基金名称</span>
                                        <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 5px;">基金经理</span></span>
                                        <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                        <span
                                            style="display: flex;flex: 2.5;justify-content: flex-start;">最新规模(亿元)</span>
                                        <span style="display: flex;flex: 1.5;justify-content: flex-end;">是否指数</span>
                                        <span style="display: flex;flex: 2;justify-content: flex-end;">是否发起式</span>
                                    </div>
                                </div>

                                <div class="gm-row" v-for="item in page2MiniFundList" :key="item">
                                    <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                            style="display: flex;width: 83px;justify-content: flex-start;text-align: left;">{{
                                                item.symbol }}</span></span>
                                    <span style="display: flex;flex: 7;justify-content: flex-start;text-align: left;">{{
                                        item.fundName }}</span>
                                    <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 5px;text-align: left;">{{
                                                item.managerName == "" ? "--" : item.managerName }}</span></span>
                                    <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                item.categoryName }}</span></span>
                                    <span style="display: flex;flex: 2.5;justify-content: flex-end;"><span
                                            style="margin-right: 19px;">{{ item.fundSize ==
                                                "" ? "--" : parseFloat(item.fundSize).toFixed(2) }}</span></span>
                                    <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{ item.index ==
                                        true ? '是' : '否' }}</span>
                                    <span style="display: flex;flex: 2;justify-content: flex-end;">{{ item.init == true
                                        ?
                                        '是' : '否' }}</span>
                                </div>
                            </div>

                            <div class="flag-height-class" id="flag-height" ref="flagHeightRef">
                            </div>

                            <div class="cpct-area3" v-show="page2FundCountShow">
                                <div class="cpct-box3">
                                    <div class="gm-row2" style="width: 200px;">
                                        <span
                                            style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">基金数量</span>
                                        <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                            companyIndexInfo.miniFundCount }}</span>
                                    </div>
                                    <div class="gm-row2" style="width: 200px;">
                                        <span
                                            style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">数量占比</span>
                                        <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                            companyIndexInfo.miniFundCountRatio
                                                ==
                                                "" ? "--" :
                                                parseFloat(companyIndexInfo.miniFundCountRatio).toFixed(2)}}%</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="content-main3-area">
                            <div class="bottom1-area">
                                <span style="font-weight:600;">数据来源：</span><span>Morningstar（晨星）；数据截⾄{{
                                    companyReportData.latestDate }}，如⽆特殊说明以⼈⺠币计算。</span>
                            </div>
                            <div class="bottom2-area">
                                <span
                                    style="font-weight:600;">免责声明：</span><span>晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况
                                    下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深
                                    圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。</span>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="page-module" v-loading="loading" v-show="page3Show" element-loading-text="加速生成中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="page-area">
                        <div class="top-area">
                            <div class="top-left-area">
                                <span class="top-left-area-title">中国基金公司量化数据报告 </span><span
                                    class="line-area">|</span><span class="top-left-area-date">
                                    {{ companyReportData.quarterStr }}</span>
                            </div>
                            <div class="top-right-area">
                                <div class="top-right-area-img"></div>
                            </div>
                        </div>

                        <div class="page-limit-area">

                            <div v-show="page3MiniFundShow" class="cpct-area7">
                                <div class="fixed-header">
                                    <div
                                        style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 22px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;margin-top: 10px;">
                                        迷你基金(规模不足一亿)</div>
                                    <div class="gm-row" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                        <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                                style="display: flex;width: 83px;justify-content: flex-start;">基金代码</span></span>
                                        <span style="display: flex;flex: 7;justify-content: flex-start;">基金名称</span>
                                        <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 5px;">基金经理</span></span>
                                        <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                        <span style="display: flex;flex: 2.5;justify-content: flex-start;">最新规模(亿元)</span>
                                        <span style="display: flex;flex: 1.5;justify-content: flex-end;">是否指数</span>
                                        <span style="display: flex;flex: 2;justify-content: flex-end;">是否发起式</span>
                                    </div>
                                </div>
                                <div class="gm-row" v-for="item in page3MiniFundList" :key="item">
                                    <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                            style="display: flex;width: 83px;justify-content: flex-start;text-align: left;">{{
                                                item.symbol }}</span></span>
                                    <span style="display: flex;flex: 7;justify-content: flex-start;text-align: left;">{{
                                        item.fundName }}</span>
                                    <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 5px;text-align: left;">{{
                                                item.managerName == "" ? "--" : item.managerName }}</span></span>
                                    <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                item.categoryName }}</span></span>
                                    <span style="display: flex;flex: 2.5;justify-content: flex-end;"><span
                                            style="margin-right: 19px;">{{ item.fundSize ==
                                                "" ? "--" : parseFloat(item.fundSize).toFixed(2) }}</span></span>
                                    <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{ item.index ==
                                        true ? '是' : '否' }}</span>
                                    <span style="display: flex;flex: 2;justify-content: flex-end;">{{ item.init == true
                                        ?
                                        '是' : '否' }}</span>
                                </div>
                            </div>

                            <div class="cpct-area3" v-show="page3FundCountShow">
                                <div class="cpct-box3">
                                    <div class="gm-row2" style="width: 200px;">
                                        <span
                                            style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">基金数量</span>
                                        <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                            companyIndexInfo.miniFundCount }}</span>
                                    </div>
                                    <div class="gm-row2" style="width: 200px;">
                                        <span
                                            style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">数量占比</span>
                                        <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                            companyIndexInfo.miniFundCountRatio }}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="content-main3-area">
                            <div class="bottom1-area">
                                <span style="font-weight:600;">数据来源：</span><span>Morningstar（晨星）；数据截⾄{{
                                    companyReportData.latestDate }}，如⽆特殊说明以⼈⺠币计算。</span>
                            </div>
                            <div class="bottom2-area">
                                <span
                                    style="font-weight:600;">免责声明：</span><span>晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况
                                    下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深
                                    圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。</span>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="page-module" v-loading="loading" v-show="page4Show" element-loading-text="加速生成中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="page-area">
                        <div class="top-area">
                            <div class="top-left-area">
                                <span class="top-left-area-title">中国基金公司量化数据报告 </span><span
                                    class="line-area">|</span><span class="top-left-area-date">
                                    {{ companyReportData.quarterStr }}</span>
                            </div>
                            <div class="top-right-area">
                                <div class="top-right-area-img"></div>
                            </div>
                        </div>

                        <div class="page-limit-area">

                            <div class="cpct-area7" v-show="page4MiniFundShow">
                                <div class="fixed-header">
                                    <div
                                        style="font-weight: 550;font-size: 16px;display: flex;width: 100%;height: 22px;color: rgb(30, 30, 30);align-items: center;padding: 6px 0px;">
                                        迷你基金(规模不足一亿)</div>
                                    <div class="gm-row" style="font-size: 13px;color: #1E1E1E;font-weight: 550;">
                                        <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                                style="display: flex;width: 83px;justify-content: flex-start;">基金代码</span></span>
                                        <span style="display: flex;flex: 7;justify-content: flex-start;">基金名称</span>
                                        <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 5px;">基金经理</span></span>
                                        <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                                style="display: flex;justify-content: flex-start;margin-left: 10px;">晨星分类</span></span>
                                        <span style="display: flex;flex: 2.5;justify-content: flex-start;">最新规模(亿元)</span>
                                        <span style="display: flex;flex: 1.5;justify-content: flex-end;">是否指数</span>
                                        <span style="display: flex;flex: 2;justify-content: flex-end;">是否发起式</span>
                                    </div>
                                </div>
                                <div class="gm-row" v-for="item in page4MiniFundList" :key="item">
                                    <span style="display: flex;flex: 1;justify-content: flex-start;"><span
                                            style="display: flex;width: 83px;justify-content: flex-start;text-align: left;">{{
                                                item.symbol }}</span></span>
                                    <span style="display: flex;flex: 7;justify-content: flex-start;text-align: left;">{{
                                        item.fundName }}</span>
                                    <span style="display: flex;flex: 3.5;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 5px;text-align: left;">{{
                                                item.managerName == "" ? "--" : item.managerName }}</span></span>
                                    <span style="display: flex;flex: 3.8;justify-content: flex-start;"><span
                                            style="display: flex;justify-content: flex-start;margin-left: 10px;text-align: left;">{{
                                                item.categoryName }}</span></span>
                                    <span style="display: flex;flex: 2.5;justify-content: flex-end;"><span
                                            style="margin-right: 19px;">{{ item.fundSize ==
                                                "" ? "--" : parseFloat(item.fundSize).toFixed(2) }}</span></span>
                                    <span style="display: flex;flex: 1.5;justify-content: flex-end;">{{ item.index ==
                                        true ? '是' : '否' }}</span>
                                    <span style="display: flex;flex: 2;justify-content: flex-end;">{{ item.init == true
                                        ?
                                        '是' : '否' }}</span>
                                </div>
                            </div>

                            <div class="cpct-area3" v-show="page4FundCountShow">
                                <div class="cpct-box3">
                                    <div class="gm-row2" style="width: 200px;">
                                        <span
                                            style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">基金数量</span>
                                        <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                            companyIndexInfo.miniFundCount }}</span>
                                    </div>
                                    <div class="gm-row2" style="width: 200px;">
                                        <span
                                            style="display: flex;flex: 2;justify-content: flex-start;font-weight: 550;">数量占比</span>
                                        <span style="display: flex;flex: 1;justify-content: flex-end;">{{
                                            companyIndexInfo.miniFundCountRatio }}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="content-main3-area">
                            <div class="bottom1-area">
                                <span style="font-weight:600;">数据来源：</span><span>Morningstar（晨星）；数据截⾄{{
                                    companyReportData.latestDate }}，如⽆特殊说明以⼈⺠币计算。</span>
                            </div>
                            <div class="bottom2-area">
                                <span
                                    style="font-weight:600;">免责声明：</span><span>晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况
                                    下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深
                                    圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。</span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";
import { getFundCache, getFundRank, getCompanyEvaluate, getCompanyReportData } from "../api/ranking";
import { loadingData } from "./mixin/loadingData";
import htmlToPdf from '../../components/api/htmlToPdf';
import companyStar from "../../public/images/star.svg";
import companyStarWhite from "../../public/images/star01.svg";
import companyStarMark from "../../public/images/star02.svg";
import companyStar2 from "../../public/images/star03.svg";
import companyStar4 from "../../public/images/star04.svg";
import MSlogo from "../../public/images/MSlogo.svg";
import TDGLlogo from "../../public/images/gltd.svg";
import GMlogo from "../../public/images/gm.svg";
import ZJLlogo from "../../public/images/zjl.svg";
import FLlogo from "../../public/images/fl.svg";
import YJPFlogo from "../../public/images/yjpf.svg";
import CPXlogo from "../../public/images/cpx.svg";

const componentsCommon = require("cb-components-common").default;
const checkResponseStatus = componentsCommon.common.checkResponseStatus;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;

export default {
    mixins: [loadingData],
    data() {
        return {
            orgOptions: {
                textStyle: {
                    fontFamily: 'intrinsic'
                },
                tooltip: {
                    trigger: 'item'
                },
                color: ['#960000', '#EC7524', '#31589F', '#FFC50D', '#7F7F7F'],
                series: [
                    {
                        name: '产品线',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '40',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 1048, name: '股票' },
                            { value: 735, name: '混合' },
                            { value: 580, name: '固收' },
                            { value: 484, name: '货币' },
                            { value: 300, name: '其它' }
                        ]
                    }
                ]
            },

            orgOptions2: {
                textStyle: {
                    fontFamily: 'intrinsic'
                },
                tooltip: {
                    trigger: 'item'
                },
                color: ['#31589F', '#EC7524'],
                series: [
                    {
                        name: '产品线',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '40',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 735, name: '主动' },
                            { value: 580, name: '指数' },
                        ]
                    }
                ]
            },
            companyStar,
            companyStarMark,
            companyStar2,
            companyStar4,
            MSlogo,
            TDGLlogo,
            GMlogo,
            ZJLlogo,
            FLlogo,
            YJPFlogo,
            CPXlogo,
            companyStarWhite,

            dateList: [],
            totalRisksList: [],

            disabledButton: false,
            symbol: "",
            imageUrl: "image_url_minus",
            searchPopoverVisible: false,
            symbolList: [],
            fundStatus: "",
            marketRiskPortraitDate: "",
            fundRiskMarketTimeout: null,
            fundRiskMarketTimeoutUpdate: null,
            showFundRiskMarketChart: false,
            showFund: false,
            loading: false,
            flexRatioHeight: '180px',
            pagination: {
                skip: 0,
                limit: 12,
                count: 0,
            },
            params: {
                sort: "effectiveDate",
                order: "desc",
                limit: 12,
                skip: 0,
                page: 1,
            },
            fundInfo: {
                symbol: "",
                className: "",
                ipoDate: "",
                inceptionDate: "",
                specialCategory: "",
                totalNetAsset: "",
                status: "",
                riskText: "",
            },
            tableData: [],
            timeout: null,
            showAddOrRemoveMyList: false,
            showTerminatedFundInfo: false,

            companyReportData: [],
            companyData: [],
            companyIndexInfo: [],
            contentInfoData: "",
            attributeData: "",
            fundSize1YText: "",
            fundSize3YText: "",
            raiseOrDown1Y: "",
            raiseOrDown3Y: "",
            typeSum1: "",
            typeSum2: "",
            typeSum3: "",
            terscoreText: "",
            comfortableText: "",
            height5: "",
            height4: "",
            height3: "",
            height2: "",
            height1: "",
            width1: "",
            width2: "",
            width3: "",
            starWidth: "",
            starNum: "",
            showStar: true,
            showStar2: true,
            showStar3: false,
            showStar4: false,
            showStarQuarter2: false,
            showStarQuarter4: false,
            shortName: "",
            quarterStr: "",

            loading: true,

            cityShow: true,
            gdShow: true,
            ywShow: true,
            tsShow: true,
            gmShow: true,
            gmrShow: true,
            zj1yShow: true,
            zj1yrShow: true,
            zj1ytbShow: true,
            zj3yShow: true,
            zj3yrShow: true,
            zj3ytbShow: true,
            cpxShow: true,
            zhpjShow: true,
            zhpjbjShow: true,
            zhpjrShow: true,
            zdcpShow: true,
            pgcpShow: true,
            gscpShow: true,
            flShow: true,
            jlrsShow: true,
            glnxShow: true,
            jjpmShow: true,
            jsnlzlShow: true,
            wdxShow: true,

            starNumBlack: "",
            showNumWhite: "",
            showStarQuarter1: false,
            showStarQuarter2: false,
            showStarQuarter4: false,

            // numList: [0,10,20,30,40,50]
            num1: '0px',
            num2: '0px',
            num3: '0px',

            middleNum1: '0px',
            middleNum2: '0px',
            middleNum3: '0px',

            scoreNum1: '0px',
            scoreNum2: '0px',
            scoreNum3: '0px',

            mark1: '0',
            mark2: '10',
            mark3: '20',
            mark4: '30',
            mark5: '40',
            mark6: '50',

            progressNum1: '0px',
            progressNum2: '0px',
            progressNum3: '0px',

            progressWidth1: '20px',
            progressWidth2: '0px',
            progressWidth3: '0px',

            survivalRatio: [],
            survivalAvg: [],
            survivalRank: [],
            successRatio: [],
            successAvg: [],
            successRank: [],

            fundInflow: [],
            fundOutflow: [],

            newFund: [],
            miniFund: [],
            obsoleteFund: [],
            // 第 0 项渲染在产品动态所在页，其余项按续页动态渲染。
            fundPages: [],

            newFundTemp1: [],
            newFundTemp2: [],

            miniFundTemp1: [],
            miniFundTemp2: [],
            miniFundTemp3: [],
            miniFundTemp4: [],

            Hflex: true,
            page3Show: false,
            page4Show: false,

            obsoleteFundShow: true,
            miniFundShow: true,
            obsoleteFundShow2: false,
            miniFundShow2: false,
            newFundTempShow2: false,

            Dheight: 'auto',
            page2Show: false,
            page1FundCountShow: false,
            bottomShow: true,

            indexFundSizeRank: '--',
            equityIndexFundSizeRank: '--',
            enhanceIndexFundSizeRank: '--',
            nonEquityFundSizeRank: '--',
            nonMoneyMarketFundCountRank: '--',

            borderTop: '1.5px solid #b1b0b0',
            borderBottom: '1.5px solid #b1b0b0',
            heightAuto: 'auto',
            miniH: '110px',

            cpxFlexHeight: '465px',
            cpxBorderBottom: '1.5px solid #b1b0b0',


            page1NewFundShow: false,
            page1ObsoleteFundShow: false,
            page1MiniFundShow: false,
            page2NewFundShow: false,
            page2ObsoleteFundShow: false,
            page2MiniFundShow: false,
            page3MiniFundShow: false,
            page4MiniFundShow: false,

            page1NewFundList: [],
            page1ObsoleteFundList: [],
            page1MiniFundList: [],
            page2NewFundList: [],
            page2ObsoleteFundList: [],
            page2MiniFundList: [],
            page3MiniFundList: [],
            page4MiniFundList: [],

            page2FundCountShow: false,
            page3FundCountShow: false,
            page4FundCountShow: false


        };
    },
    mounted() {
        const self = this;
        let userId = getNameAndValue("id");

        if (!userId || userId === "undefined" || userId === "null") {
            userId = "";
        } else {
            try {
                userId = JSON.parse(userId);
            } catch (e) {
                console.error("Error parsing userId:", e);
            }
        }

        const companyId = this.$route.params.companyId || this.$route.query.companyId;
        let data = {
            userId,
            // 路由 params 刷新后会丢失，优先兼容 params，并从 URL query 恢复公司 ID。
            companyId
        };
        getCompanyReportData(data)
            .then(async response => {
                let result = response.data.data;
                if (result != undefined && checkResponseStatus(result, self)) {
                    this.companyReportData = result;
                    this.companyData = result.selectInfo;
                    this.companyIndexInfo = result.companyIndexInfo;
                    this.fundInflow = result.companyIndexInfo.fundInflow;
                    this.fundOutflow = result.companyIndexInfo.fundOutflow;

                    if (result.companyIndexInfo != null) {
                        if (result.companyIndexInfo.indexFundSizeRank != "" || result.companyIndexInfo.indexFundSizeRank != null) {
                            this.indexFundSizeRank = result.companyIndexInfo.indexFundSizeRank;
                        }
                        if (result.companyIndexInfo.equityIndexFundSizeRank != "" || result.companyIndexInfo.equityIndexFundSizeRank != null) {
                            this.equityIndexFundSizeRank = result.companyIndexInfo.equityIndexFundSizeRank;
                        }
                        if (result.companyIndexInfo.enhanceIndexFundSizeRank != "" || result.companyIndexInfo.enhanceIndexFundSizeRank != null) {
                            this.enhanceIndexFundSizeRank = result.companyIndexInfo.enhanceIndexFundSizeRank;
                        }
                        if (result.companyIndexInfo.nonEquityFundSizeRank != "" || result.companyIndexInfo.nonEquityFundSizeRank != null) {
                            this.nonEquityFundSizeRank = result.companyIndexInfo.nonEquityFundSizeRank;
                        }
                        if (result.companyIndexInfo.nonMoneyMarketFundCountRank != "" || result.companyIndexInfo.nonMoneyMarketFundCountRank != null) {
                            this.nonMoneyMarketFundCountRank = result.companyIndexInfo.nonMoneyMarketFundCountRank;
                        }

                        if (result.companyIndexInfo.survivalRatio[0] == '0' && result.companyIndexInfo.successRatio[0] == '0') {
                            this.flexRatioHeight = '135px';
                        }
                        if (result.companyIndexInfo.survivalRatio[1] == '0' && result.companyIndexInfo.successRatio[1] == '0') {
                            this.flexRatioHeight = '135px';
                        }
                        if (result.companyIndexInfo.survivalRatio[2] == '0' && result.companyIndexInfo.successRatio[2] == '0') {
                            this.flexRatioHeight = '135px';
                        }
                        if (result.companyIndexInfo.survivalRatio[1] == '0' && result.companyIndexInfo.successRatio[1] == '0' && result.companyIndexInfo.survivalRatio[0] == '0' && result.companyIndexInfo.successRatio[0] == '0') {
                            this.flexRatioHeight = '90px';
                        }
                        if (result.companyIndexInfo.survivalRatio[0] == '0' && result.companyIndexInfo.successRatio[0] == '0' && result.companyIndexInfo.survivalRatio[2] == '0' && result.companyIndexInfo.successRatio[2] == '0') {
                            this.flexRatioHeight = '90px';
                        }
                        if (result.companyIndexInfo.survivalRatio[1] == '0' && result.companyIndexInfo.successRatio[1] == '0' && result.companyIndexInfo.survivalRatio[2] == '0' && result.companyIndexInfo.successRatio[2] == '0') {
                            this.flexRatioHeight = '90px';
                        }
                        if (result.companyIndexInfo.survivalRatio[2] == '0' && result.companyIndexInfo.successRatio[2] == '0' && result.companyIndexInfo.survivalRatio[1] == '0' && result.companyIndexInfo.successRatio[1] == '0' && result.companyIndexInfo.survivalRatio[0] == '0' && result.companyIndexInfo.successRatio[0] == '0') {
                            this.flexRatioHeight = '180px';
                        }

                        if (result.companyIndexInfo.passivityFundSizeRatio == 0) {
                            this.cpxFlexHeight = '276px';
                            this.cpxBorderBottom = 'none';
                        }
                    }

                    this.survivalRatio = result.companyIndexInfo.survivalRatio;
                    this.survivalAvg = result.companyIndexInfo.survivalAvg;
                    this.survivalRank = result.companyIndexInfo.survivalRank;
                    this.successRatio = result.companyIndexInfo.successRatio;
                    this.successAvg = result.companyIndexInfo.successAvg;
                    this.successRank = result.companyIndexInfo.successRank;

                    this.newFund = result.companyIndexInfo.newFund;


                    this.obsoleteFund = result.companyIndexInfo.obsoleteFund;

                    this.miniFund = result.companyIndexInfo.miniFund;

                    this.shortName = result.shortName;
                    this.quarterStr = result.quarterStr;
                    if (result.contentDataList != "" || result.contentDataList != null) {
                        result.contentDataList.map((item) => {
                            this.contentInfoData += item + "、";
                        })
                        this.contentInfoData = this.contentInfoData.substring(0, this.contentInfoData.lastIndexOf("、"));
                    }
                    if (result.attributeDataList != "" || result.attributeDataList != null) {
                        result.attributeDataList.map((item) => {
                            this.attributeData += item + "、";
                        })
                        this.attributeData = this.attributeData.substring(0, this.attributeData.lastIndexOf("、"));
                        if (result.attributeDataList.length == 1) {
                            this.tsShow = false;
                        }
                    }
                    if (result.selectInfo.fundSizeFlow_1Y != "" || result.selectInfo.fundSizeFlow_1Y != null) {
                        if (parseFloat(result.selectInfo.fundSizeFlow_1Y) > 0) {
                            this.fundSize1YText = "净流入";
                            this.raiseOrDown1Y = "增长";
                        } else {
                            this.fundSize1YText = "净流出";
                            this.raiseOrDown1Y = "减少";
                        }
                    }
                    if (result.selectInfo.fundSizeFlow_3Y != "" || result.selectInfo.fundSizeFlow_3Y != null) {
                        if (parseFloat(result.selectInfo.fundSizeFlow_3Y) > 0) {
                            this.fundSize3YText = "净流入";
                            this.raiseOrDown3Y = "增长";
                        } else {
                            this.fundSize3YText = "净流出";
                            this.raiseOrDown3Y = "减少";
                        }
                    }
                    if (result.selectInfo.sizeType == 1) {
                        this.typeSum1 = result.selectInfo.allBigSum;
                    } else if (result.selectInfo.sizeType == 2) {
                        this.typeSum1 = result.selectInfo.allMiddleSum;
                    } else if (result.selectInfo.sizeType == 3) {
                        this.typeSum1 = result.selectInfo.allSmallSum;
                    }
                    if (result.selectInfo.eqallocsizeType == 1) {
                        this.typeSum2 = result.selectInfo.eqallocbigSum;
                    } else if (result.selectInfo.eqallocsizeType == 2) {
                        this.typeSum2 = result.selectInfo.eqallocmiddleSum;
                    } else if (result.selectInfo.eqallocsizeType == 3) {
                        this.typeSum2 = result.selectInfo.eqallocsmallSum;
                    }
                    if (result.selectInfo.fxincsizeType == 1) {
                        this.typeSum3 = result.selectInfo.fxincbigSum;
                    } else if (result.selectInfo.fxincsizeType == 2) {
                        this.typeSum3 = result.selectInfo.fxincmiddleSum;
                    } else if (result.selectInfo.fxincsizeType == 3) {
                        this.typeSum3 = result.selectInfo.fxincsmallSum;
                    }
                    if (result.selectInfo.terscore != "" || result.selectInfo.terscore != null) {
                        if (parseFloat(result.selectInfo.terscore).toFixed(0) >= 55) {
                            this.terscoreText = "偏低";
                        } else if (45 < parseFloat(result.selectInfo.terscore).toFixed(0) < 55) {
                            this.terscoreText = "适中";
                        } else if (parseFloat(result.selectInfo.terscore).toFixed(0) <= 45) {
                            this.terscoreText = "偏高";
                        }
                    }
                    if (result.selectInfo.retention_3Y != "" || result.selectInfo.retention_3Y != null) {
                        if (parseFloat(result.selectInfo.retention_3Y).toFixed(2) > result.medianVal) {
                            this.comfortableText = "高于";
                        } else if (parseFloat(result.selectInfo.retention_3Y).toFixed(2) < result.medianVal) {
                            this.comfortableText = "低于";
                        } else if (parseFloat(result.selectInfo.retention_3Y).toFixed(2) == result.medianVal) {
                            this.comfortableText = "等于";
                        }
                    }
                    if (result.selectInfo.star5Per != "" || result.selectInfo.star5Per != null) {
                        this.height5 = (parseFloat(result.selectInfo.star5Per).toFixed(0) / 100) * 85 + "%";
                        if (parseFloat(this.height5) < 1) {
                            this.height5 = "1%";
                        }
                    } else {
                        this.height5 = "1%";
                    }
                    if (result.selectInfo.star4Per != "" || result.selectInfo.star4Per != null) {
                        this.height4 = (parseFloat(result.selectInfo.star4Per).toFixed(0) / 100) * 85 + "%";
                        if (parseFloat(this.height4) < 1) {
                            this.height4 = "1%";
                        }
                    } else {
                        this.height4 = "1%";
                    }
                    if (result.selectInfo.star3Per != "" || result.selectInfo.star3Per != null) {
                        this.height3 = (parseFloat(result.selectInfo.star3Per).toFixed(0) / 100) * 85 + "%";
                        if (parseFloat(this.height3) < 1) {
                            this.height3 = "1%";
                        }
                    } else {
                        this.height3 = "1%";
                    }
                    if (result.selectInfo.star2Per != "" || result.selectInfo.star2Per != null) {
                        this.height2 = (parseFloat(result.selectInfo.star2Per).toFixed(0) / 100) * 85 + "%";
                        if (parseFloat(this.height2) < 1) {
                            this.height2 = "1%";
                        }
                    } else {
                        this.height2 = "1%";
                    }
                    if (result.selectInfo.star1Per != "" || result.selectInfo.star1Per != null) {
                        this.height1 = (parseFloat(result.selectInfo.star1Per).toFixed(0) / 100) * 85 + "%";
                        if (parseFloat(this.height1) < 1) {
                            this.height1 = "1%";
                        }
                    } else {
                        this.height1 = "1%";
                    }

                    if (result.selectInfo.companyScoreRaw != "" || result.selectInfo.companyScoreRaw != null) {
                        this.width1 = parseFloat(result.selectInfo.companyScoreRaw).toFixed(0) + "%";
                        if (parseFloat(this.width1) < 1) {
                            this.width1 = "1%";
                        }
                    } else {
                        this.width1 = "1%";
                    }
                    if (result.selectInfo.eqalloccompanyScoreRaw != "" || result.selectInfo.eqalloccompanyScoreRaw != null) {
                        this.width2 = parseFloat(result.selectInfo.eqalloccompanyScoreRaw).toFixed(0) + "%";
                        if (parseFloat(this.width2) < 1) {
                            this.width2 = "1%";
                        }
                    } else {
                        this.width2 = "1%";
                    }

                    if (result.selectInfo.fxinccompanyScoreRaw != "" || result.selectInfo.fxinccompanyScoreRaw != null) {
                        this.width3 = parseFloat(result.selectInfo.fxinccompanyScoreRaw).toFixed(0) + "%";
                        if (parseFloat(this.width3) < 1) {
                            this.width3 = "0%";
                        }
                    } else {
                        this.width3 = "0%";
                    }

                    if (this.companyData.companyMinScoreRawRank == null || this.companyData.companyMaxScoreRawRank == null) {
                        this.progressNum1 = "0px";
                    }
                    if (this.companyData.eqalloccompanyMinScoreRawRank == null || this.companyData.eqalloccompanyMaxScoreRawRank == null) {
                        this.progressNum2 = "0px";
                    }
                    if (this.companyData.fxinccompanyMinScoreRawRank == null || this.companyData.fxinccompanyMaxScoreRawRank == null) {
                        this.progressNum3 = "0px";
                    }

                    if (this.companyData.companyMiddleScoreRawRank == null) {
                        this.middleNum1 = "0px";
                    }
                    if (this.companyData.eqalloccompanyMiddleScoreRawRank == null) {
                        this.middleNum2 = "0px";
                    }
                    if (this.companyData.fxinccompanyMiddleScoreRawRank == null) {
                        this.middleNum3 = "0px";
                    }

                    if (this.companyData.companyScoreRaw == null) {
                        this.scoreNum1 = "0px";
                    }
                    if (this.companyData.eqalloccompanyScoreRaw == null) {
                        this.scoreNum2 = "0px";
                    }
                    if (this.companyData.fxinccompanyScoreRaw == null) {
                        this.scoreNum3 = "0px";
                    }

                    if (this.companyData.stepNum != null) {
                        // if (this.companyData.stepNum == 10) {

                        //     if (this.companyData.companyMinScoreRawRank != null) {
                        //         this.progressNum1 = ((this.companyData.companyMinScoreRawRank - this.companyData.minNum) * 9.4) + "px";
                        //     }
                        //     if (this.companyData.companyMinScoreRawRank != null && this.companyData.companyMaxScoreRawRank != null) {
                        //         this.progressWidth1 = ((this.companyData.companyMaxScoreRawRank - this.companyData.companyMinScoreRawRank) * 9.4) + "px";
                        //     }

                        //     if (this.companyData.eqalloccompanyMinScoreRawRank != null) {
                        //         this.progressNum2 = ((this.companyData.eqalloccompanyMinScoreRawRank - this.companyData.minNum) * 9.4) + "px";
                        //     }
                        //     if (this.companyData.eqalloccompanyMinScoreRawRank != null && this.companyData.eqalloccompanyMaxScoreRawRank != null) {
                        //         this.progressWidth2 = ((this.companyData.eqalloccompanyMaxScoreRawRank - this.companyData.eqalloccompanyMinScoreRawRank) * 9.4) + "px";
                        //     }

                        //     if (this.companyData.fxinccompanyMinScoreRawRank != null) {
                        //         this.progressNum3 = ((this.companyData.fxinccompanyMinScoreRawRank - this.companyData.minNum) * 9.4) + "px";
                        //     }
                        //     if (this.companyData.fxinccompanyMinScoreRawRank != null && this.companyData.fxinccompanyMaxScoreRawRank != null) {
                        //         this.progressWidth3 = ((this.companyData.fxinccompanyMaxScoreRawRank - this.companyData.fxinccompanyMinScoreRawRank) * 9.4) + "px";
                        //     }

                        //     this.scoreNum1 = ((this.companyData.companyScoreRawInt-this.companyData.companyMinScoreRawRank) * 9.8) + "px";
                        //     this.scoreNum2 = ((this.companyData.eqalloccompanyScoreRawInt-this.companyData.eqalloccompanyMinScoreRawRank) * 9.8) + "px";
                        //     this.scoreNum3 = ((this.companyData.fxinccompanyScoreRawInt-this.companyData.fxinccompanyMinScoreRawRank) * 9.8) + "px";

                        //     // this.num1 = ((this.companyData.companyScoreRawInt-this.companyData.minNum) * 9) + "px";
                        //     // this.num2 = ((this.companyData.eqalloccompanyScoreRawInt-this.companyData.minNum) * 9) + "px";
                        //     // this.num3 = ((this.companyData.fxinccompanyScoreRawInt-this.companyData.minNum) * 9) + "px";
                        //     this.num1 = this.companyData.companyScoreRawInt * 4.55 + "px";
                        //     this.num2 = this.companyData.eqalloccompanyScoreRawInt * 4.55 + "px";
                        //     this.num3 = this.companyData.fxinccompanyScoreRawInt * 4.55 + "px";

                        //     this.middleNum1 = ((this.companyData.companyMiddleScoreRawRank-this.companyData.minNum) * 8.4 - (this.companyData.companyMinScoreRawRank-this.companyData.minNum) * 8.4) + "px";
                        //     this.middleNum2 = ((this.companyData.eqalloccompanyMiddleScoreRawRank-this.companyData.minNum) * 8.4 - (this.companyData.eqalloccompanyMinScoreRawRank-this.companyData.minNum) * 8.4) + "px";
                        //     this.middleNum3 = ((this.companyData.fxinccompanyMiddleScoreRawRank-this.companyData.minNum) * 8.4 - (this.companyData.fxinccompanyMinScoreRawRank-this.companyData.minNum) * 8.4) + "px";

                        // } 
                        // else {
                        this.companyData.minNum = 0;
                        if (this.companyData.companyMinScoreRawRank != null) {

                            this.progressNum1 = ((this.companyData.companyMinScoreRawRank - this.companyData.minNum) * 2.3) + "px";
                        }
                        if (this.companyData.companyMinScoreRawRank != null && this.companyData.companyMaxScoreRawRank != null) {
                            this.progressWidth1 = ((this.companyData.companyMaxScoreRawRank - this.companyData.companyMinScoreRawRank) * 2.6) + "px";
                        }

                        if (this.companyData.eqalloccompanyMinScoreRawRank != null) {
                            this.progressNum2 = ((this.companyData.eqalloccompanyMinScoreRawRank - this.companyData.minNum) * 2.3) + "px";
                        }
                        if (this.companyData.eqalloccompanyMinScoreRawRank != null && this.companyData.eqalloccompanyMaxScoreRawRank != null) {
                            this.progressWidth2 = ((this.companyData.eqalloccompanyMaxScoreRawRank - this.companyData.eqalloccompanyMinScoreRawRank) * 2.6) + "px";
                        }

                        if (this.companyData.fxinccompanyMinScoreRawRank != null) {
                            this.progressNum3 = ((this.companyData.fxinccompanyMinScoreRawRank - this.companyData.minNum) * 2.3) + "px";
                        }
                        if (this.companyData.fxinccompanyMinScoreRawRank != null && this.companyData.fxinccompanyMaxScoreRawRank != null) {
                            this.progressWidth3 = ((this.companyData.fxinccompanyMaxScoreRawRank - this.companyData.fxinccompanyMinScoreRawRank) * 2.6) + "px";
                        }

                        // this.scoreNum1 = ((this.companyData.companyScoreRawInt-this.companyData.companyMinScoreRawRank) * 9.8) + "px";
                        this.scoreNum1 = this.companyData.companyScoreRawInt * 2.2 + "px";
                        this.scoreNum2 = this.companyData.eqalloccompanyScoreRawInt * 2.2 + "px";
                        this.scoreNum3 = this.companyData.fxinccompanyScoreRawInt * 2.2 + "px";

                        this.num1 = this.companyData.companyScoreRawInt * 2.15 + "px";
                        this.num2 = this.companyData.eqalloccompanyScoreRawInt * 2.15 + "px";
                        this.num3 = this.companyData.fxinccompanyScoreRawInt * 2.15 + "px";

                        // this.middleNum1 = ((this.companyData.companyMiddleScoreRawRank-this.companyData.minNum) * 3 - (this.companyData.companyMinScoreRawRank-this.companyData.minNum) * 2.8) + "px";
                        // this.middleNum2 = ((this.companyData.eqalloccompanyMiddleScoreRawRank-this.companyData.minNum) * 3 - (this.companyData.eqalloccompanyMinScoreRawRank-this.companyData.minNum) * 2.8) + "px";
                        // this.middleNum3 = ((this.companyData.fxinccompanyMiddleScoreRawRank-this.companyData.minNum) * 3 - (this.companyData.fxinccompanyMinScoreRawRank-this.companyData.minNum) * 2.8) + "px";
                        this.middleNum1 = this.companyData.companyMiddleScoreRawRank * 2.3 + "px";
                        this.middleNum2 = this.companyData.eqalloccompanyMiddleScoreRawRank * 2.3 + "px";
                        this.middleNum3 = this.companyData.fxinccompanyMiddleScoreRawRank * 2.3 + "px";

                        // }
                    }

                    //处理加权星级遮罩部分
                    // if (result.selectInfo.aumweightedStar != "" || result.selectInfo.aumweightedStar != null) {
                    //     var index = result.selectInfo.aumweightedStar.lastIndexOf(".");
                    //     //获取小数部分
                    //     var dataStr = result.selectInfo.aumweightedStar.substr(index+1,result.selectInfo.aumweightedStar.length);
                    //     if (dataStr !== "" || dataStr !== '00') {
                    //         this.starWidth = parseFloat(dataStr)+"%";
                    //     } else {
                    //         this.showStar = false;
                    //     }

                    //     if (dataStr < 0.25) {
                    //         this.showStar = false;
                    //     } else if (0.25 <= dataStr < 0.5) {
                    //         this.showStarQuarter2 = true;
                    //     } else if (0.5 <= dataStr < 0.75) {
                    //         this.showStar = true;
                    //     } else if (0.75 <= dataStr < 1) {
                    //         this.showStarQuarter4 = true;
                    //     }
                    //     //获取整数部分
                    //     var dataStr2 = result.selectInfo.aumweightedStar.substr(0,index);
                    //     if (dataStr2 != "" || dataStr2 != 0) {
                    //         this.starNum = dataStr2;
                    //     } else {
                    //         this.starNum = "0";
                    //     }
                    //     if (dataStr2 == "" || dataStr2 == null) {
                    //         this.showStar4 = true;
                    //     }
                    //     //判断是否需要白底星星
                    //     if (dataStr2 >=4) {
                    //         this.showStar2 = false;
                    //     }
                    // }
                    this.orgOptions.series[0].data[0].value = result.selectInfo.equity;
                    this.orgOptions.series[0].data[1].value = result.selectInfo.alloc;
                    this.orgOptions.series[0].data[2].value = result.selectInfo.fxinc;
                    this.orgOptions.series[0].data[3].value = result.selectInfo.mnmkt;
                    this.orgOptions.series[0].data[4].value = result.selectInfo.other;

                    this.orgOptions2.series[0].data[0].value = result.companyIndexInfo.activeFundSizeRatio;
                    this.orgOptions2.series[0].data[1].value = result.companyIndexInfo.passivityFundSizeRatio;

                    if (result.province == "" || result.province == null) {
                        this.cityShow = false;
                    }
                    if (result.contentDataList == "" || result.contentDataList == null) {
                        this.gdShow = false;
                    }
                    if (result.attributeDataList == "" || result.attributeDataList == null) {
                        this.ywShow = false;
                    }
                    if (result.selectInfo.fundSize == "" || result.selectInfo.fundSize == null) {
                        this.gmShow = false;
                    }
                    if (result.fundSizeRankSize == "" || result.fundSizeRankSize == null) {
                        this.gmrShow = false;
                    }
                    if (result.selectInfo.fundSizeRank == "" || result.selectInfo.fundSizeRank == null) {
                        this.gmrShow = false;
                    }
                    if (result.selectInfo.fundSizeFlow_1Y == "" || result.selectInfo.fundSizeFlow_1Y == null) {
                        this.zj1yShow = false;
                    }
                    if (this.fundSize1YText == "" || this.fundSize1YText == null) {
                        this.zj1yShow = false;
                    }

                    if (result.selectInfo.fundSizeFlowRank_1Y == "" || result.selectInfo.fundSizeFlowRank_1Y == null) {
                        this.zj1yrShow = false;
                    }
                    if (result.fundSizeFlowRank1YSize == "" || result.fundSizeFlowRank1YSize == null) {
                        this.zj1yrShow = false;
                    }
                    if (result.selectInfo.fundSizeFlowPer_1Y == "" || result.selectInfo.fundSizeFlowPer_1Y == null) {
                        this.zj1ytbShow = false;
                    }
                    if (this.raiseOrDown1Y == "" || this.raiseOrDown1Y == null) {
                        this.zj1ytbShow = false;
                    }
                    if (result.selectInfo.fundSizeFlow_3Y == "" || result.selectInfo.fundSizeFlow_3Y == null) {
                        this.zj3yShow = false;
                    }
                    if (this.fundSize3YText == "" || this.fundSize3YText == null) {
                        this.zj3yShow = false;
                    }
                    if (result.selectInfo.fundSizeFlowRank_3Y == "" || result.selectInfo.fundSizeFlowRank_3Y == null) {
                        this.zj3yrShow = false;
                    }
                    if (result.selectInfo.fundSizeFlowPer_3Y == "" || result.selectInfo.fundSizeFlowPer_3Y == null) {
                        this.zj3ytbShow = false;
                    }
                    if (this.raiseOrDown3Y == "" || this.raiseOrDown3Y == null) {
                        this.zj3ytbShow = false;
                    }

                    if (result.productionData == "" || result.productionData == null) {
                        this.cpxShow = false;
                    }
                    if (result.selectInfo.aumweightedStar == "" || result.selectInfo.aumweightedStar == null) {
                        this.zhpjShow = false;
                    }
                    if (result.compareStarStr == "" || result.compareStarStr == null) {
                        this.zhpjbjShow = false;
                    }
                    if (result.aumWeightStarRank == "" || result.aumWeightStarRank == null) {
                        this.zhpjrShow = false;
                    }
                    if (this.typeSum1 == "" || this.typeSum1 == null) {
                        this.zdcpShow = false;
                    }
                    if (result.selectInfo.sizeType == "" || result.selectInfo.sizeType == null) {
                        this.zdcpShow = false;
                    }
                    if (result.selectInfo.companyScoreRawRank == "" || result.selectInfo.companyScoreRawRank == null) {
                        this.zdcpShow = false;
                    }
                    if (this.typeSum2 == "" || this.typeSum2 == null) {
                        this.pgcpShow = false;
                    }
                    if (result.selectInfo.eqallocsizeType == "" || result.selectInfo.eqallocsizeType == null) {
                        this.pgcpShow = false;
                    }
                    if (result.selectInfo.eqalloccompanyScoreRawRank == "" || result.selectInfo.eqalloccompanyScoreRawRank == null) {
                        this.pgcpShow = false;
                    }
                    if (this.typeSum3 == "" || this.typeSum3 == null) {
                        this.gscpShow = false;
                    }
                    if (result.selectInfo.fxincsizeType == "" || result.selectInfo.fxincsizeType == null) {
                        this.gscpShow = false;
                    }
                    if (result.selectInfo.fxinccompanyScoreRawRank == "" || result.selectInfo.fxinccompanyScoreRawRank == null) {
                        this.gscpShow = false;
                    }
                    if (this.terscoreText == "" || this.terscoreText == null) {
                        this.flShow = false;
                    }

                    if (result.selectInfo.managerCount == "" || result.selectInfo.managerCount == null) {
                        this.jlrsShow = false;
                    }
                    if (result.selectInfo.managerCareerTime == "" || result.selectInfo.managerCareerTime == null) {
                        this.glnxShow = false;
                    }
                    if (result.selectInfo.managerCareerTimeRank == "" || result.selectInfo.managerCareerTimeRank == null) {
                        this.jjpmShow = false;
                    }
                    if (result.selectInfo.retention_3Y == "" || result.selectInfo.retention_3Y == null) {
                        this.jsnlzlShow = false;
                    }
                    if (this.comfortableText == "" || this.comfortableText == null) {
                        this.wdxShow = false;
                    }

                    if (!result.isStartShow) {
                        this.showStar = false;
                        if (this.starNum != '5') {
                            this.showStar3 = true;
                        }
                    }


                    this.starNumBlack = result.starBlackNum;
                    this.showNumWhite = result.starWhiteNum;

                    if (result.num == 1) {
                        this.showStarQuarter2 = true;
                    } else if (result.num == 2) {
                        this.showStarQuarter1 = true;
                    } else if (result.num == 3) {
                        this.showStarQuarter4 = true;
                    }

                    // 前置模块的显隐和高度稳定后再测量产品动态，避免首页剩余高度失真。
                    await this.initFundPage();
                }
            }).finally(r => {
                this.loading = false;
            });
    },
    methods: {
        handleDown() {
            htmlToPdf.downloadPDF(document.querySelector('#demo'), this.shortName + '基金量化数据报告(' + this.quarterStr + ')');
        },
        returnBack() {
            this.$router.push({ path: '/company-evaluate' });
        },
        formatFundDate(value) {
            return value ? String(value).substr(0, 10) : '--';
        },
        formatFundRatio(value) {
            return value === '' || value === null || value === undefined
                ? '--'
                : `${parseFloat(value).toFixed(2)}%`;
        },
        fundSectionTitle(type) {
            return {
                newFund: '新发基金(近一年)',
                obsoleteFund: '基金清盘(近一年)',
                miniFund: '迷你基金(规模不足一亿)'
            }[type] || '';
        },
        async initFundPage() {
            // 先让离屏测量容器按最终宽度完成排版。
            await this.$nextTick();
            if (document.fonts && document.fonts.ready) {
                await document.fonts.ready;
            }
            await new Promise(resolve => {
                requestAnimationFrame(() => requestAnimationFrame(resolve));
            });

            const measureRoot = this.$refs.fundMeasureRef;
            const productPage = this.$refs.productReportPageRef;
            const fundStart = this.$refs.page1FundStartRef;
            if (!measureRoot || !productPage || !fundStart) {
                console.warn('产品动态分页所需的测量节点不存在');
                return;
            }

            const pageTop = productPage.querySelector('.top-area');
            const pageFooter = productPage.querySelector('.content-main3-area');
            const footerTop = pageFooter.getBoundingClientRect().top;
            const safetyGap = 2;
            const firstPageHeight = Math.max(
                0,
                footerTop - fundStart.getBoundingClientRect().top - safetyGap
            ) || 762;
            const continuationHeight = Math.max(
                0,
                footerTop - pageTop.getBoundingClientRect().bottom - safetyGap
            ) || 1214;

            const outerHeight = element => {
                if (!element) return 0;
                const style = window.getComputedStyle(element);
                return element.getBoundingClientRect().height
                    + parseFloat(style.marginTop || 0)
                    + parseFloat(style.marginBottom || 0);
            };
            const emptyHeight = outerHeight(this.$refs.fundMeasureEmptyRef) || 40;
            const summaryHeight = outerHeight(this.$refs.fundMeasureSummaryRef) || 70;
            const measureRect = measureRoot.getBoundingClientRect();
            const px = value => parseFloat(value || 0) || 0;
            const createSectionMetrics = (type, sectionRef, headerRef) => {
                const sectionElement = this.$refs[sectionRef];
                const sectionStyle = window.getComputedStyle(sectionElement);
                const rows = Array.from(sectionElement.querySelectorAll(`[data-fund-type="${type}"]`))
                    .sort((left, right) => Number(left.dataset.fundIndex) - Number(right.dataset.fundIndex))
                    .map(row => {
                        const rect = row.getBoundingClientRect();
                        return {
                            // 保存每行在同一测量容器中的实际边界，只允许在 bottom 后分页。
                            top: rect.top - measureRect.top,
                            bottom: rect.bottom - measureRect.top,
                            height: rect.height
                        };
                    });
                return {
                    // 跨页复制的是完整栏目表头，同时计入栏目边框。
                    headerHeight: (outerHeight(this.$refs[headerRef]) || 78)
                        + px(sectionStyle.borderTopWidth)
                        + px(sectionStyle.borderBottomWidth),
                    gapHeight: px(sectionStyle.marginBottom),
                    rows
                };
            };
            const sectionMetrics = {
                newFund: createSectionMetrics(
                    'newFund',
                    'fundMeasureNewSectionRef',
                    'fundMeasureNewHeaderRef'
                ),
                obsoleteFund: createSectionMetrics(
                    'obsoleteFund',
                    'fundMeasureObsoleteSectionRef',
                    'fundMeasureObsoleteHeaderRef'
                ),
                miniFund: createSectionMetrics(
                    'miniFund',
                    'fundMeasureMiniSectionRef',
                    'fundMeasureMiniHeaderRef'
                )
            };

            const sources = [
                { type: 'newFund', items: this.newFund, metrics: sectionMetrics.newFund },
                { type: 'obsoleteFund', items: this.obsoleteFund, metrics: sectionMetrics.obsoleteFund },
                { type: 'miniFund', items: this.miniFund, metrics: sectionMetrics.miniFund }
            ];
            const pages = [];
            const addPage = () => {
                const page = {
                    sections: [],
                    showSummary: false,
                    usedHeight: 0,
                    capacity: pages.length === 0 ? firstPageHeight : continuationHeight
                };
                pages.push(page);
                return page;
            };
            let page = addPage();
            const pageHasContent = target => target.sections.length > 0 || target.showSummary;
            const moveToNextPage = () => {
                page = addPage();
            };

            sources.forEach(source => {
                const headerHeight = source.metrics.headerHeight;
                const rowMetrics = source.metrics.rows;
                if (source.items.length === 0) {
                    const blockHeight = headerHeight + emptyHeight;
                    if (page.usedHeight + blockHeight > page.capacity && pageHasContent(page)) {
                        moveToNextPage();
                    }
                    page.sections.push({ type: source.type, items: [], startIndex: 0 });
                    page.usedHeight += blockHeight;
                    return;
                }

                let index = 0;
                while (index < source.items.length) {
                    const firstRowHeight = rowMetrics[index] ? rowMetrics[index].height : 32;
                    if (page.usedHeight + headerHeight + firstRowHeight > page.capacity && pageHasContent(page)) {
                        moveToNextPage();
                    }

                    // startIndex 是该分片在原始数组中的唯一游标；续页只追加游标之后的数据。
                    const section = { type: source.type, items: [], startIndex: index };
                    page.sections.push(section);
                    page.usedHeight += headerHeight;
                    let added = 0;
                    const sectionGap = source.metrics.gapHeight;
                    while (index < source.items.length) {
                        const rowHeight = rowMetrics[index] ? rowMetrics[index].height : 32;
                        if (page.usedHeight + rowHeight + sectionGap > page.capacity && added > 0) break;
                        // 极端长文本即使超过整页也必须前进，避免分页死循环。
                        section.items.push(source.items[index]);
                        page.usedHeight += rowHeight;
                        index += 1;
                        added += 1;
                        if (page.usedHeight + sectionGap >= page.capacity) break;
                    }
                    page.usedHeight += sectionGap;
                    if (index < source.items.length) moveToNextPage();
                }
            });

            if (page.usedHeight + summaryHeight > page.capacity && pageHasContent(page)) {
                moveToNextPage();
            }
            page.showSummary = true;
            page.usedHeight += summaryHeight;

            this.fundPages = pages;
            const firstPage = pages[0] || { sections: [], showSummary: false };
            const firstSection = type => firstPage.sections.find(section => section.type === type);
            const firstNewFund = firstSection('newFund');
            const firstObsoleteFund = firstSection('obsoleteFund');
            const firstMiniFund = firstSection('miniFund');

            // 首页沿用原有模板，数据由统一分页结果回填。
            this.page1NewFundShow = !!firstNewFund;
            this.page1ObsoleteFundShow = !!firstObsoleteFund;
            this.page1MiniFundShow = !!firstMiniFund;
            this.page1NewFundList = firstNewFund ? firstNewFund.items : [];
            this.page1ObsoleteFundList = firstObsoleteFund ? firstObsoleteFund.items : [];
            this.page1MiniFundList = firstMiniFund ? firstMiniFund.items : [];
            this.page1FundCountShow = firstPage.showSummary;

            // 禁用旧版固定 2～4 页，续页改由 fundPages 动态生成。
            this.page2Show = false;
            this.page3Show = false;
            this.page4Show = false;
            this.page2FundCountShow = false;
            this.page3FundCountShow = false;
            this.page4FundCountShow = false;
            this.Dheight = 'auto';

            await this.$nextTick();
        },
        legacyInitFundPage() {
            // 单条记录高度
            const itemHeight = 32;
            // page1
            const page1Height = 762;
            const noMsgHeight = 120;
            // page2
            const page2Height = 1214;
            const fundNeedHeight = 78 + 32 + 10;
            // 页面实际可用高度
            const fundAllHeight = page2Height - 78 - 10;
            const fundAreaHeight = 78 + 10;
            if (this.newFund.length !== 0) {
                this.page1NewFundShow = true;
                if (this.newFund.length >= 20) {
                    // 说明需要第2页
                    this.page2Show = true;
                    this.page1NewFundList = this.newFund.slice(0, 20);
                    this.page2NewFundShow = true;
                    // 第二页预留给newFund最大的空间高度
                    // 获取超过20条后的剩余基金数组
                    const remainingFunds = this.newFund.slice(20);
                    // 计算page2Height最多能容纳多少条记录
                    const maxItemsFit = Math.floor(fundAllHeight / itemHeight);
                    // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                    const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                    // 对应的索引位置（相对于原数组的索引）
                    // const maxIndex = 20 + displayCount;
                    // 计算实际高度
                    const newFundMaxHeight = displayCount * itemHeight;
                    // 高度差
                    const diffNewFund2Height = page2Height - (newFundMaxHeight + 78 + 10);
                    // 说明已经放完了新发基金
                    if (displayCount >= remainingFunds.length) {
                        this.page2NewFundList = this.newFund.slice(20);
                        // 判断第二页放完新发基金后，还有没有多余空间放置清盘基金, 10px为margin-bottom距离
                        if (diffNewFund2Height >= fundNeedHeight) {
                            this.page2ObsoleteFundShow = true;
                            // 实际第二页留给清盘基金的高度
                            const obsoleteFund2Height = diffNewFund2Height - fundAreaHeight;
                            const remainingFunds = this.obsoleteFund;
                            // 计算obsoleteFund2Height最多能容纳多少条记录
                            const maxItemsFit = Math.floor(obsoleteFund2Height / itemHeight);
                            // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                            const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                            // 计算实际第二页清盘基金高度
                            const obsoleteFund2MaxHeight = displayCount * itemHeight;
                            // 继续计算第二页剩余高度是否足够放置迷你基金
                            if (displayCount >= remainingFunds.length) {
                                // 说明第二页还不足够放置清盘基金
                                this.page2ObsoleteFundList = this.obsoleteFund.slice(0, displayCount);
                                // 第2页继续放置迷你基金，判断剩余高度
                                // 注意：将所有依赖DOM高度的逻辑放入$nextTick回调中
                                this.$nextTick(() => {
                                    // 此时 DOM 已更新，可安全获取 ref
                                    const page2ObsoleteFundRef = this.$refs.page2ObsoleteFundRef;
                                    const page2NewFundRef = this.$refs.page2NewFundRef;
                                    
                                    if (!page2ObsoleteFundRef && !page2NewFundRef) {
                                        console.warn("未找到ref为page2ObsoleteFundRef或page2NewFundRef的元素");
                                        return;
                                    }
                                    
                                    // 安全获取高度（此时已在回调中，确保获取到值）
                                    const page2ObsoleteFundRefHeight = page2ObsoleteFundRef ? page2ObsoleteFundRef.offsetHeight : 0;
                                    const page2NewFundRefHeight = page2NewFundRef ? page2NewFundRef.offsetHeight : 0;
                                    
                                    // 现在可以正确计算剩余高度了，78为本身标题高度, margin-bottom:10px，也要去掉
                                    const page2RemainHeight = page2Height - (page2ObsoleteFundRefHeight + page2NewFundRefHeight + fundAreaHeight);
                                    
                                    // 后续依赖page2RemainHeight的逻辑全部放在这里
                                    // 计算剩余page2Height最多能容纳多少条记录
                                    const remainingFunds = this.miniFund;
                                    const maxItemsFit = Math.floor(page2RemainHeight / itemHeight);
                                    // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                    const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                                    
                                    // 判断第2页有没有放置完迷你基金
                                    if (displayCount >= remainingFunds.length) {
                                        // 说明第2页就已经放完了
                                        this.page2MiniFundList = this.miniFund;
                                        const page2MiniFundRef = this.$refs.page2MiniFundRef;
                                        const page2RemainHeight2 = page2Height - (page2ObsoleteFundRefHeight + page2NewFundRefHeight + page2MiniFundRef);
                                        // 判断有没有多余空间放置页尾
                                        if (page2RemainHeight2 <= 96) {
                                            this.page3Show = true;
                                            this.page3FundCountShow = true;
                                            return;
                                        } else {
                                            this.page2FundCountShow = true;
                                            return;
                                        }
                                    } else {
                                        // 说明第2页还没放置完迷你基金
                                        this.page2MiniFundShow = true;
                                        this.page2MiniFundList = this.miniFund.slice(0, displayCount);
                                        // 接着放置第3页
                                        // 显示第3页
                                        this.page3Show = true;
                                        this.page3MiniFundShow = true;
                                        // 先计算此页的可用高度
                                        const miniFund3Height = page2Height - 78 - 10;
                                        // 计算最多能容纳多少条记录
                                        const maxItemsFit3 = Math.floor(miniFund3Height / itemHeight);
                                        // 获取迷你基金第3页剩下的基金列表
                                        const remainingFunds3 = this.miniFund.slice(displayCount);
                                        // 最终能显示的记录数量
                                        const displayCount3 = Math.min(remainingFunds3.length, maxItemsFit3);
                                        // 计算实际高度
                                        const miniFund3MaxHeight = displayCount3 * itemHeight;
                                        
                                        // 说明第三页就已经放置完迷你基金
                                        if (displayCount3 >= remainingFunds3.length) {
                                            this.page3MiniFundList = remainingFunds3;
                                            // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                            if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                                this.page4Show = true;
                                                this.page4FundCountShow = true;
                                            } else {
                                                this.page3FundCountShow = true;
                                                return;
                                            }
                                        } else {
                                            // 说明还要继续第4页放置迷你基金
                                            this.page4Show = true;
                                            this.page3MiniFundList = this.miniFund.slice(displayCount, displayCount + displayCount3);
                                            this.page4MiniFundShow = true;
                                            
                                            // 计算第4页可用高度
                                            const miniFund4Height = page2Height - 78 - 10;
                                            const maxItemsFit4 = Math.floor(miniFund4Height / itemHeight);
                                            // 获取剩余基金列表
                                            const remainingFunds4 = this.miniFund.slice(displayCount + displayCount3);
                                            const displayCount4 = Math.min(remainingFunds4.length, maxItemsFit4);
                                            // 计算实际高度
                                            const miniFund4MaxHeight = displayCount4 * itemHeight;
                                            
                                            if (displayCount4 >= remainingFunds4.length) {
                                                // 说明第4页能放完基金
                                                this.page4MiniFundList = remainingFunds4;
                                                this.page4FundCountShow = true;
                                                return;
                                            }
                                        }
                                    }
                                });
                            } else {
                                // 判断是否还有多余位置继续放置迷你基金
                                this.page2ObsoleteFundList = this.obsoleteFund.slice(0, remainingFunds.length);
                                const diffMiniFund2Height = page2Height - (newFundMaxHeight + 78 + 10) - (obsoleteFund2MaxHeight + 78 + 10);
                                if (diffMiniFund2Height >= fundNeedHeight) {
                                    this.page2MiniFundShow = true;
                                    // 获取超过20条后的剩余基金数组
                                    const remainingFunds = this.miniFund;
                                    // 计算page2Height最多能容纳多少条记录
                                    const miniFund2Height = diffMiniFund2Height - 78 - 10;
                                    const maxItemsFit = Math.floor(miniFund2Height / itemHeight);
                                    // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                    const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                                    // 计算实际高度，没有其它类型基金，因此无需继续判断，直接换一页
                                    const miniFund2MaxHeight = displayCount * itemHeight;
                                    // 说明第二页就放完了迷你基金，判断是否足够空间放页尾的基金数量
                                    // 剩余高度差
                                    const diffFundCount2Height = page2Height - (newFundMaxHeight + 78 + 10) - (obsoleteFund2MaxHeight + 78 + 10) - (miniFund2MaxHeight + 78 + 10);
                                    if (displayCount >= remainingFunds.length) {
                                        this.page2MiniFundList = this.miniFund.slice(0, displayCount);
                                        if (diffFundCount2Height >= 70) {
                                            // 判断有无空间放置页尾的基金数量一栏
                                            this.page2FundCountShow = true;
                                        }
                                    } else {
                                        // 继续换页放置更多的迷你基金
                                        this.page3Show = true;
                                        this.page2MiniFundList = this.miniFund.slice(0, displayCount);
                                        this.page3MiniFundShow = true;
                                        const remainingFunds = this.miniFund.slice(displayCount);
                                        // 第三页实际可用高度
                                        const miniFund3Height = page2Height - 78 - 10;
                                        // 计算obsoleteFund2Height最多能容纳多少条记录
                                        const maxItemsFit = Math.floor(miniFund3Height / itemHeight);
                                        // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                        const displayCount3 = Math.min(remainingFunds.length, maxItemsFit);
                                        // 计算实际第二页清盘基金高度
                                        const miniFund3MaxHeight = displayCount3 * itemHeight;
                                        // 说明第三页就已经放置完迷你基金
                                        if (displayCount3 >= remainingFunds.length) {
                                            this.page3MiniFundList = this.miniFund.slice(displayCount);
                                            // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                            if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                                this.page4Show = true;
                                            } else {
                                                this.page3FundCountShow = true;
                                            }
                                        } else {
                                        // 说明还要继续下一页放置迷你基金
                                            this.page4Show = true;
                                            this.page3MiniFundList = this.miniFund.slice(displayCount);
                                            this.page4MiniFundShow = true;
                                        }
                                        
                                    }

                                }
                            }
                        }
                    // 说明新发基金还有，需要第三页继续放置
                    } else {
                        // this.page2NewFundList = this.newFund.slice(20, maxIndex);
                    }

                } else {
                    this.page1NewFundList = this.newFund;
                    // 计算高度
                    const page1NewFundHeight = (this.newFund.length * 32) + 78 + 10;
                    const page1DiffHeight = page1Height - page1NewFundHeight;
                    const page1FundNeedHeight = 78 + 32 + 10;
                    // 加上固定的头，至少满足显示一行数据的条件，放置清盘基金
                    if (this.obsoleteFund.length !== 0) {
                        // 说明第一页能放下清盘基金
                        if (page1DiffHeight >= fundNeedHeight) {
                            this.page1ObsoleteFundShow = true;
                            const remainingFunds = this.obsoleteFund;
                            // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                            const obsoleteFundLength = Math.floor((page1DiffHeight - 78 - 10) / 32);
                            this.page1ObsoleteFundList = this.obsoleteFund.slice(0, obsoleteFundLength);
                            // 判断是否不足够放完清盘基金
                            if (obsoleteFundLength >= remainingFunds.length) {
                                // 说明能在第1页放完清盘基金，判断其它空间

                            } else {
                                // 说明能在第1页放不完清盘基金，继续第2页
                                this.page2Show = true;
                                this.page2ObsoleteFundShow = true;
                                // 获取剩余的所有清盘基金
                                const remaining2Funds = this.obsoleteFund.slice(obsoleteFundLength);
                                // 计算剩余page2Height最多能容纳多少条记录
                                const obsoleteFund2Height = page2Height - 78 - 10;
                                const maxItemsFit = Math.floor(obsoleteFund2Height / itemHeight);
                                // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                const displayCount2 = Math.min(remaining2Funds.length, maxItemsFit);
                                if (displayCount2 >= remaining2Funds.length) {
                                // 说明第2页就放完了清盘基金
                                this.page2ObsoleteFundList = remaining2Funds;
                                this.$nextTick(() => {
                                    // 此时 DOM 已更新，可安全获取 ref
                                    const page2ObsoleteFundRef = this.$refs.page2ObsoleteFundRef;
                                    
                                    if (!page2ObsoleteFundRef) {
                                        console.warn("未找到ref为page2ObsoleteFundRef的元素");
                                        return;
                                    }
                                    
                                    // 安全获取高度（此时已在回调中，确保获取到值）
                                    const page2ObsoleteFundRefHeight = page2ObsoleteFundRef ? page2ObsoleteFundRef.offsetHeight : 0;
                                    
                                    // 现在可以正确计算剩余高度了，注意此时是第2页的高度
                                    const page2RemainHeight = page2Height - page2ObsoleteFundRefHeight;

                                    // 判断第2页有没有位置放置迷你基金列表
                                    if (page2RemainHeight >= fundNeedHeight) {
                                        // 第2页可以放置迷你基金列表
                                        this.page2MiniFundShow = true;
                                        const remainingFunds = this.miniFund;
                                        const page2MiniFundHeight = page2RemainHeight - 78 - 10;
                                        // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                                        const maxItemsFit = Math.floor(page2MiniFundHeight / 32);
                                        // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                        const displayCount2 = Math.min(remainingFunds.length, maxItemsFit);
                                        this.page2MiniFundList = this.miniFund.slice(0, displayCount2);
                                        if (displayCount2 >= remainingFunds.length) {
                                            // 说明第二页就放完了迷你基金， 判断是否足够放置页尾基金数量一栏
                                            const page2MiniFundRef = this.$refs.page2MiniFundRef;
                                            const page2MiniFundRefHeight = page2MiniFundRef ? page2MiniFundRef.offsetHeight : 0;
                                            const page2FundCountHeight = page1Height - (page2ObsoleteFundRefHeight + page2MiniFundRefHeight);
                                            if (page2FundCountHeight >= 96) {
                                                // 说明第2页还有位置放置页尾
                                                this.page2FundCountShow = true;
                                            } else {
                                                // 说明第1页没放置完尾基金数量一栏
                                                // 接着放置第2页，显示第二页
                                                this.page3Show = true;
                                                // 显示第3页的页尾
                                                this.page3FundCountShow = true;
                                            }
                                        } else {
                                            // 第2页放不完迷你基金列表，显示第3页
                                            this.page3Show = true;
                                            // 接着放置第3页
                                            this.page3MiniFundShow = true;
                                            // 先计算此页的可用高度
                                            const miniFund3Height = page2Height - 78 - 10;
                                            // 计算最多能容纳多少条记录
                                            const maxItemsFit3 = Math.floor(miniFund3Height / itemHeight);
                                            // 获取迷你基金第3页剩下的基金列表
                                            const remainingFunds3 = this.miniFund.slice(displayCount2);
                                            // 最终能显示的记录数量
                                            const displayCount3 = Math.min(remainingFunds3.length, maxItemsFit3);
                                            // 计算实际高度
                                            const miniFund3MaxHeight = displayCount3 * itemHeight;
                                            // 说明第三页就已经放置完迷你基金
                                            if (displayCount3 >= remainingFunds3.length) {
                                                this.page3MiniFundList = remainingFunds3;
                                                // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                                if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                                    this.page4Show = true;
                                                } else {
                                                    this.page3FundCountShow = true;
                                                }
                                            } else {
                                                // 说明还要继续第4页放置迷你基金
                                                // 先放好第三页的迷你基金
                                                this.page4Show = true;
                                                this.page3MiniFundList = this.miniFund.slice(displayCount2, displayCount3);
                                                this.page4MiniFundShow = true;
                                                
                                                // 计算第4页可用高度
                                                const miniFund4Height = page2Height - 78 - 10;
                                                const maxItemsFit4 = Math.floor(miniFund4Height / itemHeight);
                                                // 获取剩余基金列表
                                                const remainingFunds4 = this.miniFund.slice(displayCount3);
                                                const displayCount4 = Math.min(remainingFunds4.length, maxItemsFit4);
                                                if (displayCount4 >= remainingFunds4.length) {
                                                    // 说明第4页能放完基金
                                                    this.page4MiniFundList = remainingFunds4;
                                                    this.page4FundCountShow = true;
                                                }
                                            }
                                        }
                                    } else {

                                    }
                                });
                            } else {
                                
                            }
                                    
                            }
                        } else {
                            // 说明第一页放不下清盘基金
                            this.page2Show = true;
                            this.page2ObsoleteFundShow = true;
                            // 获取所有清盘基金
                            const remainingFunds = this.obsoleteFund;
                            // 计算剩余page2Height最多能容纳多少条记录
                            const obsoleteFund2Height = page2Height - 78 - 10;
                            const maxItemsFit = Math.floor(obsoleteFund2Height / itemHeight);
                            // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                            const displayCount2 = Math.min(remainingFunds.length, maxItemsFit);
                            this.page2ObsoleteFundList = this.obsoleteFund.slice(0, displayCount2);
                            if (displayCount2 >= remainingFunds.length) {
                                // 说明第2页就放完了清盘基金
                                this.$nextTick(() => {
                                    // 此时 DOM 已更新，可安全获取 ref
                                    const page2ObsoleteFundRef = this.$refs.page2ObsoleteFundRef;
                                    
                                    if (!page2ObsoleteFundRef) {
                                        console.warn("未找到ref为page2ObsoleteFundRef的元素");
                                        return;
                                    }
                                    
                                    // 安全获取高度（此时已在回调中，确保获取到值）
                                    const page2ObsoleteFundRefHeight = page2ObsoleteFundRef ? page2ObsoleteFundRef.offsetHeight : 0;
                                    // 现在可以正确计算剩余高度了，注意此时是第2页的高度
                                    const page2RemainHeight = page2Height - page2ObsoleteFundRefHeight;
                                    // 判断第2页有没有位置放置迷你基金列表
                                    if (page2RemainHeight >= fundNeedHeight) {
                                        // 第2页可以放置迷你基金列表
                                        this.page2MiniFundShow = true;
                                        const remainingFunds = this.miniFund.slice(0, displayCount2);
                                        const page2MiniFundHeight = page2RemainHeight - 78 - 10;
                                        // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                                        const maxItemsFit = Math.floor(page2MiniFundHeight / 32);
                                        // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                        const displayCount2 = Math.min(remainingFunds.length, maxItemsFit);
                                        this.page2MiniFundList = this.miniFund.slice(0, displayCount2);
                                        if (displayCount2 >= remainingFunds.length) {
                                            // 说明第二页就放完了迷你基金， 判断是否足够放置页尾基金数量一栏
                                            const page2MiniFundRef = this.$refs.page2MiniFundRef;
                                            const page2MiniFundRefHeight = page2MiniFundRef ? page2MiniFundRef.offsetHeight : 0;
                                            const page2FundCountHeight = page1Height - (page2ObsoleteFundRefHeight + page2MiniFundRefHeight);
                                            if (page2FundCountHeight >= 96) {
                                                // 说明第2页还有位置放置页尾
                                                this.page1FundCountShow = true;
                                            } else {
                                                // 说明第1页没放置完尾基金数量一栏
                                                // 接着放置第2页，显示第二页
                                                this.page3Show = true;
                                                // 显示第3页的页尾
                                                this.page3FundCountShow = true;
                                            }
                                        } else {
                                            // 第2页放不完迷你基金列表，显示第3页
                                            this.page3Show = true;
                                            // 接着放置第3页
                                            this.page3MiniFundShow = true;
                                            // 先计算此页的可用高度
                                            const miniFund3Height = page2Height - 78 - 10;
                                            // 计算最多能容纳多少条记录
                                            const maxItemsFit3 = Math.floor(miniFund3Height / itemHeight);
                                            // 获取迷你基金第3页剩下的基金列表
                                            const remainingFunds3 = this.miniFund.slice(displayCount2);
                                            // 最终能显示的记录数量
                                            const displayCount3 = Math.min(remainingFunds3.length, maxItemsFit3);
                                            // 计算实际高度
                                            const miniFund3MaxHeight = displayCount3 * itemHeight;
                                            // 说明第三页就已经放置完迷你基金
                                            if (displayCount3 >= remainingFunds3.length) {
                                                this.page3MiniFundList = remainingFunds3;
                                                // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                                if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                                    this.page4Show = true;
                                                    this.page4FundCountShow = true;
                                                    return;
                                                } else {
                                                    this.page3FundCountShow = true;
                                                    return;
                                                }
                                            } else {
                                                // 说明还要继续第4页放置迷你基金
                                                // 先放好第三页的迷你基金
                                                this.page4Show = true;
                                                this.page3MiniFundList = this.miniFund.slice(displayCount2, displayCount3);
                                                this.page4MiniFundShow = true;
                                                
                                                // 计算第4页可用高度
                                                const miniFund4Height = page2Height - 78 - 10;
                                                const maxItemsFit4 = Math.floor(miniFund4Height / itemHeight);
                                                // 获取剩余基金列表
                                                const remainingFunds4 = this.miniFund.slice(displayCount3);
                                                const displayCount4 = Math.min(remainingFunds4.length, maxItemsFit4);
                                                if (displayCount4 >= remainingFunds4.length) {
                                                    // 说明第4页能放完基金
                                                    this.page4MiniFundList = remainingFunds4;
                                                    this.page4FundCountShow = true;
                                                }
                                            }
                                        }
                                    } else {

                                    }
                                });
                            }
                        }
                    } else {
                        // 显示暂无基金，判断有没有足够高度放置
                        // 说明第一页能放下清盘基金
                        if (page1DiffHeight >= fundNeedHeight) {
                            this.page1ObsoleteFundShow = true;
                            const remainingFunds = this.obsoleteFund;
                            // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                            const maxItemsFit = Math.floor((page1DiffHeight - fundAreaHeight) / itemHeight);
                            const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                            
                            if (displayCount >= remainingFunds.length) {
                                this.page1ObsoleteFundList = remainingFunds;
                                this.$nextTick(() => {
                                    // 此时 DOM 已更新，可安全获取 ref
                                    const page1NewFundRef = this.$refs.page1NewFundRef;
                                    const page1ObsoleteFundRef = this.$refs.page1ObsoleteFundRef;
                                    if (!page1NewFundRef && !page1ObsoleteFundRef) {
                                        console.warn("未找到ref为page1ObsoleteFundRef的元素");
                                        return;
                                    }
                                    const page1NewFundRefHeight = page1NewFundRef ? page1NewFundRef.offsetHeight : 0;
                                    const page1ObsoleteRefHeight = page1ObsoleteFundRef ? page1ObsoleteFundRef.offsetHeight : 0;
                                    const page1RemainHeight = page1Height - (page1NewFundRefHeight + page1ObsoleteRefHeight);
                                    if (page1RemainHeight >= fundNeedHeight) {
                                        this.page1MiniFundShow = true;
                                        const remainingFunds = this.miniFund;
                                        const page1MiniFundHeight = page1RemainHeight - 78 - 10;
                                        // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                                        const maxItemsFit = Math.floor(page1MiniFundHeight / 32);
                                        // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                        const displayCount1 = Math.min(remainingFunds.length, maxItemsFit);
                                        if (displayCount1 >= remainingFunds.length) {
                                            // 第页足够放置完迷你基金
                                            this.page2MiniFundList = this.miniFund.slice(0, displayCount1);
                                            const page1MiniFundRef = this.$refs.page1MiniFundRef;
                                            const page1MiniFundRefHeight = page1MiniFundRef ? page1MiniFundRef.offsetHeight : 0;
                                            const page1FundCountHeight = page1Height - (page1NewFundRefHeight + page1ObsoleteRefHeight + page1MiniFundRefHeight);
                                            // 继续判断放置页尾
                                            if (page1FundCountHeight >= 96) {
                                                // 说明第2页还有位置放置页尾
                                                this.page1FundCountShow = true;
                                            } else {
                                                // 说明第1页没放置完尾基金数量一栏
                                                // 接着放置第2页，显示第二页
                                                this.page2Show = true;
                                                // 显示第2页的页尾
                                                this.page2FundCountShow = true;
                                            }
                                        }
                                        
                                    }
                                });
                            } else {
                                // 第1页不够放置清盘基金
                                this.page2Show = true;
                                this.page2ObsoleteFundShow = true;
                                this.page1ObsoleteFundList = this.obsoleteFund.slice(0, displayCount);
                                const remainingFunds = this.obsoleteFund.slice(displayCount);
                                // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                                const maxItemsFit = Math.floor(fundAllHeight / 32);
                                // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                const displayCount1 = Math.min(remainingFunds.length, maxItemsFit);
                                if (displayCount1 >= remainingFunds.length) {
                                    // 第2页足够放置完清盘基金
                                    this.page2ObsoleteFundList = remainingFunds;
                                    this.$nextTick(() => {
                                        const page2ObsoleteFundRef = this.$refs.page2ObsoleteFundRef;
                                        if (!page2ObsoleteFundRef) {
                                            console.warn("未找到ref为page2ObsoleteFundRef的元素");
                                            return;
                                        }
                                        
                                        // 安全获取高度（此时已在回调中，确保获取到值）
                                        const page2ObsoleteFundRefHeight = page2ObsoleteFundRef ? page2ObsoleteFundRef.offsetHeight : 0;
                                        // 现在可以正确计算剩余高度了，注意此时是第2页的高度
                                        const page2RemainHeight = page2Height - page2ObsoleteFundRefHeight;
                                        // 继续判断放置页尾
                                        if (page2RemainHeight >= 96) {
                                            // 说明第2页还有位置放置页尾
                                            this.page2FundCountShow = true;
                                        } else {
                                            // 说明第2页没放置完尾基金数量一栏
                                            // 接着放置第3页，显示第二页
                                            this.page3Show = true;
                                            // 显示第2页的页尾
                                            this.page3FundCountShow = true;
                                        }
                                    });
                                    
                                }
                            }
                        } else {
                            // 说明第一页放不下清盘基金
                            this.page2Show = true;
                            this.page2ObsoleteFundShow = true;
                            // 获取所有清盘基金
                            const remainingFunds = this.obsoleteFund;
                            // 计算剩余page2Height最多能容纳多少条记录
                            const obsoleteFund2Height = page2Height - 78 - 10;
                            const maxItemsFit = Math.floor(obsoleteFund2Height / itemHeight);
                            // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                            const displayCount2 = Math.min(remainingFunds.length, maxItemsFit);
                            this.page2ObsoleteFundList = this.obsoleteFund.slice(0, displayCount2);
                            if (displayCount2 >= remainingFunds.length) {
                                // 说明第2页就放完了清盘基金
                                this.$nextTick(() => {
                                    // 此时 DOM 已更新，可安全获取 ref
                                    const page2ObsoleteFundRef = this.$refs.page2ObsoleteFundRef;
                                    
                                    if (!page2ObsoleteFundRef) {
                                        console.warn("未找到ref为page2ObsoleteFundRef的元素");
                                        return;
                                    }
                                    
                                    // 安全获取高度（此时已在回调中，确保获取到值）
                                    const page2ObsoleteFundRefHeight = page2ObsoleteFundRef ? page2ObsoleteFundRef.offsetHeight : 0;
                                    // 现在可以正确计算剩余高度了，注意此时是第2页的高度
                                    const page2RemainHeight = page1Height - page2ObsoleteFundRefHeight;
                                    // 判断第2页有没有位置放置迷你基金列表
                                    if (page2RemainHeight >= fundNeedHeight) {
                                        // 第2页可以放置迷你基金列表
                                        this.page2MiniFundShow = true;
                                        const remainingFunds = this.miniFund;
                                        const page2MiniFundHeight = page2RemainHeight - 78 - 10;
                                        // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                                        const maxItemsFit = Math.floor(page2MiniFundHeight / 32);
                                        // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                        const displayCount2 = Math.min(remainingFunds.length, maxItemsFit);
                                        this.page2MiniFundList = this.miniFund.slice(0, displayCount2);
                                        if (displayCount2 >= remainingFunds.length) {
                                            // 说明第二页就放完了迷你基金， 判断是否足够放置页尾基金数量一栏
                                            const page2MiniFundRef = this.$refs.page2MiniFundRef;
                                            const page2MiniFundRefHeight = page2MiniFundRef ? page2MiniFundRef.offsetHeight : 0;
                                            const page2FundCountHeight = page1Height - (page2ObsoleteFundRefHeight + page2MiniFundRefHeight);
                                            if (page2FundCountHeight >= 96) {
                                                // 说明第2页还有位置放置页尾
                                                this.page1FundCountShow = true;
                                            } else {
                                                // 说明第1页没放置完尾基金数量一栏
                                                // 接着放置第2页，显示第二页
                                                this.page3Show = true;
                                                // 显示第3页的页尾
                                                this.page3FundCountShow = true;
                                            }
                                        } else {
                                            // 第2页放不完迷你基金列表，显示第3页
                                            this.page3Show = true;
                                            // 接着放置第3页
                                            this.page3MiniFundShow = true;
                                            // 先计算此页的可用高度
                                            const miniFund3Height = page2Height - 78 - 10;
                                            // 计算最多能容纳多少条记录
                                            const maxItemsFit3 = Math.floor(miniFund3Height / itemHeight);
                                            // 获取迷你基金第3页剩下的基金列表
                                            const remainingFunds3 = this.miniFund.slice(displayCount2);
                                            // 最终能显示的记录数量
                                            const displayCount3 = Math.min(remainingFunds3.length, maxItemsFit3);
                                            
                                            // 计算实际高度
                                            const miniFund3MaxHeight = displayCount3 * itemHeight;
                                            
                                            // 说明第三页就已经放置完迷你基金
                                            if (displayCount3 >= remainingFunds3.length) {
                                                this.page3MiniFundList = remainingFunds3;
                                                // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                                if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                                    this.page4Show = true;
                                                } else {
                                                    this.page3FundCountShow = true;
                                                }
                                            } else {
                                                // 说明还要继续第4页放置迷你基金
                                                // 先放好第三页的迷你基金
                                                this.page4Show = true;
                                                this.page3MiniFundList = this.miniFund.slice(displayCount2, displayCount3);
                                                this.page4MiniFundShow = true;
                                                
                                                // 计算第4页可用高度
                                                const miniFund4Height = page2Height - 78 - 10;
                                                const maxItemsFit4 = Math.floor(miniFund4Height / itemHeight);
                                                // 获取剩余基金列表
                                                const remainingFunds4 = this.miniFund.slice(displayCount3);
                                                const displayCount4 = Math.min(remainingFunds4.length, maxItemsFit4);
                                                if (displayCount4 >= remainingFunds4.length) {
                                                    // 说明第4页能放完基金
                                                    this.page4MiniFundList = remainingFunds4;
                                                    this.page4FundCountShow = true;
                                                }
                                            }
                                        }
                                    } else {

                                    }
                                });
                            }
                        }
                    }
                    if (this.miniFund.length !== 0) {
                        this.$nextTick(() => {
                            // 此时 DOM 已更新，可安全获取 ref
                            const page1ObsoleteFundRef = this.$refs.page1ObsoleteFundRef;
                            const page1NewFundRef = this.$refs.page1NewFundRef;
                            const page1MiniFundRef = this.$refs.page1MiniFundRef;
                            
                           if (!page1ObsoleteFundRef && !page1NewFundRef && !page1MiniFundRef) {
                                console.warn("未找到ref为page1ObsoleteFundRef或page1NewFundRef或page1MiniFundRef的元素");
                                return;
                            }
                            
                            // 安全获取高度（此时已在回调中，确保获取到值）
                            const page1ObsoleteFundRefHeight = page1ObsoleteFundRef ? page1ObsoleteFundRef.offsetHeight : 0;
                            const page1NewFundRefHeight = page1NewFundRef ? page1NewFundRef.offsetHeight : 0;
                            // 现在可以正确计算剩余高度了，78为本身标题高度，也要去掉
                            const page1RemainHeight = page1Height - (page1ObsoleteFundRefHeight + page1NewFundRefHeight);
                            if (page1RemainHeight >= fundNeedHeight) {
                                this.page1MiniFundShow = true;
                                // 获取所有的迷你基金列表
                                const remainingFunds = this.miniFund;
                                // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                                const maxItemsFit = Math.floor((page1RemainHeight -78-10) / 32);
                                // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                const displayCount1 = Math.min(remainingFunds.length, maxItemsFit);
                                this.page1MiniFundList = this.miniFund.slice(0, displayCount1);
                                // 继续判断迷你基金剩余数据
                                if (displayCount1 >= remainingFunds.length) {
                                    // 说明已经排完了迷你基金，只需要判断页尾是否足够放置就行
                                    // 此时 DOM 已更新，可安全获取 ref
                                    this.$nextTick(() => {
                                        const page1ObsoleteFundRef = this.$refs.page1ObsoleteFundRef;
                                        const page1NewFundRef = this.$refs.page1NewFundRef;
                                        const page1MiniFundRef = this.$refs.page1MiniFundRef;
                                        
                                        if (!page1ObsoleteFundRef && !page1NewFundRef && !page1MiniFundRef) {
                                            console.warn("未找到ref为page1ObsoleteFundRef或page1NewFundRef或page1MiniFundRef的元素");
                                            return;
                                        }
                                        
                                        // 安全获取高度（此时已在回调中，确保获取到值）
                                        const page1ObsoleteFundRefHeight = page1ObsoleteFundRef ? page1ObsoleteFundRef.offsetHeight : 0;
                                        const page1NewFundRefHeight = page1NewFundRef ? page1NewFundRef.offsetHeight : 0;
                                        const page1MiniFundRefHeight = page1MiniFundRef ? page1MiniFundRef.offsetHeight : 0;
                                        // 现在可以正确计算剩余高度了，注意此时是第一页的高度
                                        const page1RemainHeight = page1Height - (page1ObsoleteFundRefHeight + page1NewFundRefHeight + page1MiniFundRefHeight);
                                        // 判断第1页有没有位置放置页尾基金数量一栏
                                        if (page1RemainHeight >= 96) {
                                            // 说明第1页还有位置放置页尾
                                            this.page1FundCountShow = true;
                                            return;
                                        } else {
                                            // 说明第1页没放置完尾基金数量一栏
                                            // 接着放置第2页，显示第二页
                                            this.page2Show = true;
                                            // 显示第2页的页尾
                                            this.page1FundCountShow = false;
                                            this.page2FundCountShow = true;
                                            return;
                                        }
                                    });
                                } else {
                                    this.page2Show = true;
                                    this.page2MiniFundShow = true;
                                    // 获取剩余的迷你基金
                                    const remainingFunds = this.miniFund.slice(displayCount1);
                                    // 计算剩余page2Height最多能容纳多少条记录
                                    const miniFund2Height = page2Height - 78 - 10;
                                    const maxItemsFit = Math.floor(miniFund2Height / itemHeight);
                                    // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                    const displayCount2 = Math.min(remainingFunds.length, maxItemsFit);
                                    // 判断第2页有没有放置完迷你基金
                                    if (displayCount2 >= remainingFunds.length) {
                                        // 说明第2页就已经放完了
                                        this.page2MiniFundList = remainingFunds;
                                        const page2MiniFundRefHeight = remainingFunds.length * 32 + fundAreaHeight;
                                        const page2RemainHeight = page2Height - page2MiniFundRefHeight;
                                        if (page2RemainHeight >= 96) {
                                            // 说明第1页还有位置放置页尾
                                            this.page2FundCountShow = true;
                                        } else {
                                            // 说明第2页没放置完尾基金数量一栏
                                            // 接着放置第3页，显示第3页
                                            this.page3Show = true;
                                            // 显示第3页的页尾
                                            this.page3FundCountShow = true;
                                        }
                                    } else {
                                        // 说明第2页还没放置完迷你基金
                                        // 显示第3页
                                        this.page3Show = true;
                                        this.page2MiniFundList = this.miniFund.slice(displayCount1, displayCount2);
                                        // 接着放置第3页
                                        this.page3MiniFundShow = true;
                                        // 先计算此页的可用高度
                                        const miniFund3Height = page2Height - 78 - 10;
                                        // 计算最多能容纳多少条记录
                                        const maxItemsFit3 = Math.floor(miniFund3Height / itemHeight);
                                        // 获取迷你基金第3页剩下的基金列表
                                        const remainingFunds3 = this.miniFund.slice(displayCount2);
                                        // 最终能显示的记录数量
                                        const displayCount3 = Math.min(remainingFunds3.length, maxItemsFit3);
                                        
                                        // 计算实际高度
                                        const miniFund3MaxHeight = displayCount3 * itemHeight;
                                        
                                        // 说明第三页就已经放置完迷你基金
                                        if (displayCount3 >= remainingFunds3.length) {
                                            this.page3MiniFundList = remainingFunds3;
                                            // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                            if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                                this.page4Show = true;
                                            } else {
                                                this.page3FundCountShow = true;
                                            }
                                        } else {
                                            // 说明还要继续第4页放置迷你基金
                                            // 先放好第三页的迷你基金
                                            this.page4Show = true;
                                            this.page3MiniFundList = this.miniFund.slice(displayCount2, displayCount3);
                                            this.page4MiniFundShow = true;
                                            
                                            // 计算第4页可用高度
                                            const miniFund4Height = page2Height - 78 - 10;
                                            const maxItemsFit4 = Math.floor(miniFund4Height / itemHeight);
                                            // 获取剩余基金列表
                                            const remainingFunds4 = this.miniFund.slice(displayCount3);
                                            const displayCount4 = Math.min(remainingFunds4.length, maxItemsFit4);
                                            if (displayCount4 >= remainingFunds4.length) {
                                                // 说明第4页能放完基金
                                                this.page4MiniFundList = remainingFunds4;
                                                this.page4FundCountShow = true;
                                            }
                                        }
                                    }
                                }
                            } else {
                                // 只能放置于第2页的逻辑
                                // 判断出需要第2页显示迷你基金
                                this.page2Show = true;
                                this.page2MiniFundShow = true;
                                // 获取超过20条后的剩余基金数组
                                const remainingFunds = this.miniFund;
                                // 获取page2剩余高度多少可用
                                // 注意：将所有依赖DOM高度的逻辑放入$nextTick回调中
                                this.$nextTick(() => {
                                    // 此时 DOM 已更新，可安全获取 ref
                                    const page2ObsoleteFundRef = this.$refs.page2ObsoleteFundRef;
                                    const page2NewFundRef = this.$refs.page2NewFundRef;
                                    
                                    if (!page2ObsoleteFundRef && !page2NewFundRef) {
                                        console.warn("未找到ref为page2ObsoleteFundRef或page2NewFundRef的元素");
                                        return;
                                    }
                                    
                                    // 安全获取高度（此时已在回调中，确保获取到值）
                                    const page2ObsoleteFundRefHeight = page2ObsoleteFundRef ? page2ObsoleteFundRef.offsetHeight : 0;
                                    const page2NewFundRefHeight = page2NewFundRef ? page2NewFundRef.offsetHeight : 0;
                                    
                                    // 现在可以正确计算剩余高度了，78为本身标题高度，也要去掉
                                    const page2RemainHeight = page2Height - (page2ObsoleteFundRefHeight + page2NewFundRefHeight + 78 + 10);
                                    // 后续依赖page2RemainHeight的逻辑全部放在这里
                                    // 计算剩余page2Height最多能容纳多少条记录
                                    const maxItemsFit = Math.floor(page2RemainHeight / itemHeight);
                                    // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                    const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                                    
                                    // 判断第2页有没有放置完迷你基金
                                    if (displayCount >= remainingFunds.length) {
                                        // 说明第2页就已经放完了
                                        this.page2MiniFundList = this.miniFund;
                                        // 判断是否足够放置页尾一栏
                                        const page2MiniFundHeight = displayCount * itemHeight;
                                        const page2Height = page2RemainHeight - page2MiniFundHeight;
                                        if (page2Height <= 96) {
                                            this.page2FundCountShow = false;
                                            this.page3Show = true;
                                            this.page3FundCountShow = true;
                                            return;
                                        } else {
                                            this.page2FundCountShow = true;
                                            return;
                                        }
                                    } else {
                                        // 说明第2页还没放置完迷你基金
                                        this.page2MiniFundList = this.miniFund.slice(0, displayCount);
                                        // 接着放置第3页
                                        // 显示第3页
                                        this.page3Show = true;
                                        this.page3MiniFundShow = true;
                                        // 先计算此页的可用高度
                                        const miniFund3Height = page2Height - 78 - 10;
                                        // 计算最多能容纳多少条记录
                                        const maxItemsFit3 = Math.floor(miniFund3Height / itemHeight);
                                        // 获取迷你基金第3页剩下的基金列表
                                        const remainingFunds3 = this.miniFund.slice(displayCount);
                                        // 最终能显示的记录数量
                                        const displayCount3 = Math.min(remainingFunds3.length, maxItemsFit3);
                                        // 计算实际高度
                                        const miniFund3MaxHeight = displayCount3 * itemHeight;
                                        // 说明第三页就已经放置完迷你基金
                                        if (displayCount3 >= remainingFunds3.length) {
                                            this.page3MiniFundList = remainingFunds3;
                                            // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                            if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                                this.page4Show = true;
                                            } else {
                                                this.page3FundCountShow = true;
                                            }
                                        } else {
                                            // 说明还要继续第4页放置迷你基金
                                            this.page4Show = true;
                                            this.page3MiniFundList = this.miniFund.slice(displayCount, displayCount + displayCount3);
                                            this.page4MiniFundShow = true;
                                            
                                            // 计算第4页可用高度
                                            const miniFund4Height = page2Height - 78 - 10;
                                            const maxItemsFit4 = Math.floor(miniFund4Height / itemHeight);
                                            // 获取剩余基金列表
                                            const remainingFunds4 = this.miniFund.slice(displayCount + displayCount3);
                                            const displayCount4 = Math.min(remainingFunds4.length, maxItemsFit4);
                                            if (displayCount4 >= remainingFunds4.length) {
                                                // 说明第4页能放完基金
                                                this.page4MiniFundList = remainingFunds4;
                                                this.page4FundCountShow = true;
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                }
            } else {
                this.page1NewFundShow = true;
                // 加上固定的头，至少满足显示一行数据的条件，放置清盘基金
                if (this.obsoleteFund.length !== 0) {
                    // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                    const remainingPage1Height = page1Height - noMsgHeight - fundAreaHeight;
                    const remainingFunds = this.obsoleteFund;
                    const obsoleteFundLength = Math.floor(remainingPage1Height / itemHeight);
                    const displayCount = Math.min(remainingFunds.length, obsoleteFundLength);
                    if (displayCount >= remainingFunds.length) {
                        this.page1ObsoleteFundShow = true;
                         this.page1ObsoleteFundList = this.obsoleteFund.slice(0, obsoleteFundLength);
                        // 足够放置完清盘基金，继续第1页判断是否足够放置迷你基金
                        this.$nextTick(() => {
                            // 此时 DOM 已更新，可安全获取 ref
                            const page1ObsoleteFundRef = this.$refs.page1ObsoleteFundRef;
                            const page1NewFundRef = this.$refs.page1NewFundRef;
                            const page1MiniFundRef = this.$refs.page1MiniFundRef;
                            
                            if (!page1ObsoleteFundRef && !page1NewFundRef && !page1MiniFundRef) {
                                console.warn("未找到ref为page1ObsoleteFundRef或page1NewFundRef或page1MiniFundRef的元素");
                                return;
                            }
                            
                            //安全获取高度（此时已在回调中，确保获取到值）
                            const page1ObsoleteFundRefHeight = page1ObsoleteFundRef ? page1ObsoleteFundRef.offsetHeight : 0;
                            const page1NewFundRefHeight = page1NewFundRef ? page1NewFundRef.offsetHeight : 0;
                            const page1MiniFundRefHeight = page1MiniFundRef ? page1MiniFundRef.offsetHeight : 0;
                            // 现在可以正确计算剩余高度了，78为本身标题高度, margin-bottom:10px，也要去掉
                            const page1RemainHeight = page1Height - (page1ObsoleteFundRefHeight + page1NewFundRefHeight + fundAreaHeight);
                            if (page1RemainHeight >= 32) {
                                const remainingFunds = this.miniFund;
                                const maxItemsFit = Math.floor(page1RemainHeight / itemHeight);
                                // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                                if (displayCount >= remainingFunds.length) {
                                    // 足够放置完迷你基金
                                    this.page1MiniFundShow = true;
                                    this.page1MiniFundList = remainingFunds;
                                    // 再判断是否足够放置页尾
                                    const pageRemainHeight = page1Height - (page1ObsoleteFundRefHeight + page1NewFundRefHeight + page1MiniFundRefHeight);
                                    if (pageRemainHeight <= 96) {
                                        this.page2Show = true;
                                        this.page2FundCountShow = true;
                                        return;
                                    } else {
                                        this.page1FundCountShow = true;
                                        return;
                                    }
                                } else {
                                    // 继续第2页放置迷你基金
                                    this.page2Show = true;
                                    this.page2MiniFundShow = true;
                                    this.page1MiniFundList = this.miniFund.slice(0, displayCount);
                                    const remainingFunds2 = this.miniFund.slice(displayCount);
                                    const maxItemsFit2 = Math.floor(page2Height / itemHeight);
                                    const displayCount2 = Math.min(remainingFunds2.length, maxItemsFit2);
                                    if (displayCount2 >= remainingFunds2.length) {
                                        this.page2MiniFundList = remainingFunds2;
                                        const page2MiniFundRefHeight = remainingFunds2.length*itemHeight + fundAreaHeight;
                                        const pageRemain2Height = page2Height - page2MiniFundRefHeight;
                                        if (pageRemain2Height <= 96) {
                                            this.page3Show = true;
                                            this.page3FundCountShow = true;
                                            return;
                                        } else {
                                            this.page2FundCountShow = true;
                                            return;
                                        }
                                    }
                                }
                            }
                        });
                    }
                } else {
                    // 第1页继续放置迷你基金，判断剩余高度
                    this.page1ObsoleteFundShow = true;
                    this.page1MiniFundShow = true;
                    // 注意：将所有依赖DOM高度的逻辑放入$nextTick回调中
                    this.$nextTick(() => {
                        // 此时 DOM 已更新，可安全获取 ref
                        const page1ObsoleteFundRef = this.$refs.page1ObsoleteFundRef;
                        const page1NewFundRef = this.$refs.page1NewFundRef;
                        
                        if (!page1ObsoleteFundRef && !page1NewFundRef) {
                            console.warn("未找到ref为page1ObsoleteFundRef或page1NewFundRef的元素");
                            return;
                        }
                        
                        //安全获取高度（此时已在回调中，确保获取到值）
                        const page1ObsoleteFundRefHeight = page1ObsoleteFundRef ? page1ObsoleteFundRef.offsetHeight : 0;
                        const page1NewFundRefHeight = page1NewFundRef ? page1NewFundRef.offsetHeight : 0;
                        
                        // 现在可以正确计算剩余高度了，78为本身标题高度, margin-bottom:10px，也要去掉
                        const page1RemainHeight = page1Height - (page1ObsoleteFundRefHeight + page1NewFundRefHeight + fundAreaHeight);
                        
                        // 后续依赖page1RemainHeight的逻辑全部放在这里
                        // 计算剩余page1Height最多能容纳多少条记录
                        const remainingFunds = this.miniFund;
                        const maxItemsFit = Math.floor(page1RemainHeight / itemHeight);
                        // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                        const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                        
                        // 判断第1页有没有放置完迷你基金
                        if (displayCount >= remainingFunds.length) {
                            // 说明第1页就已经放完了
                            this.page1MiniFundList = this.miniFund;
                            const page1MiniFundRefHeight = displayCount * itemHeight;
                            // 判断页尾放置空间
                            if ((page1RemainHeight - page1MiniFundRefHeight) <= 96) {
                                this.page2Show = true;
                                this.page2FundCountShow = true;
                                return;
                            } else {
                                this.page1FundCountShow = true;
                                return;
                            }
                        } else {
                            // 说明第1页还没放置完迷你基金
                            this.page1MiniFundList = this.miniFund.slice(0, displayCount);
                            // 接着放置第2页
                            // 显示第2页
                            this.page2Show = true;
                            this.page2MiniFundShow = true;
                            // 先计算此页的可用高度
                            const miniFund2Height = page2Height - 78 - 10;
                            // 计算最多能容纳多少条记录
                            const maxItemsFit2 = Math.floor(miniFund2Height / itemHeight);
                            // 获取迷你基金第2页剩下的基金列表
                            const remainingFunds2 = this.miniFund.slice(displayCount);
                            // 最终能显示的记录数量
                            const displayCount2 = Math.min(remainingFunds2.length, maxItemsFit2);
                            // 计算实际高度
                            const miniFund3MaxHeight = displayCount2 * itemHeight;
                            
                            // 说明第三页就已经放置完迷你基金
                            if (displayCount2 >= remainingFunds2.length) {
                                this.page2MiniFundList = remainingFunds2;
                                // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                if ((miniFund2Height - miniFund3MaxHeight) <= 96) {
                                    this.page3Show = true;
                                    this.page3FundCountShow = true;
                                    return;
                                } else {
                                    this.page2FundCountShow = true;
                                    return;
                                }
                            } else {
                                // 说明还要继续第4页放置迷你基金
                                this.page3Show = true;
                                this.page2MiniFundList = this.miniFund.slice(displayCount, displayCount2);
                                this.page3MiniFundShow = true;
                                
                                // 计算第4页可用高度
                                const miniFund4Height = page2Height - 78 - 10;
                                const maxItemsFit3 = Math.floor(miniFund4Height / itemHeight);
                                // 获取剩余基金列表
                                const remainingFunds3 = this.miniFund.slice(displayCount2);
                                const displayCount3 = Math.min(remainingFunds3.length, maxItemsFit3);
                                if (displayCount3 >= remainingFunds3.length) {
                                    // 说明第4页能放完基金
                                    this.page4MiniFundList = remainingFunds3;
                                    this.page4FundCountShow = true;
                                    return;
                                }
                            }
                        }
                    });
                }
                if (this.miniFund.length !== 0) {
                    // 加上固定的头，至少满足显示一行数据的条件，放置迷你基金
                    const page1AllHeight = (this.obsoleteFund.length * 32) + 78;
                    const page1HasHeight = page1Height - page1AllHeight;
                    if (page1HasHeight >= (78 + 32)) {
                        this.page1MiniFundShow = true;
                        // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                        const miniFundLength = Math.floor((page1HasHeight - 78) / 32);
                        this.page1MiniFundList = this.miniFund.slice(0, miniFundLength);
                    }
                }
            }

            // page2
            // top: 101, bottom: 96, page2H: 1410
            if (this.newFund.length > 20) {
                this.page2NewFundShow = true;
                // 第二页预留给newFund最大的空间高度
                // 获取超过20条后的剩余基金数组
                const remainingFunds = this.newFund.slice(20);
                // 计算page2Height最多能容纳多少条记录
                const maxItemsFit = Math.floor(page2Height / itemHeight);
                // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                // 对应的索引位置（相对于原数组的索引）
                const maxIndex = 20 + displayCount;
                // 计算实际高度
                const newFundMaxHeight = displayCount * itemHeight;
                // 高度差
                const diffNewFund2Height = page2Height - (newFundMaxHeight + 78 + 10);
                // 说明已经放完了新发基金
                if (maxIndex >= this.newFund.length) {
                    this.page2NewFundList = this.newFund.slice(20);
                    // 判断第二页放完新发基金后，还有没有多余空间放置清盘基金, 10px为margin-bottom距离
                    if (diffNewFund2Height >= (78 + 32 + 10)) {
                        this.page2ObsoleteFundShow = true;
                        // 实际第二页留给清盘基金的高度
                        const obsoleteFund2Height = diffNewFund2Height - 78 - 10;
                        const remainingFunds = this.obsoleteFund;
                        // 计算obsoleteFund2Height最多能容纳多少条记录
                        const maxItemsFit = Math.floor(obsoleteFund2Height / itemHeight);
                        // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                        const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                        // 计算实际第二页清盘基金高度
                        const obsoleteFund2MaxHeight = displayCount * itemHeight;
                        // 继续计算第二页剩余高度是否足够放置迷你基金
                        if (obsoleteFund2MaxHeight > obsoleteFund2Height) {
                            // 说明第二页还不足够放置清盘基金
                             this.page2ObsoleteFundList = this.obsoleteFund.slice(0, displayCount);
                        } else if (obsoleteFund2MaxHeight === obsoleteFund2Height) {
                            // 刚好第二页放完清盘基金
                            this.page2ObsoleteFundList = this.obsoleteFund.slice(0, displayCount);
                        } else {
                            // 判断是否还有多余位置继续放置迷你基金
                            this.page2ObsoleteFundList = this.obsoleteFund.slice(0, remainingFunds.length);
                            const diffMiniFund2Height = page2Height - (newFundMaxHeight + 78 + 10) - (obsoleteFund2MaxHeight + 78 + 10);
                            if (diffMiniFund2Height >= (78 + 32 + 10)) {
                                this.page2MiniFundShow = true;
                                 // 获取超过20条后的剩余基金数组
                                const remainingFunds = this.miniFund;
                                // 计算page2Height最多能容纳多少条记录
                                const miniFund2Height = diffMiniFund2Height - 78 - 10;
                                const maxItemsFit = Math.floor(miniFund2Height / itemHeight);
                                // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                const displayCount = Math.min(remainingFunds.length, maxItemsFit);
                                // 计算实际高度，没有其它类型基金，因此无需继续判断，直接换一页
                                const miniFund2MaxHeight = displayCount * itemHeight;
                                // 说明第二页就放完了迷你基金，判断是否足够空间放页尾的基金数量
                                // 剩余高度差
                                const diffFundCount2Height = page2Height - (newFundMaxHeight + 78 + 10) - (obsoleteFund2MaxHeight + 78 + 10) - (miniFund2MaxHeight + 78 + 10);
                                if (displayCount > remainingFunds.length) {
                                    this.page2MiniFundList = this.miniFund.slice(0, displayCount);
                                    if (diffFundCount2Height >= 70) {
                                        // 判断有无空间放置页尾的基金数量一栏
                                        this.Hflex = true;
                                    }
                                } else if (displayCount === remainingFunds.length) {
                                    // 刚好第二页放完迷你基金
                                    this.page2MiniFundList = this.miniFund.slice(0, displayCount);
                                } else {
                                    // 继续换页放置更多的迷你基金
                                    this.page3Show = true;
                                    this.page2MiniFundList = this.miniFund.slice(0, displayCount);
                                    this.page3MiniFundShow = true;
                                    const remainingFunds = this.miniFund.slice(displayCount);
                                    // 第三页实际可用高度
                                    const miniFund3Height = page2Height - 78 - 10;
                                    // 计算obsoleteFund2Height最多能容纳多少条记录
                                    const maxItemsFit = Math.floor(miniFund3Height / itemHeight);
                                    // 最终能显示的记录数量（取剩余记录数和最大容纳数中的较小值）
                                    const displayCount3 = Math.min(remainingFunds.length, maxItemsFit);
                                    // 计算实际第二页清盘基金高度
                                    const miniFund3MaxHeight = displayCount3 * itemHeight;
                                    // 说明第三页就已经放置完迷你基金
                                    if (displayCount3 >= remainingFunds.length) {
                                        this.page3MiniFundList = this.miniFund.slice(displayCount);
                                        // 计算第3页剩余空间是否足够放置页尾基金数量一栏
                                        if ((miniFund3Height - miniFund3MaxHeight) <= 96) {
                                            this.page4Show = true;
                                            this.page4FundCountShow = true;
                                            return;
                                        } else {
                                            this.page3FundCountShow = true;
                                            return;
                                        }
                                    } else {
                                    // 说明还要继续下一页放置迷你基金
                                        this.page4Show = true;
                                        this.page3MiniFundList = this.miniFund.slice(displayCount);
                                        this.page4MiniFundShow = true;
                                    }
                                    
                                }

                            }
                        }
                    }
                // 说明新发基金还有，需要第三页继续放置
                } else {
                    this.page2NewFundList = this.newFund.slice(20, maxIndex);
                }
            } else {
                // 加上固定的头，至少满足显示一行数据的条件，放置清盘基金
                // if (this.obsoleteFund.length !== 0) {
                //     this.page1ObsoleteFundShow = true;
                //     // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                //     const obsoleteFundLength = Math.floor((page1Height - 78) / 32);
                //     this.page1ObsoleteFundList = this.obsoleteFund.slice(0, obsoleteFundLength);
                // }
                // if (this.miniFund.length !== 0) {
                //     // 加上固定的头，至少满足显示一行数据的条件，放置迷你基金
                //     const page1AllHeight = (this.obsoleteFund.length * 32) + 78;
                //     const page1HasHeight = page1Height - page1AllHeight;
                //     if (page1HasHeight >= (78 + 32)) {
                //         this.page1MiniFundShow = true;
                //         // page1ObsoleteFundList的数量根据高度来计算决定, 向下取整
                //         const miniFundLength = Math.floor((page1HasHeight - 78) / 32);
                //         this.page1MiniFundList = this.miniFund.slice(0, miniFundLength);
                //     }
                // }
            }
        }
    }
}
</script>

<style lang="scss">
* {
    margin: 0;
    padding: 0;
}

#demo {
    width: 1000px;
    height: 5660px;
    // height: 4250px;
    margin: auto;
}

.page-module {
    width: 1000px;
    height: 1412px;
    margin: auto;
    border: 1px solid;
    // margin-top: 14px;
}

.page-area {
    /* display: flex; */
    position: relative;
    width: 91.5%;
    height: 1410px;
    margin: 0 auto;
}

.top-area {
    display: flex;
    width: 100%;
    height: 100px;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1.5px solid #b1b0b0;
}

.top-left-area {
    display: flex;
    align-items: flex-end;
    flex: 1;
}

.top-left-area-title {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 5px;
    font-size: 16px;
    margin-left: 5px;
    letter-spacing: 0.6px;
}

.line-area {
    display: flex;
    margin-bottom: 6px;
    margin-left: 5px;
}

.top-left-area-date {
    display: flex;
    margin-bottom: 5px;
    margin-left: 5px;
    font-size: 11px;
}

.top-right-area {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    flex: 1;
}

.top-right-area-img {
    width: 101px;
    height: 25px;
    background: url("../../public/images/logo_image.png") no-repeat;
}

.title-head-area {
    display: flex;
    width: 100%;
    height: 140px;
    border-bottom: 1.5px solid #b1b0b0;
}

.title-head-left {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 125px;
}

.title-head-company-name {
    text-align: left;
    font-size: 45px;
    line-height: 2.5;
    font-weight: 600;
    width: 100%;
    height: 80px;
}

.title-head-date {
    width: 100%;
    height: 45px;
    text-align: left;
    line-height: 2.5;
    font-size: 17px;
}

.content-main1-area {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 480px;
    border-bottom: 1.5px solid #b1b0b0;
}

.content-main1-left {
    display: flex;
    flex-direction: column;
    width: 33%;
    height: 480px;
}

.content-main1-right {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    width: 64.5%;
    height: 480px;
}

.content-desc-text {
    font-size: 14px;
    text-align: left;
    line-height: 2;
    letter-spacing: 1px;
    word-break: normal;
    text-align: justify;
}

.content-left-box-area {
    flex: 1;
    width: 100%;
    height: 40%;
}

.content-left-box-area:first-child {
    flex: 1;
    width: 100%;
    height: 55%;
    border-bottom: 1.5px solid #b1b0b0;
}

.content-left-top-area {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 50px;
    border-bottom: 1.5px solid #d8d8d8;
}

.content-left-top-area3 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 50px;
    // border-bottom: 1.5px solid #d8d8d8;
    border-top: 1.5px solid #d8d8d8;
}

.zjl-area {
    display: flex;
    height: 370px;
    width: 100%;
    // background-color: #7F7F7F;
}

.zjl-left-area {
    display: flex;
    flex-direction: column;
    width: 30%;
    height: 100%;
    // background-color: #31589F;
    border-top: 1.5px solid #d8d8d8;
}

.zjl-right-area {
    display: flex;
    width: 70%;
    height: 100%;
    justify-content: flex-end;
    // background-color: #a9d7ff;
}

.zjl-right-box {
    display: flex;
    flex-direction: column;
    width: 95%;
    height: 100%;
    // background-color: #b1b0b0;
    border-top: 1.5px solid #d8d8d8;
}

.zjl-content-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 170px;
}

.content-left-bottom-area1 {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 170px;
}

.content-left-bottom-area2 {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 176px;
}

.desc-text {
    flex: 2.4;
    width: 35%;
    height: 40px;
    font-size: 20px;
    text-align: left;
    line-height: 2.2;
}

.desc-text1 {
    flex: 2.9;
    width: 35%;
    height: 40px;
    font-size: 20px;
    text-align: left;
    line-height: 2.2;
}

.desc-text3 {
    flex: 11;
    width: 35%;
    height: 40px;
    font-size: 20px;
    text-align: left;
    line-height: 2.2;
}

.desc-text4 {
    flex: 13;
    width: 35%;
    height: 40px;
    font-size: 20px;
    text-align: left;
    line-height: 2.2;
}

.desc-text5 {
    flex: 13;
    width: 35%;
    height: 40px;
    font-size: 20px;
    text-align: left;
    line-height: 2.2;
}

.desc-text6 {
    flex: 11;
    width: 35%;
    height: 40px;
    font-size: 20px;
    text-align: left;
    line-height: 2.2;
}

.desc-text7 {
    flex: 11;
    width: 35%;
    height: 40px;
    font-size: 20px;
    text-align: left;
    line-height: 2.2;
}

.content-left-bottom1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    flex: 3;
    /* background-color: rgb(127, 202, 202); */
}

.content-left-bottom2 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-around;
    flex: 1;
    /* background-color: rgb(177, 243, 171); */
}

.content-left-bottom3 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-around;
    flex: 1;
    /* background-color: rgb(189, 199, 255); */
}

.left-bottom-area1 {
    flex: 0.8;
    text-align: end;
    font-size: 14px;
    font-weight: 600;
    line-height: 2.2;
    width: 100%;
    height: 20px;
    /* background-color: rgb(165, 253, 253); */
}

.left-bottom-area2 {
    display: flex;
    flex: 0.5;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;
    /* background-color: darkkhaki; */
}

.left-bottom-area33 {
    display: flex;
    flex: 1;
    width: 86%;
    height: 100%;
    align-self: flex-start;
    /* background-color: rgb(153, 231, 255); */
}

.left-bottom-area33-box {
    display: flex;
    // flex: 1;
    width: 68%;
    height: 100%;
    flex-direction: column;
    align-self: flex-start;
}

.left-bottom-area33-box1 {
    display: flex;
    width: 100%;
    height: 74%;
    align-items: flex-end;
    border-bottom: 2px solid #b1b0b0;
}

.left-bottom-area33-box2 {
    display: flex;
    width: 100%;
    height: 26%;
}

.left-bottom-area3 {
    display: flex;
    flex: 6.5;
    width: 86%;
    height: 110px;
    align-self: flex-end;
    /* background-color: rgb(153, 231, 255); */
}

.star-area {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 2;
    width: 100%;
    height: 30px;
    background-color: rgb(255 255 255);
}

.start-box {
    color: #fff;
    font-size: 24px;
    text-align: center;
    width: 18px;
    height: 18px;
    line-height: 200px;
    background: #000000;
    /* 绘制路径 */
    clip-path: polygon(50% 0, 65% 40%, 100% 40%, 72% 60%, 85% 100%, 50% 75%, 15% 100%, 28% 60%, 0 40%, 35% 40%);
}

.start-mark {
    color: #fff;
    font-size: 24px;
    text-align: center;
    width: 18px;
    height: 18px;
    line-height: 200px;
    /* background: #c9c9c9; */
    /* 绘制路径 */
    clip-path: polygon(50% 0, 65% 40%, 100% 40%, 72% 60%, 85% 100%, 50% 75%, 15% 100%, 28% 60%, 0 40%, 35% 40%);
}

.start-space {
    width: 18px;
    height: 18px;
}

.star-img {
    width: 100%;
    height: 100%;
    background: url("../../public/images/star5.png") no-repeat;
}

/* .start-mark5 {
        color: #fff;
        font-size: 24px;
        text-align: center;
        width: 17px;
        height: 17px;
        line-height: 200px;
        background: #c9c9c9;
        clip-path:polygon(50% 0,65% 40%, 100% 40%,72% 60%,85% 100%,50% 75%,15% 100%,28% 60%,0 40%,35% 40%);
    } */
.start-mark5 {
    width: 14%;
    height: 60%;
    background: url("../../public/images/star7.png") no-repeat;
}

.star-img5 {
    /* width: 50%; */
    height: 100%;
    margin-left: 2px;
    background: url("../../public/images/star5.png") no-repeat;
}

.bottom-box1 {
    display: flex;
    flex-direction: column;
    flex: 2;
    width: 100%;
    height: 100%;
    /* background-color: rgb(253, 228, 191); */
}

.bottom-space {
    flex: 0.5;
}

.box-top {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    flex: 3;
    width: 100%;
    /* height: 70px; */
    /* background-color: cadetblue; */
}

.black-box-area {
    display: flex;
    flex-direction: column-reverse;
    margin: 0 auto;
    width: 100%;
    height: 100%;
}

.black-box1 {
    margin: 0 auto;
    width: 100%;
    /* height: 20%; */
    background-color: #333333;
}

.black-box2 {
    margin: 0 auto;
    width: 100%;
    /* height: 20%; */
    background-color: #333333;
}

.black-box3 {
    margin: 0 auto;
    width: 100%;
    /* height: 30%; */
    background-color: #333333;
}

.black-box4 {
    margin: 0 auto;
    width: 100%;
    /* height: 85%; */
    background-color: #333333;
}

.black-box5 {
    margin: 0 auto;
    width: 100%;
    /* height: 50%; */
    background-color: #333333;
}

.black-null {
    margin: 0 auto;
    width: 100%;
    height: 100%;
    border: 0.5px solid #d1cfcf;
}

.box-bottom5 {
    display: flex;
    flex: 0.1;
    justify-content: center;
    align-items: flex-end;
    width: 49px;
}

.box-bottom4 {
    display: flex;
    flex: 0.1;
    justify-content: center;
    align-items: flex-end;
    width: 49px;
    /* height: 30px; */
    /* background-color: coral; */
}

.box-bottom3 {
    display: flex;
    flex: 0.1;
    justify-content: center;
    align-items: flex-end;
    width: 49px;
    /* height: 30px; */
    /* background-color: coral; */
}

.box-bottom2 {
    display: flex;
    flex: 0.1;
    justify-content: center;
    align-items: flex-end;
    width: 49px;
    /* height: 30px; */
    /* background-color: coral; */
}

.box-bottom1 {
    display: flex;
    flex: 0.1;
    justify-content: center;
    align-items: flex-end;
    width: 49px;
    /* height: 30px; */
    /* background-color: coral; */
}

.box-bottom-num {
    display: flex;
    flex: 0.8;
    justify-content: center;
    align-items: flex-end;
    width: 110%;
}

.star5 {
    width: 100%;
    height: 14px;
    background: url("../../public/images/smallstar5.gif") no-repeat;
}

.star4 {
    width: 80%;
    height: 14px;
    background: url("../../public/images/smallstar4.gif") no-repeat;
}

.star3 {
    width: 60%;
    height: 14px;
    background: url("../../public/images/smallstar3.gif") no-repeat;
}

.star2 {
    width: 40%;
    height: 14px;
    background: url("../../public/images/smallstar2.gif") no-repeat;
}

.star1 {
    width: 20%;
    height: 14px;
    background: url("../../public/images/smallstar1.gif") no-repeat;
}

.content-main2-area {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 590px;
    // border-bottom: 1.5px solid #b1b0b0;
    /* background-color: rgb(255, 199, 179); */
}

.content-main6-area {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 1215px;
    // border-bottom: 1.5px solid #b1b0b0;
}

.content-main2-left {
    display: flex;
    flex-direction: column;
    width: 33%;
    height: 560px;
    /* background-color: rgb(128, 207, 253); */
}

.content-left-box1-area {
    flex: 1;
    width: 100%;
    height: 50%;
    /* background-color: rgb(253, 224, 188); */
}

.content-left-bottom-area3 {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 120px;
    /* background-color: rgb(245, 148, 167); */
}

.left-box-area {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 85%;
    font-size: 14px;
    font-weight: 550;
    /* background-color: chartreuse; */
}

.left-text1 {
    flex: 1;
    display: flex;
    align-self: end;
    align-items: center;
}

.left-text2 {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 545;
    font-size: 16px;
}

.content-left-bottom-area4 {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 205px;
    /* background-color: rgb(245, 148, 167); */
}

.content-left-bottom-area5 {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90px;
    /* background-color: rgb(245, 148, 167); */
}

.content-main2-right {
    display: flex;
    flex-direction: column;
    width: 55%;
    height: 570px;
    /* background-color: rgb(222, 149, 255); */
}

.content-main6-right {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 1200px;
    /* background-color: rgb(222, 149, 255); */
}

.box-right1 {
    width: 100%;
    height: 223px;
    border-bottom: 1.5px solid #b1b0b0;
    /* background-color: rgb(255, 149, 110); */
}

.box-right2 {
    display: flex;
    width: 100%;
    // height: 180px;
    border-bottom: 1.5px solid #b1b0b0;
    /* background-color: rgb(194, 255, 137); */
}

.xc-area {
    display: flex;
    height: 100%;
    flex: 1;
}

.xc-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    // background-color: #1f94eb;
}

.cg-area {
    display: flex;
    height: 100%;
    justify-content: flex-end;
    flex: 1;
}

.cg-box {
    display: flex;
    flex-direction: column;
    width: 94%;
    height: 100%;
    // background-color: #960000;
}

.xc-top-box {
    display: flex;
    height: 60px;
    // border-bottom: 1.5px solid #b1b0b0;
}

.top-left {
    display: flex;
    align-items: center;
    height: 100%;
    width: 15%;
}

.top-right {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
}

.xc-bottom-box {
    display: flex;
    flex-direction: column;
    height: 170px;
}

.bottom-row {
    display: flex;
    flex: 1;
}

.box-right6 {
    width: 100%;
    height: 172px;
    // border-bottom: 1.5px solid #b1b0b0;
    /* background-color: rgb(194, 255, 137); */
}

.box-right3 {
    width: 100%;
    height: 125px;
    // border-bottom: 1.5px solid #b1b0b0;
    /* background-color: rgb(194, 255, 137); */
}

.content-area {
    display: flex;
    height: 75px;
    // flex-direction: column;
}

.fl-content-area1 {
    display: flex;
    height: 100%;
    flex: 1;
    flex-direction: column;
}

.fl-content-area2 {
    display: flex;
    height: 100%;
    flex: 1;
    align-items: flex-end;
    flex-direction: column;
}

.fl-content-title {
    display: flex;
    flex: 1;
    align-items: center;
    font-size: 13px;
}

.fl-content-data {
    display: flex;
    flex: 1;
    font-size: 14px;
    align-items: center;
}

.content-left-top-area1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // margin-left: 15px;
    width: 100%;
    height: 50px;
    border-bottom: 1.5px solid #d8d8d8;
    /* background-color: cadetblue; */
}

.content-left-top-area2 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // margin-left: 15px;
    width: 100%;
    height: 50px;
    // border-top: 1.5px solid #d8d8d8;
    border-bottom: 1.5px solid #d8d8d8;
    /* background-color: cadetblue; */
}

.cpx-content-area {
    display: flex;
    height: 270px;
    width: 100%;
}

.cpx-left-area {
    display: flex;
    height: 100%;
    width: 40%;
    flex-direction: column;
    // background-color: #7F7F7F;
}

.cpx-left-area2 {
    display: flex;
    height: 158px;
    width: 40%;
    flex-direction: column;
    // background-color: #7F7F7F;
}

.cpx-left-top-area {
    display: flex;
    height: 240px;
    width: 100%;
}

.cpx-left-bottom-area {
    display: flex;
    height: 35px;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
}

.cpx-right-area {
    display: flex;
    height: 200px;
    width: 60%;
    flex-direction: column;
    // align-self: flex-start;
    // background-color: #b18585;
}

.cpx-right-area2 {
    display: flex;
    height: 158px;
    width: 60%;
    flex-direction: column;
    // align-self: flex-start;
    // background-color: #b18585;
}

.cpx-data-row {
    display: flex;
    height: 40px;
    width: 100%;
    justify-content: flex-end;
}

.cpx-data-row2 {
    display: flex;
    height: 35px;
    width: 100%;
    justify-content: flex-end;
}

.cpx-row {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}

.content-big-box1 {
    display: flex;
    width: 100%;
    height: 180px;
    /* background-color: rgb(248, 255, 153); */
}

.content-big-gm {
    display: flex;
    width: 100%;
    height: 170px;
}

.gm-area1 {
    display: flex;
    flex: 1;
    justify-content: flex-start;
}

.gm-area2 {
    display: flex;
    flex: 1;
    justify-content: center;
}

.gm-area3 {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}

.gm-box {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
}

.gm-left-title {
    display: flex;
    width: 100%;
    height: 30px;
    justify-content: flex-end;
    align-items: flex-end;
    font-size: 13px;
    font-weight: 550;
}

.gm-row {
    display: flex;
    width: 100%;
    height: 32px;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
}

.gm-row2 {
    display: flex;
    width: 100%;
    height: 50px;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
    color: black;
}

.gm-row3 {
    display: flex;
    width: 100%;
    height: 32px;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
}

.content-bottom-area {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 88%;
    // margin-left: 18px;
    /* background-color: rgb(171, 253, 154); */
}

.top-box-area1 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 550;
    flex: 1;
    width: 100%;
}

.top-box-area2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    flex: 1;
    width: 100%;
}

.num-mark-area {
    display: flex;
    width: 100%;
    height: 16px;
    align-items: center;
    justify-content: flex-end;
    // background-color: #31589F;
}

.num-area {
    display: flex;
    width: 236px;
    height: 100%;
    // background-color: #7F7F7F;
}

.num-box1 {
    display: flex;
    width: 110px;
    height: 100%;
    // flex: 1;
}

.num-box2 {
    display: flex;
    width: 110px;
    height: 100%;
    // flex: 1;
}

.num-box3 {
    display: flex;
    width: 110px;
    height: 100%;
    // flex: 1;
}

.num-box4 {
    display: flex;
    width: 110px;
    height: 100%;
    // flex: 1;
}

.num-box5 {
    display: flex;
    width: 110px;
    height: 100%;
    // flex: 1;
}

.num-box6 {
    display: flex;
    width: 15px;
    height: 100%;
    justify-content: flex-end;
    // flex: 1;
}

.top-process-area {
    display: flex;
    position: relative;
    flex: 1.75;
    align-items: center;
    width: 100%;
    height: 35px;

    .every-box {
        display: flex;
        flex: 1;
        width: 100%;
        height: 100%;
        // border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
    }

    .top-size-area {
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 100px;
        height: 30px;
        margin-left: 0px; //max: 200px
        margin-bottom: 12px;

        // background-color: #DEE6F2;
        // border-radius: 100px;
        .top-size-box1 {
            display: flex;
            width: 100%;
            height: 14px;
            font-size: 13px;
        }

        .top-size-box2 {
            display: flex;
            // width: 100%;
            height: 18px;
            margin-top: 1px;
            background-color: #DEE6F2;
            border-radius: 100px;
            border: 1px solid #DBDCDE;

            .middle-num-box {
                display: flex;
                height: 48%;
                width: 2px;
                z-index: 999;
                position: absolute;
                // margin-left: 0px;
                background-color: #000000;
            }

            .score-num-box {
                display: flex;
                position: absolute;
                height: 50%;
                width: 16px;
                // margin-left: 0px;
                border-radius: 50%;
                background-color: #1F55A5;
            }
        }
    }
}

.process-class {
    display: flex;
    width: 100%;
    border: 0.5px solid #d1cfcf;
}

.process-item1 {
    /* width: 40%; */
    background-color: #025aa7;
}

.process-item2 {
    /* width: 85%; */
    background-color: #025aa7;
}

.process-item3 {
    /* width: 20%; */
    background-color: #025aa7;
}

.content-big-box2 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 295px;
    /* background-color: rgb(248, 255, 153); */
}

.five-row-area {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 70%;
    margin-top: 5px;
    margin-right: 5px;
    /* background-color: rgb(203, 252, 189); */
}

.row-div1 {
    flex: 1;
    display: flex;
    font-size: 14px;
    font-weight: 550;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 30px;
    /* background-color: rgb(252, 143, 237); */
}

.row-div {
    display: flex;
    flex: 1;
    width: 100%;
    height: 30px;
    font-weight: 550;
    /* background-color: rgb(255, 168, 127); */
}

.circle-div {
    display: flex;
    flex: 1.5;
    justify-content: flex-start;
    align-items: center;
    margin-right: 10px;
    /* background-color: rgb(249, 253, 190); */
}

.circle-div6 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 8px;
}

.text-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    flex: 11;
    border-bottom: 1.5px solid #d8d8d8;
    /* background-color: rgb(253, 123, 123); */
}

.process-circle-big1 {
    width: 12px;
    height: 12px;
    bottom: -3px;
    background-color: #960000;
    border-radius: 50%;
    position: relative;
}

.process-circle-big2 {
    width: 12px;
    height: 12px;
    bottom: -3px;
    background-color: #EC7524;
    border-radius: 50%;
    position: relative;
}

.process-circle-big3 {
    width: 12px;
    height: 12px;
    bottom: -3px;
    background-color: #31589F;
    border-radius: 50%;
    position: relative;
}

.process-circle-big4 {
    width: 12px;
    height: 12px;
    bottom: -3px;
    background-color: #FFC50D;
    border-radius: 50%;
    position: relative;
}

.process-circle-big5 {
    width: 12px;
    height: 12px;
    bottom: -3px;
    background-color: #7F7F7F;
    border-radius: 50%;
    position: relative;
}

.process-circle-big22 {
    width: 12px;
    height: 12px;
    bottom: -3px;
    margin-top: 4px;
    background-color: #EC7524;
    border-radius: 50%;
}

.process-circle-big33 {
    width: 12px;
    height: 12px;
    bottom: -3px;
    margin-top: 4px;
    background-color: #31589F;
    border-radius: 50%;
}

/* .text-div:last-child {
          border-bottom: 0;
      } */
.process-circle-small {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    margin-left: 4px;
    margin-top: 4px;
    background-color: #ffffff;
    position: absolute;
    /* top: 5px; */
}

.process-circle-small6 {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    margin-left: 4px;
    margin-top: 4px;
    background-color: #ffffff;
    position: relative;
}

.content-main3-area {
    // display: flex;
    // flex-direction: column;
    // align-items: flex-start;
    // width: 100%;
    // height: 100px;
    // margin-top: 10px;
    padding: 10px 0px 0px 0px;
    border-top: 1.5px solid #b1b0b0;
    display: flex;
    position: absolute;
    bottom: 0;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 85px;
    margin-top: 10px;
}

.bottom1-area {
    text-align: left;
}

.bottom2-area {
    text-align: left;
}



.demo-area {
    display: flex;
    flex: 15;
}

.button-flex {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-top: 350px;
}

.button-area1 {
    display: flex;
    align-items: flex-end;
    // flex: 0.3;
}

.button-area2 {
    display: flex;
    flex: 1;
}

.button-box1 {
    display: flex;
    justify-content: space-evenly;
    cursor: pointer;
    user-select: none;
    height: 60px;
    width: 60px;
    background-color: rgb(255 255 255);
    border: 2px solid #a9d7ff;
    color: #1f94eb;
    line-height: 64px;
    text-align: center;
    font-size: 20px;
    border-radius: 50px;
    font-weight: bold;
    letter-spacing: 2px;
    position: fixed;
}

.button-box1:hover {
    transition: 0.5s;
    transform: translateY(-10px);
    box-shadow: 0px 0px 50px rgb(117, 204, 255);
}

.button-box1:hover span {
    display: inline-block;
    animation: move 0.6s linear 0.2s infinite;
}

@keyframes move {
    from {
        transform: translateX(-8px);
    }

    to {
        transform: translateX(5px);
    }
}

.button-box2 {
    display: flex;
    justify-content: space-evenly;
    cursor: pointer;
    user-select: none;
    height: 60px;
    width: 60px;
    background-color: rgb(255 255 255);
    border: 2px solid #a9d7ff;
    color: #1f94eb;
    line-height: 64px;
    text-align: center;
    font-size: 20px;
    border-radius: 50px;
    font-weight: bold;
    letter-spacing: 2px;
    position: fixed;
}

.button-box2:hover {
    transition: 0.5s;
    transform: translateY(10px);
    box-shadow: 0px 0px 50px rgb(117, 204, 255);
}

.button-box2:hover span {
    display: inline-block;
    animation: move 0.6s linear 0.2s infinite;
}

@keyframes move {
    from {
        transform: translateX(-8px);
    }

    to {
        transform: translateX(5px);
    }
}

.companyStarClass {
    height: 22px;
    width: 21px;

    &>svg {
        width: 60px;
        height: 21px;
    }
}

.companyStarMarkClass {
    height: 23px;
    width: 21px;

    &>svg {
        width: 60px;
        height: 21px;
    }
}

.companyStarWhiteClass {
    height: 23px;
    width: 21px;

    &>svg {
        width: 60px;
        height: 21px;
    }
}

.companyStarClass2 {
    height: 23px;
    width: 21px;

    &>svg {
        width: 60px;
        height: 21px;
    }
}

.companyStarClass4 {
    height: 23px;
    width: 21px;

    &>svg {
        width: 60px;
        height: 21px;
    }
}

.levelImgClass {
    display: flex;
    justify-content: flex-start;
    flex: 1;
    height: 46px;
    width: 18px;

    &>svg {
        width: 80px;
        height: 49px;
    }
}

.teamImgClass {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    height: 46px;
    width: 18px;

    &>svg {
        width: 70px;
        height: 60px;
    }
}

.gmImgClass {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    height: 46px;
    width: 18px;

    &>svg {
        width: 38px;
        height: 36px;
    }
}

.zjlImgClass {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    height: 46px;
    width: 18px;

    &>svg {
        width: 53px;
        height: 50px;
    }
}

.flImgClass {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    height: 46px;
    width: 18px;

    &>svg {
        width: 52px;
        height: 50px;
    }
}

.yjpfImgClass {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    height: 46px;
    width: 18px;

    &>svg {
        width: 52px;
        height: 52px;
    }
}

.cpxImgClass {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    height: 46px;
    width: 18px;

    &>svg {
        width: 52px;
        height: 50px;
    }
}

.process-flex {
    display: flex;
    flex: 8;
}

.text-flex {
    display: flex;
    justify-content: center;
    flex: 2;
}

.every-box:first-child {
    border-left: 1px solid #e5e5e5;
}

.box-right6 {
    display: flex;
    height: 172px;
    flex-direction: column;
}

.box-right12 {
    display: flex;
    height: 125px;
    flex-direction: column;
}

.box-right7 {
    display: flex;
    height: 400px;
    flex-direction: column;
    border-bottom: 1.5px solid #d8d8d8;
}

.box-right8 {
    width: 100%;
    height: 230px;
    border-bottom: 1.5px solid #b1b0b0;
    /* background-color: rgb(255, 149, 110); */
}

.box-right9 {
    width: 100%;
    height: auto;
    // height: 170px;
    // background-color: #7F7F7F;
    // border-bottom: 1.5px solid #b1b0b0;
}

.content-left-top-area9 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 50px;
    border-bottom: 1.5px solid #d8d8d8;
    // border-top: 1.5px solid #d8d8d8;
}

.cpct-area {
    display: flex;
    height: auto;
    min-height: 110px;
    width: 100%;
    flex-direction: column;
}

.box-right10 {
    display: flex;
    width: 100%;
    height: 200px;
    flex-direction: column;
    // background-color: #7F7F7F;
    // border-bottom: 1.5px solid #b1b0b0;
}

.cpct-area2 {
    display: flex;
    // height: 150px;
    height: auto;
    // min-height: 110px;
    width: 100%;
    flex-direction: column;
    // border-bottom: 1.5px solid #b1b0b0;
}

.cpct-area3 {
    display: flex;
    height: 70px;
    width: 100%;
    flex-direction: column;
    // border-bottom: 1.5px solid #b1b0b0;
    border-top: 1.5px solid #b1b0b0;
}

// .cpct-area33 {
//     display: flex;
//     height: 70px;
//     width: 100%;
//     flex-direction: column;
//     // border-bottom: 1.5px solid #b1b0b0;
//     border-top: 1.5px solid #b1b0b0;
// }

.cpct-area4 {
    display: flex;
    height: 790px;
    width: 100%;
    flex-direction: column;
    border-bottom: 1.5px solid #b1b0b0;
}

.cpct-area66 {
    display: flex;
    height: auto;
    width: 100%;
    flex-direction: column;
    border-top: 1.5px solid #b1b0b0;
}

.cpct-area6 {
    display: flex;
    height: auto;
    width: 100%;
    flex-direction: column;
    border-top: 1.5px solid #b1b0b0;
    // border-bottom: 1.5px solid #b1b0b0;
}

.cpct-box3 {
    display: flex;
    // flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    // background-color: #7F7F7F;
}

.null-node-area {
    display: flex;
    justify-content: flex-start;
    font-size: 16px;
    color: #ABABAB;
    margin-bottom: 20px;
}

.cpct-area7 {
    display: flex;
    height: auto;
    // min-height: 30px;
    // padding: 14px 0px;
    width: 100%;
    flex-direction: column;
}

.page-limit-area {
    display: flex;
    flex-direction: column;
    height: auto;
    max-height: 1220px;
}

.flag-height-class {
    height: auto;
}

.content-main3-left-area {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    width: 45%;
    height: 570px;
}

.content-main3-left-box {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    width: 96%;
    height: 570px;
}

.box-left1 {
    display: flex;
    flex-direction: column;
    width: 100%;
    // height: 465px;
    border-bottom: 1.5px solid #b1b0b0;
}

.box-left1-top-area {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 275px;
    // border-bottom: 1.5px solid #b1b0b0;
}

.box-left1-bottom-area {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 260px;
    // border-bottom: 1.5px solid #b1b0b0;
}

.box-left6 {
    display: flex;
    width: 100%;
    height: 110px;
    flex-direction: column;
    // border-bottom: 1.5px solid #b1b0b0;
}

.fixed-header {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 78px;
}

.fund-start-marker {
    width: 100%;
    height: 0;
}

.fund-measure-container {
    position: fixed;
    top: 0;
    left: -100000px;
    visibility: hidden;
    pointer-events: none;
    width: 915px;
}

.fund-content-row,
.fund-standard-row,
.fund-mini-row {
    min-height: 32px;
    height: auto;
}

.fund-content-row > span,
.fund-standard-row > span,
.fund-mini-row > span {
    min-width: 0;
    overflow-wrap: anywhere;
}

.fund-standard-row > span {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    text-align: left;
}

.fund-standard-row > span:nth-child(1) { flex: 1; justify-content: flex-start; }
.fund-standard-row > span:nth-child(2) { flex: 4; justify-content: flex-start; padding-left: 10px; }
.fund-standard-row > span:nth-child(3) { flex: 2; justify-content: flex-start; padding-left: 10px; }
.fund-standard-row > span:nth-child(4) { flex: 2; justify-content: flex-start; padding-left: 10px; }
.fund-standard-row > span:nth-child(5) { flex: 2; justify-content: center; text-align: center; }
.fund-standard-row > span:nth-child(6) { flex: 1.5; justify-content: flex-end; text-align: right; }

.fund-mini-row > span {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    text-align: left;
}

.fund-mini-row > span:nth-child(1) { flex: 2.1; justify-content: flex-start; white-space: nowrap; }
.fund-mini-row > span:nth-child(2) { flex: 7; justify-content: flex-start; }
.fund-mini-row > span:nth-child(3) { flex: 3.5; justify-content: flex-start; padding-left: 5px; }
.fund-mini-row > span:nth-child(4) { flex: 3.8; justify-content: flex-start; padding-left: 10px; }
.fund-mini-row > span:nth-child(5) { flex: 2.5; justify-content: flex-end; padding-right: 19px; text-align: right; }
.fund-mini-row > span:nth-child(6) { flex: 1.5; justify-content: flex-end; text-align: right; }
.fund-mini-row > span:nth-child(7) { flex: 2; justify-content: flex-end; text-align: right; }

.fund-section-title {
    display: flex;
    width: 100%;
    height: 22px;
    padding: 6px 0;
    margin-top: 10px;
    box-sizing: content-box;
    align-items: center;
    color: #1e1e1e;
    font-size: 16px;
    font-weight: 550;
}

.fund-table-header {
    color: #1e1e1e;
    font-size: 13px;
    font-weight: 550;
}

.fund-dynamic-section {
    display: flex;
    width: 100%;
    flex-direction: column;
}

.fund-dynamic-section--bordered {
    border-top: 1.5px solid #b1b0b0;
}

.fund-dynamic-section--has-data {
    margin-bottom: 10px;
}
</style>